const seatsData=[
    {
        "id": "VIP1-01-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场VIP1 01排 01座"
    },
    {
        "id": "VIP1-01-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场VIP1 01排 02座"
    },
    {
        "id": "VIP1-01-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场VIP1 01排 03座"
    },
    {
        "id": "VIP1-01-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场VIP1 01排 04座"
    },
    {
        "id": "VIP1-01-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场VIP1 01排 05座"
    },
    {
        "id": "VIP1-01-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场VIP1 01排 06座"
    },
    {
        "id": "VIP1-01-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场VIP1 01排 07座"
    },
    {
        "id": "VIP1-01-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场VIP1 01排 08座"
    },
    {
        "id": "VIP1-01-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场VIP1 01排 09座"
    },
    {
        "id": "VIP1-01-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场VIP1 01排 10座"
    },
    {
        "id": "VIP1-01-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场VIP1 01排 11座"
    },
    {
        "id": "VIP1-01-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场VIP1 01排 12座"
    },
    {
        "id": "VIP1-01-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场VIP1 01排 13座"
    },
    {
        "id": "VIP1-01-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场VIP1 01排 14座"
    },
    {
        "id": "VIP1-01-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场VIP1 01排 15座"
    },
    {
        "id": "VIP1-02-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场VIP1 02排 01座"
    },
    {
        "id": "VIP1-02-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场VIP1 02排 02座"
    },
    {
        "id": "VIP1-02-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场VIP1 02排 03座"
    },
    {
        "id": "VIP1-02-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场VIP1 02排 04座"
    },
    {
        "id": "VIP1-02-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场VIP1 02排 05座"
    },
    {
        "id": "VIP1-02-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场VIP1 02排 06座"
    },
    {
        "id": "VIP1-02-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场VIP1 02排 07座"
    },
    {
        "id": "VIP1-02-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场VIP1 02排 08座"
    },
    {
        "id": "VIP1-02-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场VIP1 02排 09座"
    },
    {
        "id": "VIP1-02-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场VIP1 02排 10座"
    },
    {
        "id": "VIP1-02-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场VIP1 02排 11座"
    },
    {
        "id": "VIP1-02-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场VIP1 02排 12座"
    },
    {
        "id": "VIP1-02-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场VIP1 02排 13座"
    },
    {
        "id": "VIP1-02-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场VIP1 02排 14座"
    },
    {
        "id": "VIP1-02-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场VIP1 02排 15座"
    },
    {
        "id": "VIP1-03-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场VIP1 03排 01座"
    },
    {
        "id": "VIP1-03-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场VIP1 03排 02座"
    },
    {
        "id": "VIP1-03-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场VIP1 03排 03座"
    },
    {
        "id": "VIP1-03-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场VIP1 03排 04座"
    },
    {
        "id": "VIP1-03-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场VIP1 03排 05座"
    },
    {
        "id": "VIP1-03-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场VIP1 03排 06座"
    },
    {
        "id": "VIP1-03-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场VIP1 03排 07座"
    },
    {
        "id": "VIP1-03-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场VIP1 03排 08座"
    },
    {
        "id": "VIP1-03-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场VIP1 03排 09座"
    },
    {
        "id": "VIP1-03-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场VIP1 03排 10座"
    },
    {
        "id": "VIP1-03-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场VIP1 03排 11座"
    },
    {
        "id": "VIP1-03-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场VIP1 03排 12座"
    },
    {
        "id": "VIP1-03-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场VIP1 03排 13座"
    },
    {
        "id": "VIP1-03-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场VIP1 03排 14座"
    },
    {
        "id": "VIP1-03-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场VIP1 03排 15座"
    },
    {
        "id": "VIP1-04-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场VIP1 04排 01座"
    },
    {
        "id": "VIP1-04-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场VIP1 04排 02座"
    },
    {
        "id": "VIP1-04-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场VIP1 04排 03座"
    },
    {
        "id": "VIP1-04-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场VIP1 04排 04座"
    },
    {
        "id": "VIP1-04-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场VIP1 04排 05座"
    },
    {
        "id": "VIP1-04-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场VIP1 04排 06座"
    },
    {
        "id": "VIP1-04-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场VIP1 04排 07座"
    },
    {
        "id": "VIP1-04-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场VIP1 04排 08座"
    },
    {
        "id": "VIP1-04-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场VIP1 04排 09座"
    },
    {
        "id": "VIP1-04-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场VIP1 04排 10座"
    },
    {
        "id": "VIP1-04-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场VIP1 04排 11座"
    },
    {
        "id": "VIP1-04-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场VIP1 04排 12座"
    },
    {
        "id": "VIP1-04-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场VIP1 04排 13座"
    },
    {
        "id": "VIP1-04-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场VIP1 04排 14座"
    },
    {
        "id": "VIP1-04-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场VIP1 04排 15座"
    },
    {
        "id": "VIP1-05-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场VIP1 05排 01座"
    },
    {
        "id": "VIP1-05-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场VIP1 05排 02座"
    },
    {
        "id": "VIP1-05-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场VIP1 05排 03座"
    },
    {
        "id": "VIP1-05-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场VIP1 05排 04座"
    },
    {
        "id": "VIP1-05-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场VIP1 05排 05座"
    },
    {
        "id": "VIP1-05-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场VIP1 05排 06座"
    },
    {
        "id": "VIP1-05-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场VIP1 05排 07座"
    },
    {
        "id": "VIP1-05-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场VIP1 05排 08座"
    },
    {
        "id": "VIP1-05-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场VIP1 05排 09座"
    },
    {
        "id": "VIP1-05-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场VIP1 05排 10座"
    },
    {
        "id": "VIP1-05-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场VIP1 05排 11座"
    },
    {
        "id": "VIP1-05-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场VIP1 05排 12座"
    },
    {
        "id": "VIP1-05-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场VIP1 05排 13座"
    },
    {
        "id": "VIP1-05-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场VIP1 05排 14座"
    },
    {
        "id": "VIP1-05-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场VIP1 05排 15座"
    },
    {
        "id": "VIP1-06-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场VIP1 06排 01座"
    },
    {
        "id": "VIP1-06-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场VIP1 06排 02座"
    },
    {
        "id": "VIP1-06-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场VIP1 06排 03座"
    },
    {
        "id": "VIP1-06-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场VIP1 06排 04座"
    },
    {
        "id": "VIP1-06-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场VIP1 06排 05座"
    },
    {
        "id": "VIP1-06-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场VIP1 06排 06座"
    },
    {
        "id": "VIP1-06-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场VIP1 06排 07座"
    },
    {
        "id": "VIP1-06-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场VIP1 06排 08座"
    },
    {
        "id": "VIP1-06-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场VIP1 06排 09座"
    },
    {
        "id": "VIP1-06-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场VIP1 06排 10座"
    },
    {
        "id": "VIP1-06-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场VIP1 06排 11座"
    },
    {
        "id": "VIP1-06-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场VIP1 06排 12座"
    },
    {
        "id": "VIP1-06-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场VIP1 06排 13座"
    },
    {
        "id": "VIP1-06-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场VIP1 06排 14座"
    },
    {
        "id": "VIP1-06-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场VIP1 06排 15座"
    },
    {
        "id": "VIP1-07-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场VIP1 07排 01座"
    },
    {
        "id": "VIP1-07-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场VIP1 07排 02座"
    },
    {
        "id": "VIP1-07-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场VIP1 07排 03座"
    },
    {
        "id": "VIP1-07-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场VIP1 07排 04座"
    },
    {
        "id": "VIP1-07-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场VIP1 07排 05座"
    },
    {
        "id": "VIP1-07-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场VIP1 07排 06座"
    },
    {
        "id": "VIP1-07-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场VIP1 07排 07座"
    },
    {
        "id": "VIP1-07-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场VIP1 07排 08座"
    },
    {
        "id": "VIP1-07-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场VIP1 07排 09座"
    },
    {
        "id": "VIP1-07-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场VIP1 07排 10座"
    },
    {
        "id": "VIP1-07-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场VIP1 07排 11座"
    },
    {
        "id": "VIP1-07-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场VIP1 07排 12座"
    },
    {
        "id": "VIP1-07-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场VIP1 07排 13座"
    },
    {
        "id": "VIP1-07-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场VIP1 07排 14座"
    },
    {
        "id": "VIP1-07-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场VIP1 07排 15座"
    },
    {
        "id": "VIP1-08-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场VIP1 08排 01座"
    },
    {
        "id": "VIP1-08-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场VIP1 08排 02座"
    },
    {
        "id": "VIP1-08-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场VIP1 08排 03座"
    },
    {
        "id": "VIP1-08-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场VIP1 08排 04座"
    },
    {
        "id": "VIP1-08-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场VIP1 08排 05座"
    },
    {
        "id": "VIP1-08-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场VIP1 08排 06座"
    },
    {
        "id": "VIP1-08-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场VIP1 08排 07座"
    },
    {
        "id": "VIP1-08-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场VIP1 08排 08座"
    },
    {
        "id": "VIP1-08-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场VIP1 08排 09座"
    },
    {
        "id": "VIP1-08-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场VIP1 08排 10座"
    },
    {
        "id": "VIP1-08-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场VIP1 08排 11座"
    },
    {
        "id": "VIP1-08-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场VIP1 08排 12座"
    },
    {
        "id": "VIP1-08-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场VIP1 08排 13座"
    },
    {
        "id": "VIP1-08-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场VIP1 08排 14座"
    },
    {
        "id": "VIP1-08-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场VIP1 08排 15座"
    },
    {
        "id": "VIP1-09-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场VIP1 09排 01座"
    },
    {
        "id": "VIP1-09-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场VIP1 09排 02座"
    },
    {
        "id": "VIP1-09-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场VIP1 09排 03座"
    },
    {
        "id": "VIP1-09-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场VIP1 09排 04座"
    },
    {
        "id": "VIP1-09-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场VIP1 09排 05座"
    },
    {
        "id": "VIP1-09-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场VIP1 09排 06座"
    },
    {
        "id": "VIP1-09-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场VIP1 09排 07座"
    },
    {
        "id": "VIP1-09-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场VIP1 09排 08座"
    },
    {
        "id": "VIP1-09-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场VIP1 09排 09座"
    },
    {
        "id": "VIP1-09-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场VIP1 09排 10座"
    },
    {
        "id": "VIP1-09-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场VIP1 09排 11座"
    },
    {
        "id": "VIP1-09-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场VIP1 09排 12座"
    },
    {
        "id": "VIP1-09-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场VIP1 09排 13座"
    },
    {
        "id": "VIP1-09-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场VIP1 09排 14座"
    },
    {
        "id": "VIP1-09-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场VIP1 09排 15座"
    },
    {
        "id": "VIP1-10-01",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场VIP1 10排 01座"
    },
    {
        "id": "VIP1-10-02",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场VIP1 10排 02座"
    },
    {
        "id": "VIP1-10-03",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场VIP1 10排 03座"
    },
    {
        "id": "VIP1-10-04",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场VIP1 10排 04座"
    },
    {
        "id": "VIP1-10-05",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场VIP1 10排 05座"
    },
    {
        "id": "VIP1-10-06",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场VIP1 10排 06座"
    },
    {
        "id": "VIP1-10-07",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场VIP1 10排 07座"
    },
    {
        "id": "VIP1-10-08",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场VIP1 10排 08座"
    },
    {
        "id": "VIP1-10-09",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场VIP1 10排 09座"
    },
    {
        "id": "VIP1-10-10",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场VIP1 10排 10座"
    },
    {
        "id": "VIP1-10-11",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场VIP1 10排 11座"
    },
    {
        "id": "VIP1-10-12",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场VIP1 10排 12座"
    },
    {
        "id": "VIP1-10-13",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场VIP1 10排 13座"
    },
    {
        "id": "VIP1-10-14",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场VIP1 10排 14座"
    },
    {
        "id": "VIP1-10-15",
        "areaType": "内场",
        "block": "VIP1",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场VIP1 10排 15座"
    },
    {
        "id": "VIP2-01-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场VIP2 01排 01座"
    },
    {
        "id": "VIP2-01-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场VIP2 01排 02座"
    },
    {
        "id": "VIP2-01-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场VIP2 01排 03座"
    },
    {
        "id": "VIP2-01-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场VIP2 01排 04座"
    },
    {
        "id": "VIP2-01-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场VIP2 01排 05座"
    },
    {
        "id": "VIP2-01-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场VIP2 01排 06座"
    },
    {
        "id": "VIP2-01-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场VIP2 01排 07座"
    },
    {
        "id": "VIP2-01-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场VIP2 01排 08座"
    },
    {
        "id": "VIP2-01-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场VIP2 01排 09座"
    },
    {
        "id": "VIP2-01-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场VIP2 01排 10座"
    },
    {
        "id": "VIP2-01-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场VIP2 01排 11座"
    },
    {
        "id": "VIP2-01-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场VIP2 01排 12座"
    },
    {
        "id": "VIP2-01-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场VIP2 01排 13座"
    },
    {
        "id": "VIP2-01-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场VIP2 01排 14座"
    },
    {
        "id": "VIP2-01-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场VIP2 01排 15座"
    },
    {
        "id": "VIP2-02-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场VIP2 02排 01座"
    },
    {
        "id": "VIP2-02-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场VIP2 02排 02座"
    },
    {
        "id": "VIP2-02-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场VIP2 02排 03座"
    },
    {
        "id": "VIP2-02-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场VIP2 02排 04座"
    },
    {
        "id": "VIP2-02-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场VIP2 02排 05座"
    },
    {
        "id": "VIP2-02-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场VIP2 02排 06座"
    },
    {
        "id": "VIP2-02-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场VIP2 02排 07座"
    },
    {
        "id": "VIP2-02-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场VIP2 02排 08座"
    },
    {
        "id": "VIP2-02-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场VIP2 02排 09座"
    },
    {
        "id": "VIP2-02-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场VIP2 02排 10座"
    },
    {
        "id": "VIP2-02-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场VIP2 02排 11座"
    },
    {
        "id": "VIP2-02-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场VIP2 02排 12座"
    },
    {
        "id": "VIP2-02-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场VIP2 02排 13座"
    },
    {
        "id": "VIP2-02-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场VIP2 02排 14座"
    },
    {
        "id": "VIP2-02-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场VIP2 02排 15座"
    },
    {
        "id": "VIP2-03-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场VIP2 03排 01座"
    },
    {
        "id": "VIP2-03-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场VIP2 03排 02座"
    },
    {
        "id": "VIP2-03-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场VIP2 03排 03座"
    },
    {
        "id": "VIP2-03-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场VIP2 03排 04座"
    },
    {
        "id": "VIP2-03-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场VIP2 03排 05座"
    },
    {
        "id": "VIP2-03-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场VIP2 03排 06座"
    },
    {
        "id": "VIP2-03-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场VIP2 03排 07座"
    },
    {
        "id": "VIP2-03-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场VIP2 03排 08座"
    },
    {
        "id": "VIP2-03-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场VIP2 03排 09座"
    },
    {
        "id": "VIP2-03-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场VIP2 03排 10座"
    },
    {
        "id": "VIP2-03-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场VIP2 03排 11座"
    },
    {
        "id": "VIP2-03-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场VIP2 03排 12座"
    },
    {
        "id": "VIP2-03-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场VIP2 03排 13座"
    },
    {
        "id": "VIP2-03-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场VIP2 03排 14座"
    },
    {
        "id": "VIP2-03-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场VIP2 03排 15座"
    },
    {
        "id": "VIP2-04-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场VIP2 04排 01座"
    },
    {
        "id": "VIP2-04-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场VIP2 04排 02座"
    },
    {
        "id": "VIP2-04-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场VIP2 04排 03座"
    },
    {
        "id": "VIP2-04-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场VIP2 04排 04座"
    },
    {
        "id": "VIP2-04-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场VIP2 04排 05座"
    },
    {
        "id": "VIP2-04-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场VIP2 04排 06座"
    },
    {
        "id": "VIP2-04-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场VIP2 04排 07座"
    },
    {
        "id": "VIP2-04-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场VIP2 04排 08座"
    },
    {
        "id": "VIP2-04-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场VIP2 04排 09座"
    },
    {
        "id": "VIP2-04-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场VIP2 04排 10座"
    },
    {
        "id": "VIP2-04-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场VIP2 04排 11座"
    },
    {
        "id": "VIP2-04-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场VIP2 04排 12座"
    },
    {
        "id": "VIP2-04-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场VIP2 04排 13座"
    },
    {
        "id": "VIP2-04-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场VIP2 04排 14座"
    },
    {
        "id": "VIP2-04-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场VIP2 04排 15座"
    },
    {
        "id": "VIP2-05-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场VIP2 05排 01座"
    },
    {
        "id": "VIP2-05-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场VIP2 05排 02座"
    },
    {
        "id": "VIP2-05-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场VIP2 05排 03座"
    },
    {
        "id": "VIP2-05-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场VIP2 05排 04座"
    },
    {
        "id": "VIP2-05-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场VIP2 05排 05座"
    },
    {
        "id": "VIP2-05-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场VIP2 05排 06座"
    },
    {
        "id": "VIP2-05-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场VIP2 05排 07座"
    },
    {
        "id": "VIP2-05-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场VIP2 05排 08座"
    },
    {
        "id": "VIP2-05-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场VIP2 05排 09座"
    },
    {
        "id": "VIP2-05-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场VIP2 05排 10座"
    },
    {
        "id": "VIP2-05-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场VIP2 05排 11座"
    },
    {
        "id": "VIP2-05-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场VIP2 05排 12座"
    },
    {
        "id": "VIP2-05-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场VIP2 05排 13座"
    },
    {
        "id": "VIP2-05-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场VIP2 05排 14座"
    },
    {
        "id": "VIP2-05-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场VIP2 05排 15座"
    },
    {
        "id": "VIP2-06-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场VIP2 06排 01座"
    },
    {
        "id": "VIP2-06-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场VIP2 06排 02座"
    },
    {
        "id": "VIP2-06-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场VIP2 06排 03座"
    },
    {
        "id": "VIP2-06-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场VIP2 06排 04座"
    },
    {
        "id": "VIP2-06-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场VIP2 06排 05座"
    },
    {
        "id": "VIP2-06-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场VIP2 06排 06座"
    },
    {
        "id": "VIP2-06-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场VIP2 06排 07座"
    },
    {
        "id": "VIP2-06-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场VIP2 06排 08座"
    },
    {
        "id": "VIP2-06-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场VIP2 06排 09座"
    },
    {
        "id": "VIP2-06-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场VIP2 06排 10座"
    },
    {
        "id": "VIP2-06-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场VIP2 06排 11座"
    },
    {
        "id": "VIP2-06-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场VIP2 06排 12座"
    },
    {
        "id": "VIP2-06-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场VIP2 06排 13座"
    },
    {
        "id": "VIP2-06-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场VIP2 06排 14座"
    },
    {
        "id": "VIP2-06-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场VIP2 06排 15座"
    },
    {
        "id": "VIP2-07-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场VIP2 07排 01座"
    },
    {
        "id": "VIP2-07-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场VIP2 07排 02座"
    },
    {
        "id": "VIP2-07-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场VIP2 07排 03座"
    },
    {
        "id": "VIP2-07-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场VIP2 07排 04座"
    },
    {
        "id": "VIP2-07-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场VIP2 07排 05座"
    },
    {
        "id": "VIP2-07-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场VIP2 07排 06座"
    },
    {
        "id": "VIP2-07-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场VIP2 07排 07座"
    },
    {
        "id": "VIP2-07-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场VIP2 07排 08座"
    },
    {
        "id": "VIP2-07-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场VIP2 07排 09座"
    },
    {
        "id": "VIP2-07-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场VIP2 07排 10座"
    },
    {
        "id": "VIP2-07-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场VIP2 07排 11座"
    },
    {
        "id": "VIP2-07-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场VIP2 07排 12座"
    },
    {
        "id": "VIP2-07-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场VIP2 07排 13座"
    },
    {
        "id": "VIP2-07-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场VIP2 07排 14座"
    },
    {
        "id": "VIP2-07-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场VIP2 07排 15座"
    },
    {
        "id": "VIP2-08-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场VIP2 08排 01座"
    },
    {
        "id": "VIP2-08-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场VIP2 08排 02座"
    },
    {
        "id": "VIP2-08-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场VIP2 08排 03座"
    },
    {
        "id": "VIP2-08-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场VIP2 08排 04座"
    },
    {
        "id": "VIP2-08-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场VIP2 08排 05座"
    },
    {
        "id": "VIP2-08-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场VIP2 08排 06座"
    },
    {
        "id": "VIP2-08-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场VIP2 08排 07座"
    },
    {
        "id": "VIP2-08-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场VIP2 08排 08座"
    },
    {
        "id": "VIP2-08-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场VIP2 08排 09座"
    },
    {
        "id": "VIP2-08-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场VIP2 08排 10座"
    },
    {
        "id": "VIP2-08-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场VIP2 08排 11座"
    },
    {
        "id": "VIP2-08-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场VIP2 08排 12座"
    },
    {
        "id": "VIP2-08-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场VIP2 08排 13座"
    },
    {
        "id": "VIP2-08-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场VIP2 08排 14座"
    },
    {
        "id": "VIP2-08-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场VIP2 08排 15座"
    },
    {
        "id": "VIP2-09-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场VIP2 09排 01座"
    },
    {
        "id": "VIP2-09-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场VIP2 09排 02座"
    },
    {
        "id": "VIP2-09-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场VIP2 09排 03座"
    },
    {
        "id": "VIP2-09-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场VIP2 09排 04座"
    },
    {
        "id": "VIP2-09-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场VIP2 09排 05座"
    },
    {
        "id": "VIP2-09-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场VIP2 09排 06座"
    },
    {
        "id": "VIP2-09-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场VIP2 09排 07座"
    },
    {
        "id": "VIP2-09-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场VIP2 09排 08座"
    },
    {
        "id": "VIP2-09-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场VIP2 09排 09座"
    },
    {
        "id": "VIP2-09-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场VIP2 09排 10座"
    },
    {
        "id": "VIP2-09-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场VIP2 09排 11座"
    },
    {
        "id": "VIP2-09-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场VIP2 09排 12座"
    },
    {
        "id": "VIP2-09-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场VIP2 09排 13座"
    },
    {
        "id": "VIP2-09-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场VIP2 09排 14座"
    },
    {
        "id": "VIP2-09-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场VIP2 09排 15座"
    },
    {
        "id": "VIP2-10-01",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场VIP2 10排 01座"
    },
    {
        "id": "VIP2-10-02",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场VIP2 10排 02座"
    },
    {
        "id": "VIP2-10-03",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场VIP2 10排 03座"
    },
    {
        "id": "VIP2-10-04",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场VIP2 10排 04座"
    },
    {
        "id": "VIP2-10-05",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场VIP2 10排 05座"
    },
    {
        "id": "VIP2-10-06",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场VIP2 10排 06座"
    },
    {
        "id": "VIP2-10-07",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场VIP2 10排 07座"
    },
    {
        "id": "VIP2-10-08",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场VIP2 10排 08座"
    },
    {
        "id": "VIP2-10-09",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场VIP2 10排 09座"
    },
    {
        "id": "VIP2-10-10",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场VIP2 10排 10座"
    },
    {
        "id": "VIP2-10-11",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场VIP2 10排 11座"
    },
    {
        "id": "VIP2-10-12",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场VIP2 10排 12座"
    },
    {
        "id": "VIP2-10-13",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场VIP2 10排 13座"
    },
    {
        "id": "VIP2-10-14",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场VIP2 10排 14座"
    },
    {
        "id": "VIP2-10-15",
        "areaType": "内场",
        "block": "VIP2",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场VIP2 10排 15座"
    },
    {
        "id": "VIP3-01-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场VIP3 01排 01座"
    },
    {
        "id": "VIP3-01-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场VIP3 01排 02座"
    },
    {
        "id": "VIP3-01-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场VIP3 01排 03座"
    },
    {
        "id": "VIP3-01-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场VIP3 01排 04座"
    },
    {
        "id": "VIP3-01-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场VIP3 01排 05座"
    },
    {
        "id": "VIP3-01-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场VIP3 01排 06座"
    },
    {
        "id": "VIP3-01-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场VIP3 01排 07座"
    },
    {
        "id": "VIP3-01-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场VIP3 01排 08座"
    },
    {
        "id": "VIP3-01-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场VIP3 01排 09座"
    },
    {
        "id": "VIP3-01-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场VIP3 01排 10座"
    },
    {
        "id": "VIP3-01-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场VIP3 01排 11座"
    },
    {
        "id": "VIP3-01-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场VIP3 01排 12座"
    },
    {
        "id": "VIP3-01-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场VIP3 01排 13座"
    },
    {
        "id": "VIP3-01-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场VIP3 01排 14座"
    },
    {
        "id": "VIP3-01-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场VIP3 01排 15座"
    },
    {
        "id": "VIP3-02-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场VIP3 02排 01座"
    },
    {
        "id": "VIP3-02-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场VIP3 02排 02座"
    },
    {
        "id": "VIP3-02-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场VIP3 02排 03座"
    },
    {
        "id": "VIP3-02-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场VIP3 02排 04座"
    },
    {
        "id": "VIP3-02-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场VIP3 02排 05座"
    },
    {
        "id": "VIP3-02-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场VIP3 02排 06座"
    },
    {
        "id": "VIP3-02-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场VIP3 02排 07座"
    },
    {
        "id": "VIP3-02-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场VIP3 02排 08座"
    },
    {
        "id": "VIP3-02-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场VIP3 02排 09座"
    },
    {
        "id": "VIP3-02-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场VIP3 02排 10座"
    },
    {
        "id": "VIP3-02-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场VIP3 02排 11座"
    },
    {
        "id": "VIP3-02-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场VIP3 02排 12座"
    },
    {
        "id": "VIP3-02-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场VIP3 02排 13座"
    },
    {
        "id": "VIP3-02-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场VIP3 02排 14座"
    },
    {
        "id": "VIP3-02-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场VIP3 02排 15座"
    },
    {
        "id": "VIP3-03-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场VIP3 03排 01座"
    },
    {
        "id": "VIP3-03-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场VIP3 03排 02座"
    },
    {
        "id": "VIP3-03-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场VIP3 03排 03座"
    },
    {
        "id": "VIP3-03-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场VIP3 03排 04座"
    },
    {
        "id": "VIP3-03-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场VIP3 03排 05座"
    },
    {
        "id": "VIP3-03-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场VIP3 03排 06座"
    },
    {
        "id": "VIP3-03-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场VIP3 03排 07座"
    },
    {
        "id": "VIP3-03-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场VIP3 03排 08座"
    },
    {
        "id": "VIP3-03-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场VIP3 03排 09座"
    },
    {
        "id": "VIP3-03-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场VIP3 03排 10座"
    },
    {
        "id": "VIP3-03-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场VIP3 03排 11座"
    },
    {
        "id": "VIP3-03-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场VIP3 03排 12座"
    },
    {
        "id": "VIP3-03-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场VIP3 03排 13座"
    },
    {
        "id": "VIP3-03-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场VIP3 03排 14座"
    },
    {
        "id": "VIP3-03-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场VIP3 03排 15座"
    },
    {
        "id": "VIP3-04-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场VIP3 04排 01座"
    },
    {
        "id": "VIP3-04-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场VIP3 04排 02座"
    },
    {
        "id": "VIP3-04-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场VIP3 04排 03座"
    },
    {
        "id": "VIP3-04-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场VIP3 04排 04座"
    },
    {
        "id": "VIP3-04-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场VIP3 04排 05座"
    },
    {
        "id": "VIP3-04-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场VIP3 04排 06座"
    },
    {
        "id": "VIP3-04-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场VIP3 04排 07座"
    },
    {
        "id": "VIP3-04-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场VIP3 04排 08座"
    },
    {
        "id": "VIP3-04-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场VIP3 04排 09座"
    },
    {
        "id": "VIP3-04-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场VIP3 04排 10座"
    },
    {
        "id": "VIP3-04-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场VIP3 04排 11座"
    },
    {
        "id": "VIP3-04-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场VIP3 04排 12座"
    },
    {
        "id": "VIP3-04-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场VIP3 04排 13座"
    },
    {
        "id": "VIP3-04-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场VIP3 04排 14座"
    },
    {
        "id": "VIP3-04-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场VIP3 04排 15座"
    },
    {
        "id": "VIP3-05-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场VIP3 05排 01座"
    },
    {
        "id": "VIP3-05-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场VIP3 05排 02座"
    },
    {
        "id": "VIP3-05-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场VIP3 05排 03座"
    },
    {
        "id": "VIP3-05-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场VIP3 05排 04座"
    },
    {
        "id": "VIP3-05-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场VIP3 05排 05座"
    },
    {
        "id": "VIP3-05-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场VIP3 05排 06座"
    },
    {
        "id": "VIP3-05-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场VIP3 05排 07座"
    },
    {
        "id": "VIP3-05-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场VIP3 05排 08座"
    },
    {
        "id": "VIP3-05-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场VIP3 05排 09座"
    },
    {
        "id": "VIP3-05-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场VIP3 05排 10座"
    },
    {
        "id": "VIP3-05-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场VIP3 05排 11座"
    },
    {
        "id": "VIP3-05-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场VIP3 05排 12座"
    },
    {
        "id": "VIP3-05-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场VIP3 05排 13座"
    },
    {
        "id": "VIP3-05-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场VIP3 05排 14座"
    },
    {
        "id": "VIP3-05-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场VIP3 05排 15座"
    },
    {
        "id": "VIP3-06-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场VIP3 06排 01座"
    },
    {
        "id": "VIP3-06-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场VIP3 06排 02座"
    },
    {
        "id": "VIP3-06-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场VIP3 06排 03座"
    },
    {
        "id": "VIP3-06-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场VIP3 06排 04座"
    },
    {
        "id": "VIP3-06-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场VIP3 06排 05座"
    },
    {
        "id": "VIP3-06-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场VIP3 06排 06座"
    },
    {
        "id": "VIP3-06-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场VIP3 06排 07座"
    },
    {
        "id": "VIP3-06-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场VIP3 06排 08座"
    },
    {
        "id": "VIP3-06-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场VIP3 06排 09座"
    },
    {
        "id": "VIP3-06-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场VIP3 06排 10座"
    },
    {
        "id": "VIP3-06-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场VIP3 06排 11座"
    },
    {
        "id": "VIP3-06-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场VIP3 06排 12座"
    },
    {
        "id": "VIP3-06-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场VIP3 06排 13座"
    },
    {
        "id": "VIP3-06-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场VIP3 06排 14座"
    },
    {
        "id": "VIP3-06-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场VIP3 06排 15座"
    },
    {
        "id": "VIP3-07-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场VIP3 07排 01座"
    },
    {
        "id": "VIP3-07-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场VIP3 07排 02座"
    },
    {
        "id": "VIP3-07-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场VIP3 07排 03座"
    },
    {
        "id": "VIP3-07-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场VIP3 07排 04座"
    },
    {
        "id": "VIP3-07-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场VIP3 07排 05座"
    },
    {
        "id": "VIP3-07-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场VIP3 07排 06座"
    },
    {
        "id": "VIP3-07-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场VIP3 07排 07座"
    },
    {
        "id": "VIP3-07-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场VIP3 07排 08座"
    },
    {
        "id": "VIP3-07-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场VIP3 07排 09座"
    },
    {
        "id": "VIP3-07-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场VIP3 07排 10座"
    },
    {
        "id": "VIP3-07-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场VIP3 07排 11座"
    },
    {
        "id": "VIP3-07-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场VIP3 07排 12座"
    },
    {
        "id": "VIP3-07-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场VIP3 07排 13座"
    },
    {
        "id": "VIP3-07-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场VIP3 07排 14座"
    },
    {
        "id": "VIP3-07-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场VIP3 07排 15座"
    },
    {
        "id": "VIP3-08-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场VIP3 08排 01座"
    },
    {
        "id": "VIP3-08-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场VIP3 08排 02座"
    },
    {
        "id": "VIP3-08-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场VIP3 08排 03座"
    },
    {
        "id": "VIP3-08-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场VIP3 08排 04座"
    },
    {
        "id": "VIP3-08-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场VIP3 08排 05座"
    },
    {
        "id": "VIP3-08-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场VIP3 08排 06座"
    },
    {
        "id": "VIP3-08-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场VIP3 08排 07座"
    },
    {
        "id": "VIP3-08-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场VIP3 08排 08座"
    },
    {
        "id": "VIP3-08-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场VIP3 08排 09座"
    },
    {
        "id": "VIP3-08-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场VIP3 08排 10座"
    },
    {
        "id": "VIP3-08-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场VIP3 08排 11座"
    },
    {
        "id": "VIP3-08-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场VIP3 08排 12座"
    },
    {
        "id": "VIP3-08-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场VIP3 08排 13座"
    },
    {
        "id": "VIP3-08-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场VIP3 08排 14座"
    },
    {
        "id": "VIP3-08-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场VIP3 08排 15座"
    },
    {
        "id": "VIP3-09-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场VIP3 09排 01座"
    },
    {
        "id": "VIP3-09-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场VIP3 09排 02座"
    },
    {
        "id": "VIP3-09-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场VIP3 09排 03座"
    },
    {
        "id": "VIP3-09-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场VIP3 09排 04座"
    },
    {
        "id": "VIP3-09-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场VIP3 09排 05座"
    },
    {
        "id": "VIP3-09-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场VIP3 09排 06座"
    },
    {
        "id": "VIP3-09-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场VIP3 09排 07座"
    },
    {
        "id": "VIP3-09-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场VIP3 09排 08座"
    },
    {
        "id": "VIP3-09-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场VIP3 09排 09座"
    },
    {
        "id": "VIP3-09-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场VIP3 09排 10座"
    },
    {
        "id": "VIP3-09-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场VIP3 09排 11座"
    },
    {
        "id": "VIP3-09-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场VIP3 09排 12座"
    },
    {
        "id": "VIP3-09-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场VIP3 09排 13座"
    },
    {
        "id": "VIP3-09-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场VIP3 09排 14座"
    },
    {
        "id": "VIP3-09-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场VIP3 09排 15座"
    },
    {
        "id": "VIP3-10-01",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场VIP3 10排 01座"
    },
    {
        "id": "VIP3-10-02",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场VIP3 10排 02座"
    },
    {
        "id": "VIP3-10-03",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场VIP3 10排 03座"
    },
    {
        "id": "VIP3-10-04",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场VIP3 10排 04座"
    },
    {
        "id": "VIP3-10-05",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场VIP3 10排 05座"
    },
    {
        "id": "VIP3-10-06",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场VIP3 10排 06座"
    },
    {
        "id": "VIP3-10-07",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场VIP3 10排 07座"
    },
    {
        "id": "VIP3-10-08",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场VIP3 10排 08座"
    },
    {
        "id": "VIP3-10-09",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场VIP3 10排 09座"
    },
    {
        "id": "VIP3-10-10",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场VIP3 10排 10座"
    },
    {
        "id": "VIP3-10-11",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场VIP3 10排 11座"
    },
    {
        "id": "VIP3-10-12",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场VIP3 10排 12座"
    },
    {
        "id": "VIP3-10-13",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场VIP3 10排 13座"
    },
    {
        "id": "VIP3-10-14",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场VIP3 10排 14座"
    },
    {
        "id": "VIP3-10-15",
        "areaType": "内场",
        "block": "VIP3",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场VIP3 10排 15座"
    },
    {
        "id": "VIP4-01-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场VIP4 01排 01座"
    },
    {
        "id": "VIP4-01-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场VIP4 01排 02座"
    },
    {
        "id": "VIP4-01-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场VIP4 01排 03座"
    },
    {
        "id": "VIP4-01-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场VIP4 01排 04座"
    },
    {
        "id": "VIP4-01-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场VIP4 01排 05座"
    },
    {
        "id": "VIP4-01-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场VIP4 01排 06座"
    },
    {
        "id": "VIP4-01-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场VIP4 01排 07座"
    },
    {
        "id": "VIP4-01-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场VIP4 01排 08座"
    },
    {
        "id": "VIP4-01-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场VIP4 01排 09座"
    },
    {
        "id": "VIP4-01-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场VIP4 01排 10座"
    },
    {
        "id": "VIP4-01-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场VIP4 01排 11座"
    },
    {
        "id": "VIP4-01-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场VIP4 01排 12座"
    },
    {
        "id": "VIP4-01-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场VIP4 01排 13座"
    },
    {
        "id": "VIP4-01-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场VIP4 01排 14座"
    },
    {
        "id": "VIP4-01-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场VIP4 01排 15座"
    },
    {
        "id": "VIP4-02-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场VIP4 02排 01座"
    },
    {
        "id": "VIP4-02-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场VIP4 02排 02座"
    },
    {
        "id": "VIP4-02-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场VIP4 02排 03座"
    },
    {
        "id": "VIP4-02-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场VIP4 02排 04座"
    },
    {
        "id": "VIP4-02-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场VIP4 02排 05座"
    },
    {
        "id": "VIP4-02-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场VIP4 02排 06座"
    },
    {
        "id": "VIP4-02-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场VIP4 02排 07座"
    },
    {
        "id": "VIP4-02-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场VIP4 02排 08座"
    },
    {
        "id": "VIP4-02-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场VIP4 02排 09座"
    },
    {
        "id": "VIP4-02-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场VIP4 02排 10座"
    },
    {
        "id": "VIP4-02-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场VIP4 02排 11座"
    },
    {
        "id": "VIP4-02-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场VIP4 02排 12座"
    },
    {
        "id": "VIP4-02-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场VIP4 02排 13座"
    },
    {
        "id": "VIP4-02-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场VIP4 02排 14座"
    },
    {
        "id": "VIP4-02-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场VIP4 02排 15座"
    },
    {
        "id": "VIP4-03-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场VIP4 03排 01座"
    },
    {
        "id": "VIP4-03-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场VIP4 03排 02座"
    },
    {
        "id": "VIP4-03-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场VIP4 03排 03座"
    },
    {
        "id": "VIP4-03-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场VIP4 03排 04座"
    },
    {
        "id": "VIP4-03-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场VIP4 03排 05座"
    },
    {
        "id": "VIP4-03-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场VIP4 03排 06座"
    },
    {
        "id": "VIP4-03-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场VIP4 03排 07座"
    },
    {
        "id": "VIP4-03-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场VIP4 03排 08座"
    },
    {
        "id": "VIP4-03-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场VIP4 03排 09座"
    },
    {
        "id": "VIP4-03-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场VIP4 03排 10座"
    },
    {
        "id": "VIP4-03-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场VIP4 03排 11座"
    },
    {
        "id": "VIP4-03-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场VIP4 03排 12座"
    },
    {
        "id": "VIP4-03-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场VIP4 03排 13座"
    },
    {
        "id": "VIP4-03-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场VIP4 03排 14座"
    },
    {
        "id": "VIP4-03-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场VIP4 03排 15座"
    },
    {
        "id": "VIP4-04-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场VIP4 04排 01座"
    },
    {
        "id": "VIP4-04-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场VIP4 04排 02座"
    },
    {
        "id": "VIP4-04-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场VIP4 04排 03座"
    },
    {
        "id": "VIP4-04-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场VIP4 04排 04座"
    },
    {
        "id": "VIP4-04-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场VIP4 04排 05座"
    },
    {
        "id": "VIP4-04-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场VIP4 04排 06座"
    },
    {
        "id": "VIP4-04-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场VIP4 04排 07座"
    },
    {
        "id": "VIP4-04-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场VIP4 04排 08座"
    },
    {
        "id": "VIP4-04-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场VIP4 04排 09座"
    },
    {
        "id": "VIP4-04-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场VIP4 04排 10座"
    },
    {
        "id": "VIP4-04-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场VIP4 04排 11座"
    },
    {
        "id": "VIP4-04-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场VIP4 04排 12座"
    },
    {
        "id": "VIP4-04-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场VIP4 04排 13座"
    },
    {
        "id": "VIP4-04-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场VIP4 04排 14座"
    },
    {
        "id": "VIP4-04-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场VIP4 04排 15座"
    },
    {
        "id": "VIP4-05-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场VIP4 05排 01座"
    },
    {
        "id": "VIP4-05-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场VIP4 05排 02座"
    },
    {
        "id": "VIP4-05-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场VIP4 05排 03座"
    },
    {
        "id": "VIP4-05-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场VIP4 05排 04座"
    },
    {
        "id": "VIP4-05-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场VIP4 05排 05座"
    },
    {
        "id": "VIP4-05-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场VIP4 05排 06座"
    },
    {
        "id": "VIP4-05-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场VIP4 05排 07座"
    },
    {
        "id": "VIP4-05-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场VIP4 05排 08座"
    },
    {
        "id": "VIP4-05-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场VIP4 05排 09座"
    },
    {
        "id": "VIP4-05-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场VIP4 05排 10座"
    },
    {
        "id": "VIP4-05-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场VIP4 05排 11座"
    },
    {
        "id": "VIP4-05-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场VIP4 05排 12座"
    },
    {
        "id": "VIP4-05-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场VIP4 05排 13座"
    },
    {
        "id": "VIP4-05-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场VIP4 05排 14座"
    },
    {
        "id": "VIP4-05-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场VIP4 05排 15座"
    },
    {
        "id": "VIP4-06-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场VIP4 06排 01座"
    },
    {
        "id": "VIP4-06-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场VIP4 06排 02座"
    },
    {
        "id": "VIP4-06-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场VIP4 06排 03座"
    },
    {
        "id": "VIP4-06-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场VIP4 06排 04座"
    },
    {
        "id": "VIP4-06-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场VIP4 06排 05座"
    },
    {
        "id": "VIP4-06-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场VIP4 06排 06座"
    },
    {
        "id": "VIP4-06-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场VIP4 06排 07座"
    },
    {
        "id": "VIP4-06-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场VIP4 06排 08座"
    },
    {
        "id": "VIP4-06-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场VIP4 06排 09座"
    },
    {
        "id": "VIP4-06-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场VIP4 06排 10座"
    },
    {
        "id": "VIP4-06-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场VIP4 06排 11座"
    },
    {
        "id": "VIP4-06-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场VIP4 06排 12座"
    },
    {
        "id": "VIP4-06-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场VIP4 06排 13座"
    },
    {
        "id": "VIP4-06-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场VIP4 06排 14座"
    },
    {
        "id": "VIP4-06-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场VIP4 06排 15座"
    },
    {
        "id": "VIP4-07-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场VIP4 07排 01座"
    },
    {
        "id": "VIP4-07-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场VIP4 07排 02座"
    },
    {
        "id": "VIP4-07-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场VIP4 07排 03座"
    },
    {
        "id": "VIP4-07-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场VIP4 07排 04座"
    },
    {
        "id": "VIP4-07-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场VIP4 07排 05座"
    },
    {
        "id": "VIP4-07-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场VIP4 07排 06座"
    },
    {
        "id": "VIP4-07-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场VIP4 07排 07座"
    },
    {
        "id": "VIP4-07-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场VIP4 07排 08座"
    },
    {
        "id": "VIP4-07-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场VIP4 07排 09座"
    },
    {
        "id": "VIP4-07-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场VIP4 07排 10座"
    },
    {
        "id": "VIP4-07-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场VIP4 07排 11座"
    },
    {
        "id": "VIP4-07-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场VIP4 07排 12座"
    },
    {
        "id": "VIP4-07-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场VIP4 07排 13座"
    },
    {
        "id": "VIP4-07-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场VIP4 07排 14座"
    },
    {
        "id": "VIP4-07-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场VIP4 07排 15座"
    },
    {
        "id": "VIP4-08-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场VIP4 08排 01座"
    },
    {
        "id": "VIP4-08-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场VIP4 08排 02座"
    },
    {
        "id": "VIP4-08-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场VIP4 08排 03座"
    },
    {
        "id": "VIP4-08-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场VIP4 08排 04座"
    },
    {
        "id": "VIP4-08-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场VIP4 08排 05座"
    },
    {
        "id": "VIP4-08-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场VIP4 08排 06座"
    },
    {
        "id": "VIP4-08-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场VIP4 08排 07座"
    },
    {
        "id": "VIP4-08-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场VIP4 08排 08座"
    },
    {
        "id": "VIP4-08-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场VIP4 08排 09座"
    },
    {
        "id": "VIP4-08-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场VIP4 08排 10座"
    },
    {
        "id": "VIP4-08-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场VIP4 08排 11座"
    },
    {
        "id": "VIP4-08-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场VIP4 08排 12座"
    },
    {
        "id": "VIP4-08-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场VIP4 08排 13座"
    },
    {
        "id": "VIP4-08-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场VIP4 08排 14座"
    },
    {
        "id": "VIP4-08-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场VIP4 08排 15座"
    },
    {
        "id": "VIP4-09-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场VIP4 09排 01座"
    },
    {
        "id": "VIP4-09-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场VIP4 09排 02座"
    },
    {
        "id": "VIP4-09-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场VIP4 09排 03座"
    },
    {
        "id": "VIP4-09-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场VIP4 09排 04座"
    },
    {
        "id": "VIP4-09-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场VIP4 09排 05座"
    },
    {
        "id": "VIP4-09-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场VIP4 09排 06座"
    },
    {
        "id": "VIP4-09-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场VIP4 09排 07座"
    },
    {
        "id": "VIP4-09-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场VIP4 09排 08座"
    },
    {
        "id": "VIP4-09-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场VIP4 09排 09座"
    },
    {
        "id": "VIP4-09-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场VIP4 09排 10座"
    },
    {
        "id": "VIP4-09-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场VIP4 09排 11座"
    },
    {
        "id": "VIP4-09-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场VIP4 09排 12座"
    },
    {
        "id": "VIP4-09-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场VIP4 09排 13座"
    },
    {
        "id": "VIP4-09-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场VIP4 09排 14座"
    },
    {
        "id": "VIP4-09-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场VIP4 09排 15座"
    },
    {
        "id": "VIP4-10-01",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场VIP4 10排 01座"
    },
    {
        "id": "VIP4-10-02",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场VIP4 10排 02座"
    },
    {
        "id": "VIP4-10-03",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场VIP4 10排 03座"
    },
    {
        "id": "VIP4-10-04",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场VIP4 10排 04座"
    },
    {
        "id": "VIP4-10-05",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场VIP4 10排 05座"
    },
    {
        "id": "VIP4-10-06",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场VIP4 10排 06座"
    },
    {
        "id": "VIP4-10-07",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场VIP4 10排 07座"
    },
    {
        "id": "VIP4-10-08",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场VIP4 10排 08座"
    },
    {
        "id": "VIP4-10-09",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场VIP4 10排 09座"
    },
    {
        "id": "VIP4-10-10",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场VIP4 10排 10座"
    },
    {
        "id": "VIP4-10-11",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场VIP4 10排 11座"
    },
    {
        "id": "VIP4-10-12",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场VIP4 10排 12座"
    },
    {
        "id": "VIP4-10-13",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场VIP4 10排 13座"
    },
    {
        "id": "VIP4-10-14",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场VIP4 10排 14座"
    },
    {
        "id": "VIP4-10-15",
        "areaType": "内场",
        "block": "VIP4",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场VIP4 10排 15座"
    },
    {
        "id": "VIP5-01-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场VIP5 01排 01座"
    },
    {
        "id": "VIP5-01-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场VIP5 01排 02座"
    },
    {
        "id": "VIP5-01-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场VIP5 01排 03座"
    },
    {
        "id": "VIP5-01-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场VIP5 01排 04座"
    },
    {
        "id": "VIP5-01-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场VIP5 01排 05座"
    },
    {
        "id": "VIP5-01-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场VIP5 01排 06座"
    },
    {
        "id": "VIP5-01-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场VIP5 01排 07座"
    },
    {
        "id": "VIP5-01-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场VIP5 01排 08座"
    },
    {
        "id": "VIP5-01-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场VIP5 01排 09座"
    },
    {
        "id": "VIP5-01-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场VIP5 01排 10座"
    },
    {
        "id": "VIP5-01-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场VIP5 01排 11座"
    },
    {
        "id": "VIP5-01-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场VIP5 01排 12座"
    },
    {
        "id": "VIP5-01-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场VIP5 01排 13座"
    },
    {
        "id": "VIP5-01-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场VIP5 01排 14座"
    },
    {
        "id": "VIP5-01-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场VIP5 01排 15座"
    },
    {
        "id": "VIP5-02-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场VIP5 02排 01座"
    },
    {
        "id": "VIP5-02-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场VIP5 02排 02座"
    },
    {
        "id": "VIP5-02-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场VIP5 02排 03座"
    },
    {
        "id": "VIP5-02-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场VIP5 02排 04座"
    },
    {
        "id": "VIP5-02-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场VIP5 02排 05座"
    },
    {
        "id": "VIP5-02-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场VIP5 02排 06座"
    },
    {
        "id": "VIP5-02-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场VIP5 02排 07座"
    },
    {
        "id": "VIP5-02-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场VIP5 02排 08座"
    },
    {
        "id": "VIP5-02-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场VIP5 02排 09座"
    },
    {
        "id": "VIP5-02-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场VIP5 02排 10座"
    },
    {
        "id": "VIP5-02-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场VIP5 02排 11座"
    },
    {
        "id": "VIP5-02-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场VIP5 02排 12座"
    },
    {
        "id": "VIP5-02-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场VIP5 02排 13座"
    },
    {
        "id": "VIP5-02-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场VIP5 02排 14座"
    },
    {
        "id": "VIP5-02-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场VIP5 02排 15座"
    },
    {
        "id": "VIP5-03-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场VIP5 03排 01座"
    },
    {
        "id": "VIP5-03-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场VIP5 03排 02座"
    },
    {
        "id": "VIP5-03-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场VIP5 03排 03座"
    },
    {
        "id": "VIP5-03-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场VIP5 03排 04座"
    },
    {
        "id": "VIP5-03-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场VIP5 03排 05座"
    },
    {
        "id": "VIP5-03-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场VIP5 03排 06座"
    },
    {
        "id": "VIP5-03-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场VIP5 03排 07座"
    },
    {
        "id": "VIP5-03-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场VIP5 03排 08座"
    },
    {
        "id": "VIP5-03-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场VIP5 03排 09座"
    },
    {
        "id": "VIP5-03-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场VIP5 03排 10座"
    },
    {
        "id": "VIP5-03-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场VIP5 03排 11座"
    },
    {
        "id": "VIP5-03-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场VIP5 03排 12座"
    },
    {
        "id": "VIP5-03-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场VIP5 03排 13座"
    },
    {
        "id": "VIP5-03-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场VIP5 03排 14座"
    },
    {
        "id": "VIP5-03-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场VIP5 03排 15座"
    },
    {
        "id": "VIP5-04-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场VIP5 04排 01座"
    },
    {
        "id": "VIP5-04-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场VIP5 04排 02座"
    },
    {
        "id": "VIP5-04-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场VIP5 04排 03座"
    },
    {
        "id": "VIP5-04-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场VIP5 04排 04座"
    },
    {
        "id": "VIP5-04-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场VIP5 04排 05座"
    },
    {
        "id": "VIP5-04-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场VIP5 04排 06座"
    },
    {
        "id": "VIP5-04-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场VIP5 04排 07座"
    },
    {
        "id": "VIP5-04-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场VIP5 04排 08座"
    },
    {
        "id": "VIP5-04-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场VIP5 04排 09座"
    },
    {
        "id": "VIP5-04-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场VIP5 04排 10座"
    },
    {
        "id": "VIP5-04-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场VIP5 04排 11座"
    },
    {
        "id": "VIP5-04-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场VIP5 04排 12座"
    },
    {
        "id": "VIP5-04-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场VIP5 04排 13座"
    },
    {
        "id": "VIP5-04-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场VIP5 04排 14座"
    },
    {
        "id": "VIP5-04-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场VIP5 04排 15座"
    },
    {
        "id": "VIP5-05-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场VIP5 05排 01座"
    },
    {
        "id": "VIP5-05-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场VIP5 05排 02座"
    },
    {
        "id": "VIP5-05-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场VIP5 05排 03座"
    },
    {
        "id": "VIP5-05-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场VIP5 05排 04座"
    },
    {
        "id": "VIP5-05-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场VIP5 05排 05座"
    },
    {
        "id": "VIP5-05-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场VIP5 05排 06座"
    },
    {
        "id": "VIP5-05-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场VIP5 05排 07座"
    },
    {
        "id": "VIP5-05-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场VIP5 05排 08座"
    },
    {
        "id": "VIP5-05-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场VIP5 05排 09座"
    },
    {
        "id": "VIP5-05-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场VIP5 05排 10座"
    },
    {
        "id": "VIP5-05-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场VIP5 05排 11座"
    },
    {
        "id": "VIP5-05-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场VIP5 05排 12座"
    },
    {
        "id": "VIP5-05-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场VIP5 05排 13座"
    },
    {
        "id": "VIP5-05-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场VIP5 05排 14座"
    },
    {
        "id": "VIP5-05-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场VIP5 05排 15座"
    },
    {
        "id": "VIP5-06-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场VIP5 06排 01座"
    },
    {
        "id": "VIP5-06-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场VIP5 06排 02座"
    },
    {
        "id": "VIP5-06-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场VIP5 06排 03座"
    },
    {
        "id": "VIP5-06-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场VIP5 06排 04座"
    },
    {
        "id": "VIP5-06-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场VIP5 06排 05座"
    },
    {
        "id": "VIP5-06-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场VIP5 06排 06座"
    },
    {
        "id": "VIP5-06-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场VIP5 06排 07座"
    },
    {
        "id": "VIP5-06-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场VIP5 06排 08座"
    },
    {
        "id": "VIP5-06-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场VIP5 06排 09座"
    },
    {
        "id": "VIP5-06-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场VIP5 06排 10座"
    },
    {
        "id": "VIP5-06-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场VIP5 06排 11座"
    },
    {
        "id": "VIP5-06-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场VIP5 06排 12座"
    },
    {
        "id": "VIP5-06-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场VIP5 06排 13座"
    },
    {
        "id": "VIP5-06-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场VIP5 06排 14座"
    },
    {
        "id": "VIP5-06-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场VIP5 06排 15座"
    },
    {
        "id": "VIP5-07-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场VIP5 07排 01座"
    },
    {
        "id": "VIP5-07-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场VIP5 07排 02座"
    },
    {
        "id": "VIP5-07-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场VIP5 07排 03座"
    },
    {
        "id": "VIP5-07-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场VIP5 07排 04座"
    },
    {
        "id": "VIP5-07-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场VIP5 07排 05座"
    },
    {
        "id": "VIP5-07-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场VIP5 07排 06座"
    },
    {
        "id": "VIP5-07-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场VIP5 07排 07座"
    },
    {
        "id": "VIP5-07-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场VIP5 07排 08座"
    },
    {
        "id": "VIP5-07-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场VIP5 07排 09座"
    },
    {
        "id": "VIP5-07-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场VIP5 07排 10座"
    },
    {
        "id": "VIP5-07-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场VIP5 07排 11座"
    },
    {
        "id": "VIP5-07-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场VIP5 07排 12座"
    },
    {
        "id": "VIP5-07-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场VIP5 07排 13座"
    },
    {
        "id": "VIP5-07-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场VIP5 07排 14座"
    },
    {
        "id": "VIP5-07-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场VIP5 07排 15座"
    },
    {
        "id": "VIP5-08-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场VIP5 08排 01座"
    },
    {
        "id": "VIP5-08-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场VIP5 08排 02座"
    },
    {
        "id": "VIP5-08-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场VIP5 08排 03座"
    },
    {
        "id": "VIP5-08-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场VIP5 08排 04座"
    },
    {
        "id": "VIP5-08-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场VIP5 08排 05座"
    },
    {
        "id": "VIP5-08-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场VIP5 08排 06座"
    },
    {
        "id": "VIP5-08-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场VIP5 08排 07座"
    },
    {
        "id": "VIP5-08-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场VIP5 08排 08座"
    },
    {
        "id": "VIP5-08-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场VIP5 08排 09座"
    },
    {
        "id": "VIP5-08-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场VIP5 08排 10座"
    },
    {
        "id": "VIP5-08-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场VIP5 08排 11座"
    },
    {
        "id": "VIP5-08-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场VIP5 08排 12座"
    },
    {
        "id": "VIP5-08-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场VIP5 08排 13座"
    },
    {
        "id": "VIP5-08-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场VIP5 08排 14座"
    },
    {
        "id": "VIP5-08-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场VIP5 08排 15座"
    },
    {
        "id": "VIP5-09-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场VIP5 09排 01座"
    },
    {
        "id": "VIP5-09-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场VIP5 09排 02座"
    },
    {
        "id": "VIP5-09-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场VIP5 09排 03座"
    },
    {
        "id": "VIP5-09-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场VIP5 09排 04座"
    },
    {
        "id": "VIP5-09-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场VIP5 09排 05座"
    },
    {
        "id": "VIP5-09-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场VIP5 09排 06座"
    },
    {
        "id": "VIP5-09-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场VIP5 09排 07座"
    },
    {
        "id": "VIP5-09-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场VIP5 09排 08座"
    },
    {
        "id": "VIP5-09-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场VIP5 09排 09座"
    },
    {
        "id": "VIP5-09-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场VIP5 09排 10座"
    },
    {
        "id": "VIP5-09-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场VIP5 09排 11座"
    },
    {
        "id": "VIP5-09-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场VIP5 09排 12座"
    },
    {
        "id": "VIP5-09-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场VIP5 09排 13座"
    },
    {
        "id": "VIP5-09-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场VIP5 09排 14座"
    },
    {
        "id": "VIP5-09-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场VIP5 09排 15座"
    },
    {
        "id": "VIP5-10-01",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场VIP5 10排 01座"
    },
    {
        "id": "VIP5-10-02",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场VIP5 10排 02座"
    },
    {
        "id": "VIP5-10-03",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场VIP5 10排 03座"
    },
    {
        "id": "VIP5-10-04",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场VIP5 10排 04座"
    },
    {
        "id": "VIP5-10-05",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场VIP5 10排 05座"
    },
    {
        "id": "VIP5-10-06",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场VIP5 10排 06座"
    },
    {
        "id": "VIP5-10-07",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场VIP5 10排 07座"
    },
    {
        "id": "VIP5-10-08",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场VIP5 10排 08座"
    },
    {
        "id": "VIP5-10-09",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场VIP5 10排 09座"
    },
    {
        "id": "VIP5-10-10",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场VIP5 10排 10座"
    },
    {
        "id": "VIP5-10-11",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场VIP5 10排 11座"
    },
    {
        "id": "VIP5-10-12",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场VIP5 10排 12座"
    },
    {
        "id": "VIP5-10-13",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场VIP5 10排 13座"
    },
    {
        "id": "VIP5-10-14",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场VIP5 10排 14座"
    },
    {
        "id": "VIP5-10-15",
        "areaType": "内场",
        "block": "VIP5",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场VIP5 10排 15座"
    },
    {
        "id": "A11-01-01",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场A11 01排 01座"
    },
    {
        "id": "A11-01-02",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场A11 01排 02座"
    },
    {
        "id": "A11-01-03",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场A11 01排 03座"
    },
    {
        "id": "A11-01-04",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场A11 01排 04座"
    },
    {
        "id": "A11-01-05",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场A11 01排 05座"
    },
    {
        "id": "A11-01-06",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场A11 01排 06座"
    },
    {
        "id": "A11-01-07",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场A11 01排 07座"
    },
    {
        "id": "A11-01-08",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场A11 01排 08座"
    },
    {
        "id": "A11-01-09",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场A11 01排 09座"
    },
    {
        "id": "A11-01-10",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场A11 01排 10座"
    },
    {
        "id": "A11-01-11",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场A11 01排 11座"
    },
    {
        "id": "A11-01-12",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场A11 01排 12座"
    },
    {
        "id": "A11-01-13",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场A11 01排 13座"
    },
    {
        "id": "A11-01-14",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场A11 01排 14座"
    },
    {
        "id": "A11-01-15",
        "areaType": "内场",
        "block": "A11",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场A11 01排 15座"
    },
    {
        "id": "A11-02-01",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场A11 02排 01座"
    },
    {
        "id": "A11-02-02",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场A11 02排 02座"
    },
    {
        "id": "A11-02-03",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场A11 02排 03座"
    },
    {
        "id": "A11-02-04",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场A11 02排 04座"
    },
    {
        "id": "A11-02-05",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场A11 02排 05座"
    },
    {
        "id": "A11-02-06",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场A11 02排 06座"
    },
    {
        "id": "A11-02-07",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场A11 02排 07座"
    },
    {
        "id": "A11-02-08",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场A11 02排 08座"
    },
    {
        "id": "A11-02-09",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场A11 02排 09座"
    },
    {
        "id": "A11-02-10",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场A11 02排 10座"
    },
    {
        "id": "A11-02-11",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场A11 02排 11座"
    },
    {
        "id": "A11-02-12",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场A11 02排 12座"
    },
    {
        "id": "A11-02-13",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场A11 02排 13座"
    },
    {
        "id": "A11-02-14",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场A11 02排 14座"
    },
    {
        "id": "A11-02-15",
        "areaType": "内场",
        "block": "A11",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场A11 02排 15座"
    },
    {
        "id": "A11-03-01",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场A11 03排 01座"
    },
    {
        "id": "A11-03-02",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场A11 03排 02座"
    },
    {
        "id": "A11-03-03",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场A11 03排 03座"
    },
    {
        "id": "A11-03-04",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场A11 03排 04座"
    },
    {
        "id": "A11-03-05",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场A11 03排 05座"
    },
    {
        "id": "A11-03-06",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场A11 03排 06座"
    },
    {
        "id": "A11-03-07",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场A11 03排 07座"
    },
    {
        "id": "A11-03-08",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场A11 03排 08座"
    },
    {
        "id": "A11-03-09",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场A11 03排 09座"
    },
    {
        "id": "A11-03-10",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场A11 03排 10座"
    },
    {
        "id": "A11-03-11",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场A11 03排 11座"
    },
    {
        "id": "A11-03-12",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场A11 03排 12座"
    },
    {
        "id": "A11-03-13",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场A11 03排 13座"
    },
    {
        "id": "A11-03-14",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场A11 03排 14座"
    },
    {
        "id": "A11-03-15",
        "areaType": "内场",
        "block": "A11",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场A11 03排 15座"
    },
    {
        "id": "A11-04-01",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场A11 04排 01座"
    },
    {
        "id": "A11-04-02",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场A11 04排 02座"
    },
    {
        "id": "A11-04-03",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场A11 04排 03座"
    },
    {
        "id": "A11-04-04",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场A11 04排 04座"
    },
    {
        "id": "A11-04-05",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场A11 04排 05座"
    },
    {
        "id": "A11-04-06",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场A11 04排 06座"
    },
    {
        "id": "A11-04-07",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场A11 04排 07座"
    },
    {
        "id": "A11-04-08",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场A11 04排 08座"
    },
    {
        "id": "A11-04-09",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场A11 04排 09座"
    },
    {
        "id": "A11-04-10",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场A11 04排 10座"
    },
    {
        "id": "A11-04-11",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场A11 04排 11座"
    },
    {
        "id": "A11-04-12",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场A11 04排 12座"
    },
    {
        "id": "A11-04-13",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场A11 04排 13座"
    },
    {
        "id": "A11-04-14",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场A11 04排 14座"
    },
    {
        "id": "A11-04-15",
        "areaType": "内场",
        "block": "A11",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场A11 04排 15座"
    },
    {
        "id": "A11-05-01",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场A11 05排 01座"
    },
    {
        "id": "A11-05-02",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场A11 05排 02座"
    },
    {
        "id": "A11-05-03",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场A11 05排 03座"
    },
    {
        "id": "A11-05-04",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场A11 05排 04座"
    },
    {
        "id": "A11-05-05",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场A11 05排 05座"
    },
    {
        "id": "A11-05-06",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场A11 05排 06座"
    },
    {
        "id": "A11-05-07",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场A11 05排 07座"
    },
    {
        "id": "A11-05-08",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场A11 05排 08座"
    },
    {
        "id": "A11-05-09",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场A11 05排 09座"
    },
    {
        "id": "A11-05-10",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场A11 05排 10座"
    },
    {
        "id": "A11-05-11",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场A11 05排 11座"
    },
    {
        "id": "A11-05-12",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场A11 05排 12座"
    },
    {
        "id": "A11-05-13",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场A11 05排 13座"
    },
    {
        "id": "A11-05-14",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场A11 05排 14座"
    },
    {
        "id": "A11-05-15",
        "areaType": "内场",
        "block": "A11",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场A11 05排 15座"
    },
    {
        "id": "A11-06-01",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场A11 06排 01座"
    },
    {
        "id": "A11-06-02",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场A11 06排 02座"
    },
    {
        "id": "A11-06-03",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场A11 06排 03座"
    },
    {
        "id": "A11-06-04",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场A11 06排 04座"
    },
    {
        "id": "A11-06-05",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场A11 06排 05座"
    },
    {
        "id": "A11-06-06",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场A11 06排 06座"
    },
    {
        "id": "A11-06-07",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场A11 06排 07座"
    },
    {
        "id": "A11-06-08",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场A11 06排 08座"
    },
    {
        "id": "A11-06-09",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场A11 06排 09座"
    },
    {
        "id": "A11-06-10",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场A11 06排 10座"
    },
    {
        "id": "A11-06-11",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场A11 06排 11座"
    },
    {
        "id": "A11-06-12",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场A11 06排 12座"
    },
    {
        "id": "A11-06-13",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场A11 06排 13座"
    },
    {
        "id": "A11-06-14",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场A11 06排 14座"
    },
    {
        "id": "A11-06-15",
        "areaType": "内场",
        "block": "A11",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场A11 06排 15座"
    },
    {
        "id": "A11-07-01",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场A11 07排 01座"
    },
    {
        "id": "A11-07-02",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场A11 07排 02座"
    },
    {
        "id": "A11-07-03",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场A11 07排 03座"
    },
    {
        "id": "A11-07-04",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场A11 07排 04座"
    },
    {
        "id": "A11-07-05",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场A11 07排 05座"
    },
    {
        "id": "A11-07-06",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场A11 07排 06座"
    },
    {
        "id": "A11-07-07",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场A11 07排 07座"
    },
    {
        "id": "A11-07-08",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场A11 07排 08座"
    },
    {
        "id": "A11-07-09",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场A11 07排 09座"
    },
    {
        "id": "A11-07-10",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场A11 07排 10座"
    },
    {
        "id": "A11-07-11",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场A11 07排 11座"
    },
    {
        "id": "A11-07-12",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场A11 07排 12座"
    },
    {
        "id": "A11-07-13",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场A11 07排 13座"
    },
    {
        "id": "A11-07-14",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场A11 07排 14座"
    },
    {
        "id": "A11-07-15",
        "areaType": "内场",
        "block": "A11",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场A11 07排 15座"
    },
    {
        "id": "A11-08-01",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场A11 08排 01座"
    },
    {
        "id": "A11-08-02",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场A11 08排 02座"
    },
    {
        "id": "A11-08-03",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场A11 08排 03座"
    },
    {
        "id": "A11-08-04",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场A11 08排 04座"
    },
    {
        "id": "A11-08-05",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场A11 08排 05座"
    },
    {
        "id": "A11-08-06",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场A11 08排 06座"
    },
    {
        "id": "A11-08-07",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场A11 08排 07座"
    },
    {
        "id": "A11-08-08",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场A11 08排 08座"
    },
    {
        "id": "A11-08-09",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场A11 08排 09座"
    },
    {
        "id": "A11-08-10",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场A11 08排 10座"
    },
    {
        "id": "A11-08-11",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场A11 08排 11座"
    },
    {
        "id": "A11-08-12",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场A11 08排 12座"
    },
    {
        "id": "A11-08-13",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场A11 08排 13座"
    },
    {
        "id": "A11-08-14",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场A11 08排 14座"
    },
    {
        "id": "A11-08-15",
        "areaType": "内场",
        "block": "A11",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场A11 08排 15座"
    },
    {
        "id": "A11-09-01",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场A11 09排 01座"
    },
    {
        "id": "A11-09-02",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场A11 09排 02座"
    },
    {
        "id": "A11-09-03",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场A11 09排 03座"
    },
    {
        "id": "A11-09-04",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场A11 09排 04座"
    },
    {
        "id": "A11-09-05",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场A11 09排 05座"
    },
    {
        "id": "A11-09-06",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场A11 09排 06座"
    },
    {
        "id": "A11-09-07",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场A11 09排 07座"
    },
    {
        "id": "A11-09-08",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场A11 09排 08座"
    },
    {
        "id": "A11-09-09",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场A11 09排 09座"
    },
    {
        "id": "A11-09-10",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场A11 09排 10座"
    },
    {
        "id": "A11-09-11",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场A11 09排 11座"
    },
    {
        "id": "A11-09-12",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场A11 09排 12座"
    },
    {
        "id": "A11-09-13",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场A11 09排 13座"
    },
    {
        "id": "A11-09-14",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场A11 09排 14座"
    },
    {
        "id": "A11-09-15",
        "areaType": "内场",
        "block": "A11",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场A11 09排 15座"
    },
    {
        "id": "A11-10-01",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场A11 10排 01座"
    },
    {
        "id": "A11-10-02",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场A11 10排 02座"
    },
    {
        "id": "A11-10-03",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场A11 10排 03座"
    },
    {
        "id": "A11-10-04",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场A11 10排 04座"
    },
    {
        "id": "A11-10-05",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场A11 10排 05座"
    },
    {
        "id": "A11-10-06",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场A11 10排 06座"
    },
    {
        "id": "A11-10-07",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场A11 10排 07座"
    },
    {
        "id": "A11-10-08",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场A11 10排 08座"
    },
    {
        "id": "A11-10-09",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场A11 10排 09座"
    },
    {
        "id": "A11-10-10",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场A11 10排 10座"
    },
    {
        "id": "A11-10-11",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场A11 10排 11座"
    },
    {
        "id": "A11-10-12",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场A11 10排 12座"
    },
    {
        "id": "A11-10-13",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场A11 10排 13座"
    },
    {
        "id": "A11-10-14",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场A11 10排 14座"
    },
    {
        "id": "A11-10-15",
        "areaType": "内场",
        "block": "A11",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场A11 10排 15座"
    },
    {
        "id": "A12-01-01",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场A12 01排 01座"
    },
    {
        "id": "A12-01-02",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场A12 01排 02座"
    },
    {
        "id": "A12-01-03",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场A12 01排 03座"
    },
    {
        "id": "A12-01-04",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场A12 01排 04座"
    },
    {
        "id": "A12-01-05",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场A12 01排 05座"
    },
    {
        "id": "A12-01-06",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场A12 01排 06座"
    },
    {
        "id": "A12-01-07",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场A12 01排 07座"
    },
    {
        "id": "A12-01-08",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场A12 01排 08座"
    },
    {
        "id": "A12-01-09",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场A12 01排 09座"
    },
    {
        "id": "A12-01-10",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场A12 01排 10座"
    },
    {
        "id": "A12-01-11",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场A12 01排 11座"
    },
    {
        "id": "A12-01-12",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场A12 01排 12座"
    },
    {
        "id": "A12-01-13",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场A12 01排 13座"
    },
    {
        "id": "A12-01-14",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场A12 01排 14座"
    },
    {
        "id": "A12-01-15",
        "areaType": "内场",
        "block": "A12",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场A12 01排 15座"
    },
    {
        "id": "A12-02-01",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场A12 02排 01座"
    },
    {
        "id": "A12-02-02",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场A12 02排 02座"
    },
    {
        "id": "A12-02-03",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场A12 02排 03座"
    },
    {
        "id": "A12-02-04",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场A12 02排 04座"
    },
    {
        "id": "A12-02-05",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场A12 02排 05座"
    },
    {
        "id": "A12-02-06",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场A12 02排 06座"
    },
    {
        "id": "A12-02-07",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场A12 02排 07座"
    },
    {
        "id": "A12-02-08",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场A12 02排 08座"
    },
    {
        "id": "A12-02-09",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场A12 02排 09座"
    },
    {
        "id": "A12-02-10",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场A12 02排 10座"
    },
    {
        "id": "A12-02-11",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场A12 02排 11座"
    },
    {
        "id": "A12-02-12",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场A12 02排 12座"
    },
    {
        "id": "A12-02-13",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场A12 02排 13座"
    },
    {
        "id": "A12-02-14",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场A12 02排 14座"
    },
    {
        "id": "A12-02-15",
        "areaType": "内场",
        "block": "A12",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场A12 02排 15座"
    },
    {
        "id": "A12-03-01",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场A12 03排 01座"
    },
    {
        "id": "A12-03-02",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场A12 03排 02座"
    },
    {
        "id": "A12-03-03",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场A12 03排 03座"
    },
    {
        "id": "A12-03-04",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场A12 03排 04座"
    },
    {
        "id": "A12-03-05",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场A12 03排 05座"
    },
    {
        "id": "A12-03-06",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场A12 03排 06座"
    },
    {
        "id": "A12-03-07",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场A12 03排 07座"
    },
    {
        "id": "A12-03-08",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场A12 03排 08座"
    },
    {
        "id": "A12-03-09",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场A12 03排 09座"
    },
    {
        "id": "A12-03-10",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场A12 03排 10座"
    },
    {
        "id": "A12-03-11",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场A12 03排 11座"
    },
    {
        "id": "A12-03-12",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场A12 03排 12座"
    },
    {
        "id": "A12-03-13",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场A12 03排 13座"
    },
    {
        "id": "A12-03-14",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场A12 03排 14座"
    },
    {
        "id": "A12-03-15",
        "areaType": "内场",
        "block": "A12",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场A12 03排 15座"
    },
    {
        "id": "A12-04-01",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场A12 04排 01座"
    },
    {
        "id": "A12-04-02",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场A12 04排 02座"
    },
    {
        "id": "A12-04-03",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场A12 04排 03座"
    },
    {
        "id": "A12-04-04",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场A12 04排 04座"
    },
    {
        "id": "A12-04-05",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场A12 04排 05座"
    },
    {
        "id": "A12-04-06",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场A12 04排 06座"
    },
    {
        "id": "A12-04-07",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场A12 04排 07座"
    },
    {
        "id": "A12-04-08",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场A12 04排 08座"
    },
    {
        "id": "A12-04-09",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场A12 04排 09座"
    },
    {
        "id": "A12-04-10",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场A12 04排 10座"
    },
    {
        "id": "A12-04-11",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场A12 04排 11座"
    },
    {
        "id": "A12-04-12",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场A12 04排 12座"
    },
    {
        "id": "A12-04-13",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场A12 04排 13座"
    },
    {
        "id": "A12-04-14",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场A12 04排 14座"
    },
    {
        "id": "A12-04-15",
        "areaType": "内场",
        "block": "A12",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场A12 04排 15座"
    },
    {
        "id": "A12-05-01",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场A12 05排 01座"
    },
    {
        "id": "A12-05-02",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场A12 05排 02座"
    },
    {
        "id": "A12-05-03",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场A12 05排 03座"
    },
    {
        "id": "A12-05-04",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场A12 05排 04座"
    },
    {
        "id": "A12-05-05",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场A12 05排 05座"
    },
    {
        "id": "A12-05-06",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场A12 05排 06座"
    },
    {
        "id": "A12-05-07",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场A12 05排 07座"
    },
    {
        "id": "A12-05-08",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场A12 05排 08座"
    },
    {
        "id": "A12-05-09",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场A12 05排 09座"
    },
    {
        "id": "A12-05-10",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场A12 05排 10座"
    },
    {
        "id": "A12-05-11",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场A12 05排 11座"
    },
    {
        "id": "A12-05-12",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场A12 05排 12座"
    },
    {
        "id": "A12-05-13",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场A12 05排 13座"
    },
    {
        "id": "A12-05-14",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场A12 05排 14座"
    },
    {
        "id": "A12-05-15",
        "areaType": "内场",
        "block": "A12",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场A12 05排 15座"
    },
    {
        "id": "A12-06-01",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场A12 06排 01座"
    },
    {
        "id": "A12-06-02",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场A12 06排 02座"
    },
    {
        "id": "A12-06-03",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场A12 06排 03座"
    },
    {
        "id": "A12-06-04",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场A12 06排 04座"
    },
    {
        "id": "A12-06-05",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场A12 06排 05座"
    },
    {
        "id": "A12-06-06",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场A12 06排 06座"
    },
    {
        "id": "A12-06-07",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场A12 06排 07座"
    },
    {
        "id": "A12-06-08",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场A12 06排 08座"
    },
    {
        "id": "A12-06-09",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场A12 06排 09座"
    },
    {
        "id": "A12-06-10",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场A12 06排 10座"
    },
    {
        "id": "A12-06-11",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场A12 06排 11座"
    },
    {
        "id": "A12-06-12",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场A12 06排 12座"
    },
    {
        "id": "A12-06-13",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场A12 06排 13座"
    },
    {
        "id": "A12-06-14",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场A12 06排 14座"
    },
    {
        "id": "A12-06-15",
        "areaType": "内场",
        "block": "A12",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场A12 06排 15座"
    },
    {
        "id": "A12-07-01",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场A12 07排 01座"
    },
    {
        "id": "A12-07-02",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场A12 07排 02座"
    },
    {
        "id": "A12-07-03",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场A12 07排 03座"
    },
    {
        "id": "A12-07-04",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场A12 07排 04座"
    },
    {
        "id": "A12-07-05",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场A12 07排 05座"
    },
    {
        "id": "A12-07-06",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场A12 07排 06座"
    },
    {
        "id": "A12-07-07",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场A12 07排 07座"
    },
    {
        "id": "A12-07-08",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场A12 07排 08座"
    },
    {
        "id": "A12-07-09",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场A12 07排 09座"
    },
    {
        "id": "A12-07-10",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场A12 07排 10座"
    },
    {
        "id": "A12-07-11",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场A12 07排 11座"
    },
    {
        "id": "A12-07-12",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场A12 07排 12座"
    },
    {
        "id": "A12-07-13",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场A12 07排 13座"
    },
    {
        "id": "A12-07-14",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场A12 07排 14座"
    },
    {
        "id": "A12-07-15",
        "areaType": "内场",
        "block": "A12",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场A12 07排 15座"
    },
    {
        "id": "A12-08-01",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场A12 08排 01座"
    },
    {
        "id": "A12-08-02",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场A12 08排 02座"
    },
    {
        "id": "A12-08-03",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场A12 08排 03座"
    },
    {
        "id": "A12-08-04",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场A12 08排 04座"
    },
    {
        "id": "A12-08-05",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场A12 08排 05座"
    },
    {
        "id": "A12-08-06",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场A12 08排 06座"
    },
    {
        "id": "A12-08-07",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场A12 08排 07座"
    },
    {
        "id": "A12-08-08",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场A12 08排 08座"
    },
    {
        "id": "A12-08-09",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场A12 08排 09座"
    },
    {
        "id": "A12-08-10",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场A12 08排 10座"
    },
    {
        "id": "A12-08-11",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场A12 08排 11座"
    },
    {
        "id": "A12-08-12",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场A12 08排 12座"
    },
    {
        "id": "A12-08-13",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场A12 08排 13座"
    },
    {
        "id": "A12-08-14",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场A12 08排 14座"
    },
    {
        "id": "A12-08-15",
        "areaType": "内场",
        "block": "A12",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场A12 08排 15座"
    },
    {
        "id": "A12-09-01",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场A12 09排 01座"
    },
    {
        "id": "A12-09-02",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场A12 09排 02座"
    },
    {
        "id": "A12-09-03",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场A12 09排 03座"
    },
    {
        "id": "A12-09-04",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场A12 09排 04座"
    },
    {
        "id": "A12-09-05",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场A12 09排 05座"
    },
    {
        "id": "A12-09-06",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场A12 09排 06座"
    },
    {
        "id": "A12-09-07",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场A12 09排 07座"
    },
    {
        "id": "A12-09-08",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场A12 09排 08座"
    },
    {
        "id": "A12-09-09",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场A12 09排 09座"
    },
    {
        "id": "A12-09-10",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场A12 09排 10座"
    },
    {
        "id": "A12-09-11",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场A12 09排 11座"
    },
    {
        "id": "A12-09-12",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场A12 09排 12座"
    },
    {
        "id": "A12-09-13",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场A12 09排 13座"
    },
    {
        "id": "A12-09-14",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场A12 09排 14座"
    },
    {
        "id": "A12-09-15",
        "areaType": "内场",
        "block": "A12",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场A12 09排 15座"
    },
    {
        "id": "A12-10-01",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场A12 10排 01座"
    },
    {
        "id": "A12-10-02",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场A12 10排 02座"
    },
    {
        "id": "A12-10-03",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场A12 10排 03座"
    },
    {
        "id": "A12-10-04",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场A12 10排 04座"
    },
    {
        "id": "A12-10-05",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场A12 10排 05座"
    },
    {
        "id": "A12-10-06",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场A12 10排 06座"
    },
    {
        "id": "A12-10-07",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场A12 10排 07座"
    },
    {
        "id": "A12-10-08",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场A12 10排 08座"
    },
    {
        "id": "A12-10-09",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场A12 10排 09座"
    },
    {
        "id": "A12-10-10",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场A12 10排 10座"
    },
    {
        "id": "A12-10-11",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场A12 10排 11座"
    },
    {
        "id": "A12-10-12",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场A12 10排 12座"
    },
    {
        "id": "A12-10-13",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场A12 10排 13座"
    },
    {
        "id": "A12-10-14",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场A12 10排 14座"
    },
    {
        "id": "A12-10-15",
        "areaType": "内场",
        "block": "A12",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场A12 10排 15座"
    },
    {
        "id": "A13-01-01",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场A13 01排 01座"
    },
    {
        "id": "A13-01-02",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场A13 01排 02座"
    },
    {
        "id": "A13-01-03",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场A13 01排 03座"
    },
    {
        "id": "A13-01-04",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场A13 01排 04座"
    },
    {
        "id": "A13-01-05",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场A13 01排 05座"
    },
    {
        "id": "A13-01-06",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场A13 01排 06座"
    },
    {
        "id": "A13-01-07",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场A13 01排 07座"
    },
    {
        "id": "A13-01-08",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场A13 01排 08座"
    },
    {
        "id": "A13-01-09",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场A13 01排 09座"
    },
    {
        "id": "A13-01-10",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场A13 01排 10座"
    },
    {
        "id": "A13-01-11",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场A13 01排 11座"
    },
    {
        "id": "A13-01-12",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场A13 01排 12座"
    },
    {
        "id": "A13-01-13",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场A13 01排 13座"
    },
    {
        "id": "A13-01-14",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场A13 01排 14座"
    },
    {
        "id": "A13-01-15",
        "areaType": "内场",
        "block": "A13",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场A13 01排 15座"
    },
    {
        "id": "A13-02-01",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场A13 02排 01座"
    },
    {
        "id": "A13-02-02",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场A13 02排 02座"
    },
    {
        "id": "A13-02-03",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场A13 02排 03座"
    },
    {
        "id": "A13-02-04",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场A13 02排 04座"
    },
    {
        "id": "A13-02-05",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场A13 02排 05座"
    },
    {
        "id": "A13-02-06",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场A13 02排 06座"
    },
    {
        "id": "A13-02-07",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场A13 02排 07座"
    },
    {
        "id": "A13-02-08",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场A13 02排 08座"
    },
    {
        "id": "A13-02-09",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场A13 02排 09座"
    },
    {
        "id": "A13-02-10",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场A13 02排 10座"
    },
    {
        "id": "A13-02-11",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场A13 02排 11座"
    },
    {
        "id": "A13-02-12",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场A13 02排 12座"
    },
    {
        "id": "A13-02-13",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场A13 02排 13座"
    },
    {
        "id": "A13-02-14",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场A13 02排 14座"
    },
    {
        "id": "A13-02-15",
        "areaType": "内场",
        "block": "A13",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场A13 02排 15座"
    },
    {
        "id": "A13-03-01",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场A13 03排 01座"
    },
    {
        "id": "A13-03-02",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场A13 03排 02座"
    },
    {
        "id": "A13-03-03",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场A13 03排 03座"
    },
    {
        "id": "A13-03-04",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场A13 03排 04座"
    },
    {
        "id": "A13-03-05",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场A13 03排 05座"
    },
    {
        "id": "A13-03-06",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场A13 03排 06座"
    },
    {
        "id": "A13-03-07",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场A13 03排 07座"
    },
    {
        "id": "A13-03-08",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场A13 03排 08座"
    },
    {
        "id": "A13-03-09",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场A13 03排 09座"
    },
    {
        "id": "A13-03-10",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场A13 03排 10座"
    },
    {
        "id": "A13-03-11",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场A13 03排 11座"
    },
    {
        "id": "A13-03-12",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场A13 03排 12座"
    },
    {
        "id": "A13-03-13",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场A13 03排 13座"
    },
    {
        "id": "A13-03-14",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场A13 03排 14座"
    },
    {
        "id": "A13-03-15",
        "areaType": "内场",
        "block": "A13",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场A13 03排 15座"
    },
    {
        "id": "A13-04-01",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场A13 04排 01座"
    },
    {
        "id": "A13-04-02",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场A13 04排 02座"
    },
    {
        "id": "A13-04-03",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场A13 04排 03座"
    },
    {
        "id": "A13-04-04",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场A13 04排 04座"
    },
    {
        "id": "A13-04-05",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场A13 04排 05座"
    },
    {
        "id": "A13-04-06",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场A13 04排 06座"
    },
    {
        "id": "A13-04-07",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场A13 04排 07座"
    },
    {
        "id": "A13-04-08",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场A13 04排 08座"
    },
    {
        "id": "A13-04-09",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场A13 04排 09座"
    },
    {
        "id": "A13-04-10",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场A13 04排 10座"
    },
    {
        "id": "A13-04-11",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场A13 04排 11座"
    },
    {
        "id": "A13-04-12",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场A13 04排 12座"
    },
    {
        "id": "A13-04-13",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场A13 04排 13座"
    },
    {
        "id": "A13-04-14",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场A13 04排 14座"
    },
    {
        "id": "A13-04-15",
        "areaType": "内场",
        "block": "A13",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场A13 04排 15座"
    },
    {
        "id": "A13-05-01",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场A13 05排 01座"
    },
    {
        "id": "A13-05-02",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场A13 05排 02座"
    },
    {
        "id": "A13-05-03",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场A13 05排 03座"
    },
    {
        "id": "A13-05-04",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场A13 05排 04座"
    },
    {
        "id": "A13-05-05",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场A13 05排 05座"
    },
    {
        "id": "A13-05-06",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场A13 05排 06座"
    },
    {
        "id": "A13-05-07",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场A13 05排 07座"
    },
    {
        "id": "A13-05-08",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场A13 05排 08座"
    },
    {
        "id": "A13-05-09",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场A13 05排 09座"
    },
    {
        "id": "A13-05-10",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场A13 05排 10座"
    },
    {
        "id": "A13-05-11",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场A13 05排 11座"
    },
    {
        "id": "A13-05-12",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场A13 05排 12座"
    },
    {
        "id": "A13-05-13",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场A13 05排 13座"
    },
    {
        "id": "A13-05-14",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场A13 05排 14座"
    },
    {
        "id": "A13-05-15",
        "areaType": "内场",
        "block": "A13",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场A13 05排 15座"
    },
    {
        "id": "A13-06-01",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场A13 06排 01座"
    },
    {
        "id": "A13-06-02",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场A13 06排 02座"
    },
    {
        "id": "A13-06-03",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场A13 06排 03座"
    },
    {
        "id": "A13-06-04",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场A13 06排 04座"
    },
    {
        "id": "A13-06-05",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场A13 06排 05座"
    },
    {
        "id": "A13-06-06",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场A13 06排 06座"
    },
    {
        "id": "A13-06-07",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场A13 06排 07座"
    },
    {
        "id": "A13-06-08",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场A13 06排 08座"
    },
    {
        "id": "A13-06-09",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场A13 06排 09座"
    },
    {
        "id": "A13-06-10",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场A13 06排 10座"
    },
    {
        "id": "A13-06-11",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场A13 06排 11座"
    },
    {
        "id": "A13-06-12",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场A13 06排 12座"
    },
    {
        "id": "A13-06-13",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场A13 06排 13座"
    },
    {
        "id": "A13-06-14",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场A13 06排 14座"
    },
    {
        "id": "A13-06-15",
        "areaType": "内场",
        "block": "A13",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场A13 06排 15座"
    },
    {
        "id": "A13-07-01",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场A13 07排 01座"
    },
    {
        "id": "A13-07-02",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场A13 07排 02座"
    },
    {
        "id": "A13-07-03",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场A13 07排 03座"
    },
    {
        "id": "A13-07-04",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场A13 07排 04座"
    },
    {
        "id": "A13-07-05",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场A13 07排 05座"
    },
    {
        "id": "A13-07-06",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场A13 07排 06座"
    },
    {
        "id": "A13-07-07",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场A13 07排 07座"
    },
    {
        "id": "A13-07-08",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场A13 07排 08座"
    },
    {
        "id": "A13-07-09",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场A13 07排 09座"
    },
    {
        "id": "A13-07-10",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场A13 07排 10座"
    },
    {
        "id": "A13-07-11",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场A13 07排 11座"
    },
    {
        "id": "A13-07-12",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场A13 07排 12座"
    },
    {
        "id": "A13-07-13",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场A13 07排 13座"
    },
    {
        "id": "A13-07-14",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场A13 07排 14座"
    },
    {
        "id": "A13-07-15",
        "areaType": "内场",
        "block": "A13",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场A13 07排 15座"
    },
    {
        "id": "A13-08-01",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场A13 08排 01座"
    },
    {
        "id": "A13-08-02",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场A13 08排 02座"
    },
    {
        "id": "A13-08-03",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场A13 08排 03座"
    },
    {
        "id": "A13-08-04",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场A13 08排 04座"
    },
    {
        "id": "A13-08-05",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场A13 08排 05座"
    },
    {
        "id": "A13-08-06",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场A13 08排 06座"
    },
    {
        "id": "A13-08-07",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场A13 08排 07座"
    },
    {
        "id": "A13-08-08",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场A13 08排 08座"
    },
    {
        "id": "A13-08-09",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场A13 08排 09座"
    },
    {
        "id": "A13-08-10",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场A13 08排 10座"
    },
    {
        "id": "A13-08-11",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场A13 08排 11座"
    },
    {
        "id": "A13-08-12",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场A13 08排 12座"
    },
    {
        "id": "A13-08-13",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场A13 08排 13座"
    },
    {
        "id": "A13-08-14",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场A13 08排 14座"
    },
    {
        "id": "A13-08-15",
        "areaType": "内场",
        "block": "A13",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场A13 08排 15座"
    },
    {
        "id": "A13-09-01",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场A13 09排 01座"
    },
    {
        "id": "A13-09-02",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场A13 09排 02座"
    },
    {
        "id": "A13-09-03",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场A13 09排 03座"
    },
    {
        "id": "A13-09-04",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场A13 09排 04座"
    },
    {
        "id": "A13-09-05",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场A13 09排 05座"
    },
    {
        "id": "A13-09-06",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场A13 09排 06座"
    },
    {
        "id": "A13-09-07",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场A13 09排 07座"
    },
    {
        "id": "A13-09-08",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场A13 09排 08座"
    },
    {
        "id": "A13-09-09",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场A13 09排 09座"
    },
    {
        "id": "A13-09-10",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场A13 09排 10座"
    },
    {
        "id": "A13-09-11",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场A13 09排 11座"
    },
    {
        "id": "A13-09-12",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场A13 09排 12座"
    },
    {
        "id": "A13-09-13",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场A13 09排 13座"
    },
    {
        "id": "A13-09-14",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场A13 09排 14座"
    },
    {
        "id": "A13-09-15",
        "areaType": "内场",
        "block": "A13",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场A13 09排 15座"
    },
    {
        "id": "A13-10-01",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场A13 10排 01座"
    },
    {
        "id": "A13-10-02",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场A13 10排 02座"
    },
    {
        "id": "A13-10-03",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场A13 10排 03座"
    },
    {
        "id": "A13-10-04",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场A13 10排 04座"
    },
    {
        "id": "A13-10-05",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场A13 10排 05座"
    },
    {
        "id": "A13-10-06",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场A13 10排 06座"
    },
    {
        "id": "A13-10-07",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场A13 10排 07座"
    },
    {
        "id": "A13-10-08",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场A13 10排 08座"
    },
    {
        "id": "A13-10-09",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场A13 10排 09座"
    },
    {
        "id": "A13-10-10",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场A13 10排 10座"
    },
    {
        "id": "A13-10-11",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场A13 10排 11座"
    },
    {
        "id": "A13-10-12",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场A13 10排 12座"
    },
    {
        "id": "A13-10-13",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场A13 10排 13座"
    },
    {
        "id": "A13-10-14",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场A13 10排 14座"
    },
    {
        "id": "A13-10-15",
        "areaType": "内场",
        "block": "A13",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场A13 10排 15座"
    },
    {
        "id": "A14-01-01",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场A14 01排 01座"
    },
    {
        "id": "A14-01-02",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场A14 01排 02座"
    },
    {
        "id": "A14-01-03",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场A14 01排 03座"
    },
    {
        "id": "A14-01-04",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场A14 01排 04座"
    },
    {
        "id": "A14-01-05",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场A14 01排 05座"
    },
    {
        "id": "A14-01-06",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场A14 01排 06座"
    },
    {
        "id": "A14-01-07",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场A14 01排 07座"
    },
    {
        "id": "A14-01-08",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场A14 01排 08座"
    },
    {
        "id": "A14-01-09",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场A14 01排 09座"
    },
    {
        "id": "A14-01-10",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场A14 01排 10座"
    },
    {
        "id": "A14-01-11",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场A14 01排 11座"
    },
    {
        "id": "A14-01-12",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场A14 01排 12座"
    },
    {
        "id": "A14-01-13",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场A14 01排 13座"
    },
    {
        "id": "A14-01-14",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场A14 01排 14座"
    },
    {
        "id": "A14-01-15",
        "areaType": "内场",
        "block": "A14",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场A14 01排 15座"
    },
    {
        "id": "A14-02-01",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场A14 02排 01座"
    },
    {
        "id": "A14-02-02",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场A14 02排 02座"
    },
    {
        "id": "A14-02-03",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场A14 02排 03座"
    },
    {
        "id": "A14-02-04",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场A14 02排 04座"
    },
    {
        "id": "A14-02-05",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场A14 02排 05座"
    },
    {
        "id": "A14-02-06",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场A14 02排 06座"
    },
    {
        "id": "A14-02-07",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场A14 02排 07座"
    },
    {
        "id": "A14-02-08",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场A14 02排 08座"
    },
    {
        "id": "A14-02-09",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场A14 02排 09座"
    },
    {
        "id": "A14-02-10",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场A14 02排 10座"
    },
    {
        "id": "A14-02-11",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场A14 02排 11座"
    },
    {
        "id": "A14-02-12",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场A14 02排 12座"
    },
    {
        "id": "A14-02-13",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场A14 02排 13座"
    },
    {
        "id": "A14-02-14",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场A14 02排 14座"
    },
    {
        "id": "A14-02-15",
        "areaType": "内场",
        "block": "A14",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场A14 02排 15座"
    },
    {
        "id": "A14-03-01",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场A14 03排 01座"
    },
    {
        "id": "A14-03-02",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场A14 03排 02座"
    },
    {
        "id": "A14-03-03",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场A14 03排 03座"
    },
    {
        "id": "A14-03-04",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场A14 03排 04座"
    },
    {
        "id": "A14-03-05",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场A14 03排 05座"
    },
    {
        "id": "A14-03-06",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场A14 03排 06座"
    },
    {
        "id": "A14-03-07",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场A14 03排 07座"
    },
    {
        "id": "A14-03-08",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场A14 03排 08座"
    },
    {
        "id": "A14-03-09",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场A14 03排 09座"
    },
    {
        "id": "A14-03-10",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场A14 03排 10座"
    },
    {
        "id": "A14-03-11",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场A14 03排 11座"
    },
    {
        "id": "A14-03-12",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场A14 03排 12座"
    },
    {
        "id": "A14-03-13",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场A14 03排 13座"
    },
    {
        "id": "A14-03-14",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场A14 03排 14座"
    },
    {
        "id": "A14-03-15",
        "areaType": "内场",
        "block": "A14",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场A14 03排 15座"
    },
    {
        "id": "A14-04-01",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场A14 04排 01座"
    },
    {
        "id": "A14-04-02",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场A14 04排 02座"
    },
    {
        "id": "A14-04-03",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场A14 04排 03座"
    },
    {
        "id": "A14-04-04",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场A14 04排 04座"
    },
    {
        "id": "A14-04-05",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场A14 04排 05座"
    },
    {
        "id": "A14-04-06",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场A14 04排 06座"
    },
    {
        "id": "A14-04-07",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场A14 04排 07座"
    },
    {
        "id": "A14-04-08",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场A14 04排 08座"
    },
    {
        "id": "A14-04-09",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场A14 04排 09座"
    },
    {
        "id": "A14-04-10",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场A14 04排 10座"
    },
    {
        "id": "A14-04-11",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场A14 04排 11座"
    },
    {
        "id": "A14-04-12",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场A14 04排 12座"
    },
    {
        "id": "A14-04-13",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场A14 04排 13座"
    },
    {
        "id": "A14-04-14",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场A14 04排 14座"
    },
    {
        "id": "A14-04-15",
        "areaType": "内场",
        "block": "A14",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场A14 04排 15座"
    },
    {
        "id": "A14-05-01",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场A14 05排 01座"
    },
    {
        "id": "A14-05-02",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场A14 05排 02座"
    },
    {
        "id": "A14-05-03",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场A14 05排 03座"
    },
    {
        "id": "A14-05-04",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场A14 05排 04座"
    },
    {
        "id": "A14-05-05",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场A14 05排 05座"
    },
    {
        "id": "A14-05-06",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场A14 05排 06座"
    },
    {
        "id": "A14-05-07",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场A14 05排 07座"
    },
    {
        "id": "A14-05-08",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场A14 05排 08座"
    },
    {
        "id": "A14-05-09",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场A14 05排 09座"
    },
    {
        "id": "A14-05-10",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场A14 05排 10座"
    },
    {
        "id": "A14-05-11",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场A14 05排 11座"
    },
    {
        "id": "A14-05-12",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场A14 05排 12座"
    },
    {
        "id": "A14-05-13",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场A14 05排 13座"
    },
    {
        "id": "A14-05-14",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场A14 05排 14座"
    },
    {
        "id": "A14-05-15",
        "areaType": "内场",
        "block": "A14",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场A14 05排 15座"
    },
    {
        "id": "A14-06-01",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场A14 06排 01座"
    },
    {
        "id": "A14-06-02",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场A14 06排 02座"
    },
    {
        "id": "A14-06-03",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场A14 06排 03座"
    },
    {
        "id": "A14-06-04",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场A14 06排 04座"
    },
    {
        "id": "A14-06-05",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场A14 06排 05座"
    },
    {
        "id": "A14-06-06",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场A14 06排 06座"
    },
    {
        "id": "A14-06-07",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场A14 06排 07座"
    },
    {
        "id": "A14-06-08",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场A14 06排 08座"
    },
    {
        "id": "A14-06-09",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场A14 06排 09座"
    },
    {
        "id": "A14-06-10",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场A14 06排 10座"
    },
    {
        "id": "A14-06-11",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场A14 06排 11座"
    },
    {
        "id": "A14-06-12",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场A14 06排 12座"
    },
    {
        "id": "A14-06-13",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场A14 06排 13座"
    },
    {
        "id": "A14-06-14",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场A14 06排 14座"
    },
    {
        "id": "A14-06-15",
        "areaType": "内场",
        "block": "A14",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场A14 06排 15座"
    },
    {
        "id": "A14-07-01",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场A14 07排 01座"
    },
    {
        "id": "A14-07-02",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场A14 07排 02座"
    },
    {
        "id": "A14-07-03",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场A14 07排 03座"
    },
    {
        "id": "A14-07-04",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场A14 07排 04座"
    },
    {
        "id": "A14-07-05",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场A14 07排 05座"
    },
    {
        "id": "A14-07-06",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场A14 07排 06座"
    },
    {
        "id": "A14-07-07",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场A14 07排 07座"
    },
    {
        "id": "A14-07-08",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场A14 07排 08座"
    },
    {
        "id": "A14-07-09",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场A14 07排 09座"
    },
    {
        "id": "A14-07-10",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场A14 07排 10座"
    },
    {
        "id": "A14-07-11",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场A14 07排 11座"
    },
    {
        "id": "A14-07-12",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场A14 07排 12座"
    },
    {
        "id": "A14-07-13",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场A14 07排 13座"
    },
    {
        "id": "A14-07-14",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场A14 07排 14座"
    },
    {
        "id": "A14-07-15",
        "areaType": "内场",
        "block": "A14",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场A14 07排 15座"
    },
    {
        "id": "A14-08-01",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场A14 08排 01座"
    },
    {
        "id": "A14-08-02",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场A14 08排 02座"
    },
    {
        "id": "A14-08-03",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场A14 08排 03座"
    },
    {
        "id": "A14-08-04",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场A14 08排 04座"
    },
    {
        "id": "A14-08-05",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场A14 08排 05座"
    },
    {
        "id": "A14-08-06",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场A14 08排 06座"
    },
    {
        "id": "A14-08-07",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场A14 08排 07座"
    },
    {
        "id": "A14-08-08",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场A14 08排 08座"
    },
    {
        "id": "A14-08-09",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场A14 08排 09座"
    },
    {
        "id": "A14-08-10",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场A14 08排 10座"
    },
    {
        "id": "A14-08-11",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场A14 08排 11座"
    },
    {
        "id": "A14-08-12",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场A14 08排 12座"
    },
    {
        "id": "A14-08-13",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场A14 08排 13座"
    },
    {
        "id": "A14-08-14",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场A14 08排 14座"
    },
    {
        "id": "A14-08-15",
        "areaType": "内场",
        "block": "A14",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场A14 08排 15座"
    },
    {
        "id": "A14-09-01",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场A14 09排 01座"
    },
    {
        "id": "A14-09-02",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场A14 09排 02座"
    },
    {
        "id": "A14-09-03",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场A14 09排 03座"
    },
    {
        "id": "A14-09-04",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场A14 09排 04座"
    },
    {
        "id": "A14-09-05",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场A14 09排 05座"
    },
    {
        "id": "A14-09-06",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场A14 09排 06座"
    },
    {
        "id": "A14-09-07",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场A14 09排 07座"
    },
    {
        "id": "A14-09-08",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场A14 09排 08座"
    },
    {
        "id": "A14-09-09",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场A14 09排 09座"
    },
    {
        "id": "A14-09-10",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场A14 09排 10座"
    },
    {
        "id": "A14-09-11",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场A14 09排 11座"
    },
    {
        "id": "A14-09-12",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场A14 09排 12座"
    },
    {
        "id": "A14-09-13",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场A14 09排 13座"
    },
    {
        "id": "A14-09-14",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场A14 09排 14座"
    },
    {
        "id": "A14-09-15",
        "areaType": "内场",
        "block": "A14",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场A14 09排 15座"
    },
    {
        "id": "A14-10-01",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场A14 10排 01座"
    },
    {
        "id": "A14-10-02",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场A14 10排 02座"
    },
    {
        "id": "A14-10-03",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场A14 10排 03座"
    },
    {
        "id": "A14-10-04",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场A14 10排 04座"
    },
    {
        "id": "A14-10-05",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场A14 10排 05座"
    },
    {
        "id": "A14-10-06",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场A14 10排 06座"
    },
    {
        "id": "A14-10-07",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场A14 10排 07座"
    },
    {
        "id": "A14-10-08",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场A14 10排 08座"
    },
    {
        "id": "A14-10-09",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场A14 10排 09座"
    },
    {
        "id": "A14-10-10",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场A14 10排 10座"
    },
    {
        "id": "A14-10-11",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场A14 10排 11座"
    },
    {
        "id": "A14-10-12",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场A14 10排 12座"
    },
    {
        "id": "A14-10-13",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场A14 10排 13座"
    },
    {
        "id": "A14-10-14",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场A14 10排 14座"
    },
    {
        "id": "A14-10-15",
        "areaType": "内场",
        "block": "A14",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场A14 10排 15座"
    },
    {
        "id": "A15-01-01",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场A15 01排 01座"
    },
    {
        "id": "A15-01-02",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场A15 01排 02座"
    },
    {
        "id": "A15-01-03",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场A15 01排 03座"
    },
    {
        "id": "A15-01-04",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场A15 01排 04座"
    },
    {
        "id": "A15-01-05",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场A15 01排 05座"
    },
    {
        "id": "A15-01-06",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场A15 01排 06座"
    },
    {
        "id": "A15-01-07",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场A15 01排 07座"
    },
    {
        "id": "A15-01-08",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场A15 01排 08座"
    },
    {
        "id": "A15-01-09",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场A15 01排 09座"
    },
    {
        "id": "A15-01-10",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场A15 01排 10座"
    },
    {
        "id": "A15-01-11",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场A15 01排 11座"
    },
    {
        "id": "A15-01-12",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场A15 01排 12座"
    },
    {
        "id": "A15-01-13",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场A15 01排 13座"
    },
    {
        "id": "A15-01-14",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场A15 01排 14座"
    },
    {
        "id": "A15-01-15",
        "areaType": "内场",
        "block": "A15",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场A15 01排 15座"
    },
    {
        "id": "A15-02-01",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场A15 02排 01座"
    },
    {
        "id": "A15-02-02",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场A15 02排 02座"
    },
    {
        "id": "A15-02-03",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场A15 02排 03座"
    },
    {
        "id": "A15-02-04",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场A15 02排 04座"
    },
    {
        "id": "A15-02-05",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场A15 02排 05座"
    },
    {
        "id": "A15-02-06",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场A15 02排 06座"
    },
    {
        "id": "A15-02-07",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场A15 02排 07座"
    },
    {
        "id": "A15-02-08",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场A15 02排 08座"
    },
    {
        "id": "A15-02-09",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场A15 02排 09座"
    },
    {
        "id": "A15-02-10",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场A15 02排 10座"
    },
    {
        "id": "A15-02-11",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场A15 02排 11座"
    },
    {
        "id": "A15-02-12",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场A15 02排 12座"
    },
    {
        "id": "A15-02-13",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场A15 02排 13座"
    },
    {
        "id": "A15-02-14",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场A15 02排 14座"
    },
    {
        "id": "A15-02-15",
        "areaType": "内场",
        "block": "A15",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场A15 02排 15座"
    },
    {
        "id": "A15-03-01",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场A15 03排 01座"
    },
    {
        "id": "A15-03-02",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场A15 03排 02座"
    },
    {
        "id": "A15-03-03",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场A15 03排 03座"
    },
    {
        "id": "A15-03-04",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场A15 03排 04座"
    },
    {
        "id": "A15-03-05",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场A15 03排 05座"
    },
    {
        "id": "A15-03-06",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场A15 03排 06座"
    },
    {
        "id": "A15-03-07",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场A15 03排 07座"
    },
    {
        "id": "A15-03-08",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场A15 03排 08座"
    },
    {
        "id": "A15-03-09",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场A15 03排 09座"
    },
    {
        "id": "A15-03-10",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场A15 03排 10座"
    },
    {
        "id": "A15-03-11",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场A15 03排 11座"
    },
    {
        "id": "A15-03-12",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场A15 03排 12座"
    },
    {
        "id": "A15-03-13",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场A15 03排 13座"
    },
    {
        "id": "A15-03-14",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场A15 03排 14座"
    },
    {
        "id": "A15-03-15",
        "areaType": "内场",
        "block": "A15",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场A15 03排 15座"
    },
    {
        "id": "A15-04-01",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场A15 04排 01座"
    },
    {
        "id": "A15-04-02",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场A15 04排 02座"
    },
    {
        "id": "A15-04-03",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场A15 04排 03座"
    },
    {
        "id": "A15-04-04",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场A15 04排 04座"
    },
    {
        "id": "A15-04-05",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场A15 04排 05座"
    },
    {
        "id": "A15-04-06",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场A15 04排 06座"
    },
    {
        "id": "A15-04-07",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场A15 04排 07座"
    },
    {
        "id": "A15-04-08",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场A15 04排 08座"
    },
    {
        "id": "A15-04-09",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场A15 04排 09座"
    },
    {
        "id": "A15-04-10",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场A15 04排 10座"
    },
    {
        "id": "A15-04-11",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场A15 04排 11座"
    },
    {
        "id": "A15-04-12",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场A15 04排 12座"
    },
    {
        "id": "A15-04-13",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场A15 04排 13座"
    },
    {
        "id": "A15-04-14",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场A15 04排 14座"
    },
    {
        "id": "A15-04-15",
        "areaType": "内场",
        "block": "A15",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场A15 04排 15座"
    },
    {
        "id": "A15-05-01",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场A15 05排 01座"
    },
    {
        "id": "A15-05-02",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场A15 05排 02座"
    },
    {
        "id": "A15-05-03",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场A15 05排 03座"
    },
    {
        "id": "A15-05-04",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场A15 05排 04座"
    },
    {
        "id": "A15-05-05",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场A15 05排 05座"
    },
    {
        "id": "A15-05-06",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场A15 05排 06座"
    },
    {
        "id": "A15-05-07",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场A15 05排 07座"
    },
    {
        "id": "A15-05-08",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场A15 05排 08座"
    },
    {
        "id": "A15-05-09",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场A15 05排 09座"
    },
    {
        "id": "A15-05-10",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场A15 05排 10座"
    },
    {
        "id": "A15-05-11",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场A15 05排 11座"
    },
    {
        "id": "A15-05-12",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场A15 05排 12座"
    },
    {
        "id": "A15-05-13",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场A15 05排 13座"
    },
    {
        "id": "A15-05-14",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场A15 05排 14座"
    },
    {
        "id": "A15-05-15",
        "areaType": "内场",
        "block": "A15",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场A15 05排 15座"
    },
    {
        "id": "A15-06-01",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场A15 06排 01座"
    },
    {
        "id": "A15-06-02",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场A15 06排 02座"
    },
    {
        "id": "A15-06-03",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场A15 06排 03座"
    },
    {
        "id": "A15-06-04",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场A15 06排 04座"
    },
    {
        "id": "A15-06-05",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场A15 06排 05座"
    },
    {
        "id": "A15-06-06",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场A15 06排 06座"
    },
    {
        "id": "A15-06-07",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场A15 06排 07座"
    },
    {
        "id": "A15-06-08",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场A15 06排 08座"
    },
    {
        "id": "A15-06-09",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场A15 06排 09座"
    },
    {
        "id": "A15-06-10",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场A15 06排 10座"
    },
    {
        "id": "A15-06-11",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场A15 06排 11座"
    },
    {
        "id": "A15-06-12",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场A15 06排 12座"
    },
    {
        "id": "A15-06-13",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场A15 06排 13座"
    },
    {
        "id": "A15-06-14",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场A15 06排 14座"
    },
    {
        "id": "A15-06-15",
        "areaType": "内场",
        "block": "A15",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场A15 06排 15座"
    },
    {
        "id": "A15-07-01",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场A15 07排 01座"
    },
    {
        "id": "A15-07-02",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场A15 07排 02座"
    },
    {
        "id": "A15-07-03",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场A15 07排 03座"
    },
    {
        "id": "A15-07-04",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场A15 07排 04座"
    },
    {
        "id": "A15-07-05",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场A15 07排 05座"
    },
    {
        "id": "A15-07-06",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场A15 07排 06座"
    },
    {
        "id": "A15-07-07",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场A15 07排 07座"
    },
    {
        "id": "A15-07-08",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场A15 07排 08座"
    },
    {
        "id": "A15-07-09",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场A15 07排 09座"
    },
    {
        "id": "A15-07-10",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场A15 07排 10座"
    },
    {
        "id": "A15-07-11",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场A15 07排 11座"
    },
    {
        "id": "A15-07-12",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场A15 07排 12座"
    },
    {
        "id": "A15-07-13",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场A15 07排 13座"
    },
    {
        "id": "A15-07-14",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场A15 07排 14座"
    },
    {
        "id": "A15-07-15",
        "areaType": "内场",
        "block": "A15",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场A15 07排 15座"
    },
    {
        "id": "A15-08-01",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场A15 08排 01座"
    },
    {
        "id": "A15-08-02",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场A15 08排 02座"
    },
    {
        "id": "A15-08-03",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场A15 08排 03座"
    },
    {
        "id": "A15-08-04",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场A15 08排 04座"
    },
    {
        "id": "A15-08-05",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场A15 08排 05座"
    },
    {
        "id": "A15-08-06",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场A15 08排 06座"
    },
    {
        "id": "A15-08-07",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场A15 08排 07座"
    },
    {
        "id": "A15-08-08",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场A15 08排 08座"
    },
    {
        "id": "A15-08-09",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场A15 08排 09座"
    },
    {
        "id": "A15-08-10",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场A15 08排 10座"
    },
    {
        "id": "A15-08-11",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场A15 08排 11座"
    },
    {
        "id": "A15-08-12",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场A15 08排 12座"
    },
    {
        "id": "A15-08-13",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场A15 08排 13座"
    },
    {
        "id": "A15-08-14",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场A15 08排 14座"
    },
    {
        "id": "A15-08-15",
        "areaType": "内场",
        "block": "A15",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场A15 08排 15座"
    },
    {
        "id": "A15-09-01",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场A15 09排 01座"
    },
    {
        "id": "A15-09-02",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场A15 09排 02座"
    },
    {
        "id": "A15-09-03",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场A15 09排 03座"
    },
    {
        "id": "A15-09-04",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场A15 09排 04座"
    },
    {
        "id": "A15-09-05",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场A15 09排 05座"
    },
    {
        "id": "A15-09-06",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场A15 09排 06座"
    },
    {
        "id": "A15-09-07",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场A15 09排 07座"
    },
    {
        "id": "A15-09-08",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场A15 09排 08座"
    },
    {
        "id": "A15-09-09",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场A15 09排 09座"
    },
    {
        "id": "A15-09-10",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场A15 09排 10座"
    },
    {
        "id": "A15-09-11",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场A15 09排 11座"
    },
    {
        "id": "A15-09-12",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场A15 09排 12座"
    },
    {
        "id": "A15-09-13",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场A15 09排 13座"
    },
    {
        "id": "A15-09-14",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场A15 09排 14座"
    },
    {
        "id": "A15-09-15",
        "areaType": "内场",
        "block": "A15",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场A15 09排 15座"
    },
    {
        "id": "A15-10-01",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场A15 10排 01座"
    },
    {
        "id": "A15-10-02",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场A15 10排 02座"
    },
    {
        "id": "A15-10-03",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场A15 10排 03座"
    },
    {
        "id": "A15-10-04",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场A15 10排 04座"
    },
    {
        "id": "A15-10-05",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场A15 10排 05座"
    },
    {
        "id": "A15-10-06",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场A15 10排 06座"
    },
    {
        "id": "A15-10-07",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场A15 10排 07座"
    },
    {
        "id": "A15-10-08",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场A15 10排 08座"
    },
    {
        "id": "A15-10-09",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场A15 10排 09座"
    },
    {
        "id": "A15-10-10",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场A15 10排 10座"
    },
    {
        "id": "A15-10-11",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场A15 10排 11座"
    },
    {
        "id": "A15-10-12",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场A15 10排 12座"
    },
    {
        "id": "A15-10-13",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场A15 10排 13座"
    },
    {
        "id": "A15-10-14",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场A15 10排 14座"
    },
    {
        "id": "A15-10-15",
        "areaType": "内场",
        "block": "A15",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场A15 10排 15座"
    },
    {
        "id": "B1-01-01",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场B1 01排 01座"
    },
    {
        "id": "B1-01-02",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场B1 01排 02座"
    },
    {
        "id": "B1-01-03",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场B1 01排 03座"
    },
    {
        "id": "B1-01-04",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场B1 01排 04座"
    },
    {
        "id": "B1-01-05",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场B1 01排 05座"
    },
    {
        "id": "B1-01-06",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场B1 01排 06座"
    },
    {
        "id": "B1-01-07",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场B1 01排 07座"
    },
    {
        "id": "B1-01-08",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场B1 01排 08座"
    },
    {
        "id": "B1-01-09",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场B1 01排 09座"
    },
    {
        "id": "B1-01-10",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场B1 01排 10座"
    },
    {
        "id": "B1-01-11",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场B1 01排 11座"
    },
    {
        "id": "B1-01-12",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场B1 01排 12座"
    },
    {
        "id": "B1-01-13",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场B1 01排 13座"
    },
    {
        "id": "B1-01-14",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场B1 01排 14座"
    },
    {
        "id": "B1-01-15",
        "areaType": "内场",
        "block": "B1",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场B1 01排 15座"
    },
    {
        "id": "B1-02-01",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场B1 02排 01座"
    },
    {
        "id": "B1-02-02",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场B1 02排 02座"
    },
    {
        "id": "B1-02-03",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场B1 02排 03座"
    },
    {
        "id": "B1-02-04",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场B1 02排 04座"
    },
    {
        "id": "B1-02-05",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场B1 02排 05座"
    },
    {
        "id": "B1-02-06",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场B1 02排 06座"
    },
    {
        "id": "B1-02-07",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场B1 02排 07座"
    },
    {
        "id": "B1-02-08",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场B1 02排 08座"
    },
    {
        "id": "B1-02-09",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场B1 02排 09座"
    },
    {
        "id": "B1-02-10",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场B1 02排 10座"
    },
    {
        "id": "B1-02-11",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场B1 02排 11座"
    },
    {
        "id": "B1-02-12",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场B1 02排 12座"
    },
    {
        "id": "B1-02-13",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场B1 02排 13座"
    },
    {
        "id": "B1-02-14",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场B1 02排 14座"
    },
    {
        "id": "B1-02-15",
        "areaType": "内场",
        "block": "B1",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场B1 02排 15座"
    },
    {
        "id": "B1-03-01",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场B1 03排 01座"
    },
    {
        "id": "B1-03-02",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场B1 03排 02座"
    },
    {
        "id": "B1-03-03",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场B1 03排 03座"
    },
    {
        "id": "B1-03-04",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场B1 03排 04座"
    },
    {
        "id": "B1-03-05",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场B1 03排 05座"
    },
    {
        "id": "B1-03-06",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场B1 03排 06座"
    },
    {
        "id": "B1-03-07",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场B1 03排 07座"
    },
    {
        "id": "B1-03-08",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场B1 03排 08座"
    },
    {
        "id": "B1-03-09",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场B1 03排 09座"
    },
    {
        "id": "B1-03-10",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场B1 03排 10座"
    },
    {
        "id": "B1-03-11",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场B1 03排 11座"
    },
    {
        "id": "B1-03-12",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场B1 03排 12座"
    },
    {
        "id": "B1-03-13",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场B1 03排 13座"
    },
    {
        "id": "B1-03-14",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场B1 03排 14座"
    },
    {
        "id": "B1-03-15",
        "areaType": "内场",
        "block": "B1",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场B1 03排 15座"
    },
    {
        "id": "B1-04-01",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场B1 04排 01座"
    },
    {
        "id": "B1-04-02",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场B1 04排 02座"
    },
    {
        "id": "B1-04-03",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场B1 04排 03座"
    },
    {
        "id": "B1-04-04",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场B1 04排 04座"
    },
    {
        "id": "B1-04-05",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场B1 04排 05座"
    },
    {
        "id": "B1-04-06",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场B1 04排 06座"
    },
    {
        "id": "B1-04-07",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场B1 04排 07座"
    },
    {
        "id": "B1-04-08",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场B1 04排 08座"
    },
    {
        "id": "B1-04-09",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场B1 04排 09座"
    },
    {
        "id": "B1-04-10",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场B1 04排 10座"
    },
    {
        "id": "B1-04-11",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场B1 04排 11座"
    },
    {
        "id": "B1-04-12",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场B1 04排 12座"
    },
    {
        "id": "B1-04-13",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场B1 04排 13座"
    },
    {
        "id": "B1-04-14",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场B1 04排 14座"
    },
    {
        "id": "B1-04-15",
        "areaType": "内场",
        "block": "B1",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场B1 04排 15座"
    },
    {
        "id": "B1-05-01",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场B1 05排 01座"
    },
    {
        "id": "B1-05-02",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场B1 05排 02座"
    },
    {
        "id": "B1-05-03",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场B1 05排 03座"
    },
    {
        "id": "B1-05-04",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场B1 05排 04座"
    },
    {
        "id": "B1-05-05",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场B1 05排 05座"
    },
    {
        "id": "B1-05-06",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场B1 05排 06座"
    },
    {
        "id": "B1-05-07",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场B1 05排 07座"
    },
    {
        "id": "B1-05-08",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场B1 05排 08座"
    },
    {
        "id": "B1-05-09",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场B1 05排 09座"
    },
    {
        "id": "B1-05-10",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场B1 05排 10座"
    },
    {
        "id": "B1-05-11",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场B1 05排 11座"
    },
    {
        "id": "B1-05-12",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场B1 05排 12座"
    },
    {
        "id": "B1-05-13",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场B1 05排 13座"
    },
    {
        "id": "B1-05-14",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场B1 05排 14座"
    },
    {
        "id": "B1-05-15",
        "areaType": "内场",
        "block": "B1",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场B1 05排 15座"
    },
    {
        "id": "B1-06-01",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场B1 06排 01座"
    },
    {
        "id": "B1-06-02",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场B1 06排 02座"
    },
    {
        "id": "B1-06-03",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场B1 06排 03座"
    },
    {
        "id": "B1-06-04",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场B1 06排 04座"
    },
    {
        "id": "B1-06-05",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场B1 06排 05座"
    },
    {
        "id": "B1-06-06",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场B1 06排 06座"
    },
    {
        "id": "B1-06-07",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场B1 06排 07座"
    },
    {
        "id": "B1-06-08",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场B1 06排 08座"
    },
    {
        "id": "B1-06-09",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场B1 06排 09座"
    },
    {
        "id": "B1-06-10",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场B1 06排 10座"
    },
    {
        "id": "B1-06-11",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场B1 06排 11座"
    },
    {
        "id": "B1-06-12",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场B1 06排 12座"
    },
    {
        "id": "B1-06-13",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场B1 06排 13座"
    },
    {
        "id": "B1-06-14",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场B1 06排 14座"
    },
    {
        "id": "B1-06-15",
        "areaType": "内场",
        "block": "B1",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场B1 06排 15座"
    },
    {
        "id": "B1-07-01",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场B1 07排 01座"
    },
    {
        "id": "B1-07-02",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场B1 07排 02座"
    },
    {
        "id": "B1-07-03",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场B1 07排 03座"
    },
    {
        "id": "B1-07-04",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场B1 07排 04座"
    },
    {
        "id": "B1-07-05",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场B1 07排 05座"
    },
    {
        "id": "B1-07-06",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场B1 07排 06座"
    },
    {
        "id": "B1-07-07",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场B1 07排 07座"
    },
    {
        "id": "B1-07-08",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场B1 07排 08座"
    },
    {
        "id": "B1-07-09",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场B1 07排 09座"
    },
    {
        "id": "B1-07-10",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场B1 07排 10座"
    },
    {
        "id": "B1-07-11",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场B1 07排 11座"
    },
    {
        "id": "B1-07-12",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场B1 07排 12座"
    },
    {
        "id": "B1-07-13",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场B1 07排 13座"
    },
    {
        "id": "B1-07-14",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场B1 07排 14座"
    },
    {
        "id": "B1-07-15",
        "areaType": "内场",
        "block": "B1",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场B1 07排 15座"
    },
    {
        "id": "B1-08-01",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场B1 08排 01座"
    },
    {
        "id": "B1-08-02",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场B1 08排 02座"
    },
    {
        "id": "B1-08-03",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场B1 08排 03座"
    },
    {
        "id": "B1-08-04",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场B1 08排 04座"
    },
    {
        "id": "B1-08-05",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场B1 08排 05座"
    },
    {
        "id": "B1-08-06",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场B1 08排 06座"
    },
    {
        "id": "B1-08-07",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场B1 08排 07座"
    },
    {
        "id": "B1-08-08",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场B1 08排 08座"
    },
    {
        "id": "B1-08-09",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场B1 08排 09座"
    },
    {
        "id": "B1-08-10",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场B1 08排 10座"
    },
    {
        "id": "B1-08-11",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场B1 08排 11座"
    },
    {
        "id": "B1-08-12",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场B1 08排 12座"
    },
    {
        "id": "B1-08-13",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场B1 08排 13座"
    },
    {
        "id": "B1-08-14",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场B1 08排 14座"
    },
    {
        "id": "B1-08-15",
        "areaType": "内场",
        "block": "B1",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场B1 08排 15座"
    },
    {
        "id": "B1-09-01",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场B1 09排 01座"
    },
    {
        "id": "B1-09-02",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场B1 09排 02座"
    },
    {
        "id": "B1-09-03",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场B1 09排 03座"
    },
    {
        "id": "B1-09-04",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场B1 09排 04座"
    },
    {
        "id": "B1-09-05",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场B1 09排 05座"
    },
    {
        "id": "B1-09-06",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场B1 09排 06座"
    },
    {
        "id": "B1-09-07",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场B1 09排 07座"
    },
    {
        "id": "B1-09-08",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场B1 09排 08座"
    },
    {
        "id": "B1-09-09",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场B1 09排 09座"
    },
    {
        "id": "B1-09-10",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场B1 09排 10座"
    },
    {
        "id": "B1-09-11",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场B1 09排 11座"
    },
    {
        "id": "B1-09-12",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场B1 09排 12座"
    },
    {
        "id": "B1-09-13",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场B1 09排 13座"
    },
    {
        "id": "B1-09-14",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场B1 09排 14座"
    },
    {
        "id": "B1-09-15",
        "areaType": "内场",
        "block": "B1",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场B1 09排 15座"
    },
    {
        "id": "B1-10-01",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场B1 10排 01座"
    },
    {
        "id": "B1-10-02",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场B1 10排 02座"
    },
    {
        "id": "B1-10-03",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场B1 10排 03座"
    },
    {
        "id": "B1-10-04",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场B1 10排 04座"
    },
    {
        "id": "B1-10-05",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场B1 10排 05座"
    },
    {
        "id": "B1-10-06",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场B1 10排 06座"
    },
    {
        "id": "B1-10-07",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场B1 10排 07座"
    },
    {
        "id": "B1-10-08",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场B1 10排 08座"
    },
    {
        "id": "B1-10-09",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场B1 10排 09座"
    },
    {
        "id": "B1-10-10",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场B1 10排 10座"
    },
    {
        "id": "B1-10-11",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场B1 10排 11座"
    },
    {
        "id": "B1-10-12",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场B1 10排 12座"
    },
    {
        "id": "B1-10-13",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场B1 10排 13座"
    },
    {
        "id": "B1-10-14",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场B1 10排 14座"
    },
    {
        "id": "B1-10-15",
        "areaType": "内场",
        "block": "B1",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场B1 10排 15座"
    },
    {
        "id": "B2-01-01",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场B2 01排 01座"
    },
    {
        "id": "B2-01-02",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场B2 01排 02座"
    },
    {
        "id": "B2-01-03",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场B2 01排 03座"
    },
    {
        "id": "B2-01-04",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场B2 01排 04座"
    },
    {
        "id": "B2-01-05",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场B2 01排 05座"
    },
    {
        "id": "B2-01-06",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场B2 01排 06座"
    },
    {
        "id": "B2-01-07",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场B2 01排 07座"
    },
    {
        "id": "B2-01-08",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场B2 01排 08座"
    },
    {
        "id": "B2-01-09",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场B2 01排 09座"
    },
    {
        "id": "B2-01-10",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场B2 01排 10座"
    },
    {
        "id": "B2-01-11",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场B2 01排 11座"
    },
    {
        "id": "B2-01-12",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场B2 01排 12座"
    },
    {
        "id": "B2-01-13",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场B2 01排 13座"
    },
    {
        "id": "B2-01-14",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场B2 01排 14座"
    },
    {
        "id": "B2-01-15",
        "areaType": "内场",
        "block": "B2",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场B2 01排 15座"
    },
    {
        "id": "B2-02-01",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场B2 02排 01座"
    },
    {
        "id": "B2-02-02",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场B2 02排 02座"
    },
    {
        "id": "B2-02-03",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场B2 02排 03座"
    },
    {
        "id": "B2-02-04",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场B2 02排 04座"
    },
    {
        "id": "B2-02-05",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场B2 02排 05座"
    },
    {
        "id": "B2-02-06",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场B2 02排 06座"
    },
    {
        "id": "B2-02-07",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场B2 02排 07座"
    },
    {
        "id": "B2-02-08",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场B2 02排 08座"
    },
    {
        "id": "B2-02-09",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场B2 02排 09座"
    },
    {
        "id": "B2-02-10",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场B2 02排 10座"
    },
    {
        "id": "B2-02-11",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场B2 02排 11座"
    },
    {
        "id": "B2-02-12",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场B2 02排 12座"
    },
    {
        "id": "B2-02-13",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场B2 02排 13座"
    },
    {
        "id": "B2-02-14",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场B2 02排 14座"
    },
    {
        "id": "B2-02-15",
        "areaType": "内场",
        "block": "B2",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场B2 02排 15座"
    },
    {
        "id": "B2-03-01",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场B2 03排 01座"
    },
    {
        "id": "B2-03-02",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场B2 03排 02座"
    },
    {
        "id": "B2-03-03",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场B2 03排 03座"
    },
    {
        "id": "B2-03-04",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场B2 03排 04座"
    },
    {
        "id": "B2-03-05",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场B2 03排 05座"
    },
    {
        "id": "B2-03-06",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场B2 03排 06座"
    },
    {
        "id": "B2-03-07",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场B2 03排 07座"
    },
    {
        "id": "B2-03-08",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场B2 03排 08座"
    },
    {
        "id": "B2-03-09",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场B2 03排 09座"
    },
    {
        "id": "B2-03-10",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场B2 03排 10座"
    },
    {
        "id": "B2-03-11",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场B2 03排 11座"
    },
    {
        "id": "B2-03-12",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场B2 03排 12座"
    },
    {
        "id": "B2-03-13",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场B2 03排 13座"
    },
    {
        "id": "B2-03-14",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场B2 03排 14座"
    },
    {
        "id": "B2-03-15",
        "areaType": "内场",
        "block": "B2",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场B2 03排 15座"
    },
    {
        "id": "B2-04-01",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场B2 04排 01座"
    },
    {
        "id": "B2-04-02",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场B2 04排 02座"
    },
    {
        "id": "B2-04-03",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场B2 04排 03座"
    },
    {
        "id": "B2-04-04",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场B2 04排 04座"
    },
    {
        "id": "B2-04-05",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场B2 04排 05座"
    },
    {
        "id": "B2-04-06",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场B2 04排 06座"
    },
    {
        "id": "B2-04-07",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场B2 04排 07座"
    },
    {
        "id": "B2-04-08",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场B2 04排 08座"
    },
    {
        "id": "B2-04-09",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场B2 04排 09座"
    },
    {
        "id": "B2-04-10",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场B2 04排 10座"
    },
    {
        "id": "B2-04-11",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场B2 04排 11座"
    },
    {
        "id": "B2-04-12",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场B2 04排 12座"
    },
    {
        "id": "B2-04-13",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场B2 04排 13座"
    },
    {
        "id": "B2-04-14",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场B2 04排 14座"
    },
    {
        "id": "B2-04-15",
        "areaType": "内场",
        "block": "B2",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场B2 04排 15座"
    },
    {
        "id": "B2-05-01",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场B2 05排 01座"
    },
    {
        "id": "B2-05-02",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场B2 05排 02座"
    },
    {
        "id": "B2-05-03",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场B2 05排 03座"
    },
    {
        "id": "B2-05-04",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场B2 05排 04座"
    },
    {
        "id": "B2-05-05",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场B2 05排 05座"
    },
    {
        "id": "B2-05-06",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场B2 05排 06座"
    },
    {
        "id": "B2-05-07",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场B2 05排 07座"
    },
    {
        "id": "B2-05-08",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场B2 05排 08座"
    },
    {
        "id": "B2-05-09",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场B2 05排 09座"
    },
    {
        "id": "B2-05-10",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场B2 05排 10座"
    },
    {
        "id": "B2-05-11",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场B2 05排 11座"
    },
    {
        "id": "B2-05-12",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场B2 05排 12座"
    },
    {
        "id": "B2-05-13",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场B2 05排 13座"
    },
    {
        "id": "B2-05-14",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场B2 05排 14座"
    },
    {
        "id": "B2-05-15",
        "areaType": "内场",
        "block": "B2",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场B2 05排 15座"
    },
    {
        "id": "B2-06-01",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场B2 06排 01座"
    },
    {
        "id": "B2-06-02",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场B2 06排 02座"
    },
    {
        "id": "B2-06-03",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场B2 06排 03座"
    },
    {
        "id": "B2-06-04",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场B2 06排 04座"
    },
    {
        "id": "B2-06-05",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场B2 06排 05座"
    },
    {
        "id": "B2-06-06",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场B2 06排 06座"
    },
    {
        "id": "B2-06-07",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场B2 06排 07座"
    },
    {
        "id": "B2-06-08",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场B2 06排 08座"
    },
    {
        "id": "B2-06-09",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场B2 06排 09座"
    },
    {
        "id": "B2-06-10",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场B2 06排 10座"
    },
    {
        "id": "B2-06-11",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场B2 06排 11座"
    },
    {
        "id": "B2-06-12",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场B2 06排 12座"
    },
    {
        "id": "B2-06-13",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场B2 06排 13座"
    },
    {
        "id": "B2-06-14",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场B2 06排 14座"
    },
    {
        "id": "B2-06-15",
        "areaType": "内场",
        "block": "B2",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场B2 06排 15座"
    },
    {
        "id": "B2-07-01",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场B2 07排 01座"
    },
    {
        "id": "B2-07-02",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场B2 07排 02座"
    },
    {
        "id": "B2-07-03",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场B2 07排 03座"
    },
    {
        "id": "B2-07-04",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场B2 07排 04座"
    },
    {
        "id": "B2-07-05",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场B2 07排 05座"
    },
    {
        "id": "B2-07-06",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场B2 07排 06座"
    },
    {
        "id": "B2-07-07",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场B2 07排 07座"
    },
    {
        "id": "B2-07-08",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场B2 07排 08座"
    },
    {
        "id": "B2-07-09",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场B2 07排 09座"
    },
    {
        "id": "B2-07-10",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场B2 07排 10座"
    },
    {
        "id": "B2-07-11",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场B2 07排 11座"
    },
    {
        "id": "B2-07-12",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场B2 07排 12座"
    },
    {
        "id": "B2-07-13",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场B2 07排 13座"
    },
    {
        "id": "B2-07-14",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场B2 07排 14座"
    },
    {
        "id": "B2-07-15",
        "areaType": "内场",
        "block": "B2",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场B2 07排 15座"
    },
    {
        "id": "B2-08-01",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场B2 08排 01座"
    },
    {
        "id": "B2-08-02",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场B2 08排 02座"
    },
    {
        "id": "B2-08-03",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场B2 08排 03座"
    },
    {
        "id": "B2-08-04",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场B2 08排 04座"
    },
    {
        "id": "B2-08-05",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场B2 08排 05座"
    },
    {
        "id": "B2-08-06",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场B2 08排 06座"
    },
    {
        "id": "B2-08-07",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场B2 08排 07座"
    },
    {
        "id": "B2-08-08",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场B2 08排 08座"
    },
    {
        "id": "B2-08-09",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场B2 08排 09座"
    },
    {
        "id": "B2-08-10",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场B2 08排 10座"
    },
    {
        "id": "B2-08-11",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场B2 08排 11座"
    },
    {
        "id": "B2-08-12",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场B2 08排 12座"
    },
    {
        "id": "B2-08-13",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场B2 08排 13座"
    },
    {
        "id": "B2-08-14",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场B2 08排 14座"
    },
    {
        "id": "B2-08-15",
        "areaType": "内场",
        "block": "B2",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场B2 08排 15座"
    },
    {
        "id": "B2-09-01",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场B2 09排 01座"
    },
    {
        "id": "B2-09-02",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场B2 09排 02座"
    },
    {
        "id": "B2-09-03",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场B2 09排 03座"
    },
    {
        "id": "B2-09-04",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场B2 09排 04座"
    },
    {
        "id": "B2-09-05",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场B2 09排 05座"
    },
    {
        "id": "B2-09-06",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场B2 09排 06座"
    },
    {
        "id": "B2-09-07",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场B2 09排 07座"
    },
    {
        "id": "B2-09-08",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场B2 09排 08座"
    },
    {
        "id": "B2-09-09",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场B2 09排 09座"
    },
    {
        "id": "B2-09-10",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场B2 09排 10座"
    },
    {
        "id": "B2-09-11",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场B2 09排 11座"
    },
    {
        "id": "B2-09-12",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场B2 09排 12座"
    },
    {
        "id": "B2-09-13",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场B2 09排 13座"
    },
    {
        "id": "B2-09-14",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场B2 09排 14座"
    },
    {
        "id": "B2-09-15",
        "areaType": "内场",
        "block": "B2",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场B2 09排 15座"
    },
    {
        "id": "B2-10-01",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场B2 10排 01座"
    },
    {
        "id": "B2-10-02",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场B2 10排 02座"
    },
    {
        "id": "B2-10-03",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场B2 10排 03座"
    },
    {
        "id": "B2-10-04",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场B2 10排 04座"
    },
    {
        "id": "B2-10-05",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场B2 10排 05座"
    },
    {
        "id": "B2-10-06",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场B2 10排 06座"
    },
    {
        "id": "B2-10-07",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场B2 10排 07座"
    },
    {
        "id": "B2-10-08",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场B2 10排 08座"
    },
    {
        "id": "B2-10-09",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场B2 10排 09座"
    },
    {
        "id": "B2-10-10",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场B2 10排 10座"
    },
    {
        "id": "B2-10-11",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场B2 10排 11座"
    },
    {
        "id": "B2-10-12",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场B2 10排 12座"
    },
    {
        "id": "B2-10-13",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场B2 10排 13座"
    },
    {
        "id": "B2-10-14",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场B2 10排 14座"
    },
    {
        "id": "B2-10-15",
        "areaType": "内场",
        "block": "B2",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场B2 10排 15座"
    },
    {
        "id": "B3-01-01",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场B3 01排 01座"
    },
    {
        "id": "B3-01-02",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场B3 01排 02座"
    },
    {
        "id": "B3-01-03",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场B3 01排 03座"
    },
    {
        "id": "B3-01-04",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场B3 01排 04座"
    },
    {
        "id": "B3-01-05",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场B3 01排 05座"
    },
    {
        "id": "B3-01-06",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场B3 01排 06座"
    },
    {
        "id": "B3-01-07",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场B3 01排 07座"
    },
    {
        "id": "B3-01-08",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场B3 01排 08座"
    },
    {
        "id": "B3-01-09",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场B3 01排 09座"
    },
    {
        "id": "B3-01-10",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场B3 01排 10座"
    },
    {
        "id": "B3-01-11",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场B3 01排 11座"
    },
    {
        "id": "B3-01-12",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场B3 01排 12座"
    },
    {
        "id": "B3-01-13",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场B3 01排 13座"
    },
    {
        "id": "B3-01-14",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场B3 01排 14座"
    },
    {
        "id": "B3-01-15",
        "areaType": "内场",
        "block": "B3",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场B3 01排 15座"
    },
    {
        "id": "B3-02-01",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场B3 02排 01座"
    },
    {
        "id": "B3-02-02",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场B3 02排 02座"
    },
    {
        "id": "B3-02-03",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场B3 02排 03座"
    },
    {
        "id": "B3-02-04",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场B3 02排 04座"
    },
    {
        "id": "B3-02-05",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场B3 02排 05座"
    },
    {
        "id": "B3-02-06",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场B3 02排 06座"
    },
    {
        "id": "B3-02-07",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场B3 02排 07座"
    },
    {
        "id": "B3-02-08",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场B3 02排 08座"
    },
    {
        "id": "B3-02-09",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场B3 02排 09座"
    },
    {
        "id": "B3-02-10",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场B3 02排 10座"
    },
    {
        "id": "B3-02-11",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场B3 02排 11座"
    },
    {
        "id": "B3-02-12",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场B3 02排 12座"
    },
    {
        "id": "B3-02-13",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场B3 02排 13座"
    },
    {
        "id": "B3-02-14",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场B3 02排 14座"
    },
    {
        "id": "B3-02-15",
        "areaType": "内场",
        "block": "B3",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场B3 02排 15座"
    },
    {
        "id": "B3-03-01",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场B3 03排 01座"
    },
    {
        "id": "B3-03-02",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场B3 03排 02座"
    },
    {
        "id": "B3-03-03",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场B3 03排 03座"
    },
    {
        "id": "B3-03-04",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场B3 03排 04座"
    },
    {
        "id": "B3-03-05",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场B3 03排 05座"
    },
    {
        "id": "B3-03-06",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场B3 03排 06座"
    },
    {
        "id": "B3-03-07",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场B3 03排 07座"
    },
    {
        "id": "B3-03-08",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场B3 03排 08座"
    },
    {
        "id": "B3-03-09",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场B3 03排 09座"
    },
    {
        "id": "B3-03-10",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场B3 03排 10座"
    },
    {
        "id": "B3-03-11",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场B3 03排 11座"
    },
    {
        "id": "B3-03-12",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场B3 03排 12座"
    },
    {
        "id": "B3-03-13",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场B3 03排 13座"
    },
    {
        "id": "B3-03-14",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场B3 03排 14座"
    },
    {
        "id": "B3-03-15",
        "areaType": "内场",
        "block": "B3",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场B3 03排 15座"
    },
    {
        "id": "B3-04-01",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场B3 04排 01座"
    },
    {
        "id": "B3-04-02",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场B3 04排 02座"
    },
    {
        "id": "B3-04-03",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场B3 04排 03座"
    },
    {
        "id": "B3-04-04",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场B3 04排 04座"
    },
    {
        "id": "B3-04-05",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场B3 04排 05座"
    },
    {
        "id": "B3-04-06",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场B3 04排 06座"
    },
    {
        "id": "B3-04-07",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场B3 04排 07座"
    },
    {
        "id": "B3-04-08",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场B3 04排 08座"
    },
    {
        "id": "B3-04-09",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场B3 04排 09座"
    },
    {
        "id": "B3-04-10",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场B3 04排 10座"
    },
    {
        "id": "B3-04-11",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场B3 04排 11座"
    },
    {
        "id": "B3-04-12",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场B3 04排 12座"
    },
    {
        "id": "B3-04-13",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场B3 04排 13座"
    },
    {
        "id": "B3-04-14",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场B3 04排 14座"
    },
    {
        "id": "B3-04-15",
        "areaType": "内场",
        "block": "B3",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场B3 04排 15座"
    },
    {
        "id": "B3-05-01",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场B3 05排 01座"
    },
    {
        "id": "B3-05-02",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场B3 05排 02座"
    },
    {
        "id": "B3-05-03",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场B3 05排 03座"
    },
    {
        "id": "B3-05-04",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场B3 05排 04座"
    },
    {
        "id": "B3-05-05",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场B3 05排 05座"
    },
    {
        "id": "B3-05-06",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场B3 05排 06座"
    },
    {
        "id": "B3-05-07",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场B3 05排 07座"
    },
    {
        "id": "B3-05-08",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场B3 05排 08座"
    },
    {
        "id": "B3-05-09",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场B3 05排 09座"
    },
    {
        "id": "B3-05-10",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场B3 05排 10座"
    },
    {
        "id": "B3-05-11",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场B3 05排 11座"
    },
    {
        "id": "B3-05-12",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场B3 05排 12座"
    },
    {
        "id": "B3-05-13",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场B3 05排 13座"
    },
    {
        "id": "B3-05-14",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场B3 05排 14座"
    },
    {
        "id": "B3-05-15",
        "areaType": "内场",
        "block": "B3",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场B3 05排 15座"
    },
    {
        "id": "B3-06-01",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场B3 06排 01座"
    },
    {
        "id": "B3-06-02",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场B3 06排 02座"
    },
    {
        "id": "B3-06-03",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场B3 06排 03座"
    },
    {
        "id": "B3-06-04",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场B3 06排 04座"
    },
    {
        "id": "B3-06-05",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场B3 06排 05座"
    },
    {
        "id": "B3-06-06",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场B3 06排 06座"
    },
    {
        "id": "B3-06-07",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场B3 06排 07座"
    },
    {
        "id": "B3-06-08",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场B3 06排 08座"
    },
    {
        "id": "B3-06-09",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场B3 06排 09座"
    },
    {
        "id": "B3-06-10",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场B3 06排 10座"
    },
    {
        "id": "B3-06-11",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场B3 06排 11座"
    },
    {
        "id": "B3-06-12",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场B3 06排 12座"
    },
    {
        "id": "B3-06-13",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场B3 06排 13座"
    },
    {
        "id": "B3-06-14",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场B3 06排 14座"
    },
    {
        "id": "B3-06-15",
        "areaType": "内场",
        "block": "B3",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场B3 06排 15座"
    },
    {
        "id": "B3-07-01",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场B3 07排 01座"
    },
    {
        "id": "B3-07-02",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场B3 07排 02座"
    },
    {
        "id": "B3-07-03",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场B3 07排 03座"
    },
    {
        "id": "B3-07-04",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场B3 07排 04座"
    },
    {
        "id": "B3-07-05",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场B3 07排 05座"
    },
    {
        "id": "B3-07-06",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场B3 07排 06座"
    },
    {
        "id": "B3-07-07",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场B3 07排 07座"
    },
    {
        "id": "B3-07-08",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场B3 07排 08座"
    },
    {
        "id": "B3-07-09",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场B3 07排 09座"
    },
    {
        "id": "B3-07-10",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场B3 07排 10座"
    },
    {
        "id": "B3-07-11",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场B3 07排 11座"
    },
    {
        "id": "B3-07-12",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场B3 07排 12座"
    },
    {
        "id": "B3-07-13",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场B3 07排 13座"
    },
    {
        "id": "B3-07-14",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场B3 07排 14座"
    },
    {
        "id": "B3-07-15",
        "areaType": "内场",
        "block": "B3",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场B3 07排 15座"
    },
    {
        "id": "B3-08-01",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场B3 08排 01座"
    },
    {
        "id": "B3-08-02",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场B3 08排 02座"
    },
    {
        "id": "B3-08-03",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场B3 08排 03座"
    },
    {
        "id": "B3-08-04",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场B3 08排 04座"
    },
    {
        "id": "B3-08-05",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场B3 08排 05座"
    },
    {
        "id": "B3-08-06",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场B3 08排 06座"
    },
    {
        "id": "B3-08-07",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场B3 08排 07座"
    },
    {
        "id": "B3-08-08",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场B3 08排 08座"
    },
    {
        "id": "B3-08-09",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场B3 08排 09座"
    },
    {
        "id": "B3-08-10",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场B3 08排 10座"
    },
    {
        "id": "B3-08-11",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场B3 08排 11座"
    },
    {
        "id": "B3-08-12",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场B3 08排 12座"
    },
    {
        "id": "B3-08-13",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场B3 08排 13座"
    },
    {
        "id": "B3-08-14",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场B3 08排 14座"
    },
    {
        "id": "B3-08-15",
        "areaType": "内场",
        "block": "B3",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场B3 08排 15座"
    },
    {
        "id": "B3-09-01",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场B3 09排 01座"
    },
    {
        "id": "B3-09-02",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场B3 09排 02座"
    },
    {
        "id": "B3-09-03",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场B3 09排 03座"
    },
    {
        "id": "B3-09-04",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场B3 09排 04座"
    },
    {
        "id": "B3-09-05",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场B3 09排 05座"
    },
    {
        "id": "B3-09-06",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场B3 09排 06座"
    },
    {
        "id": "B3-09-07",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场B3 09排 07座"
    },
    {
        "id": "B3-09-08",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场B3 09排 08座"
    },
    {
        "id": "B3-09-09",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场B3 09排 09座"
    },
    {
        "id": "B3-09-10",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场B3 09排 10座"
    },
    {
        "id": "B3-09-11",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场B3 09排 11座"
    },
    {
        "id": "B3-09-12",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场B3 09排 12座"
    },
    {
        "id": "B3-09-13",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场B3 09排 13座"
    },
    {
        "id": "B3-09-14",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场B3 09排 14座"
    },
    {
        "id": "B3-09-15",
        "areaType": "内场",
        "block": "B3",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场B3 09排 15座"
    },
    {
        "id": "B3-10-01",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场B3 10排 01座"
    },
    {
        "id": "B3-10-02",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场B3 10排 02座"
    },
    {
        "id": "B3-10-03",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场B3 10排 03座"
    },
    {
        "id": "B3-10-04",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场B3 10排 04座"
    },
    {
        "id": "B3-10-05",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场B3 10排 05座"
    },
    {
        "id": "B3-10-06",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场B3 10排 06座"
    },
    {
        "id": "B3-10-07",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场B3 10排 07座"
    },
    {
        "id": "B3-10-08",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场B3 10排 08座"
    },
    {
        "id": "B3-10-09",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场B3 10排 09座"
    },
    {
        "id": "B3-10-10",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场B3 10排 10座"
    },
    {
        "id": "B3-10-11",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场B3 10排 11座"
    },
    {
        "id": "B3-10-12",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场B3 10排 12座"
    },
    {
        "id": "B3-10-13",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场B3 10排 13座"
    },
    {
        "id": "B3-10-14",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场B3 10排 14座"
    },
    {
        "id": "B3-10-15",
        "areaType": "内场",
        "block": "B3",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场B3 10排 15座"
    },
    {
        "id": "B4-01-01",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "内场B4 01排 01座"
    },
    {
        "id": "B4-01-02",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "内场B4 01排 02座"
    },
    {
        "id": "B4-01-03",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "内场B4 01排 03座"
    },
    {
        "id": "B4-01-04",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "内场B4 01排 04座"
    },
    {
        "id": "B4-01-05",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "内场B4 01排 05座"
    },
    {
        "id": "B4-01-06",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "内场B4 01排 06座"
    },
    {
        "id": "B4-01-07",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "内场B4 01排 07座"
    },
    {
        "id": "B4-01-08",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "内场B4 01排 08座"
    },
    {
        "id": "B4-01-09",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "内场B4 01排 09座"
    },
    {
        "id": "B4-01-10",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "内场B4 01排 10座"
    },
    {
        "id": "B4-01-11",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "内场B4 01排 11座"
    },
    {
        "id": "B4-01-12",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "内场B4 01排 12座"
    },
    {
        "id": "B4-01-13",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "内场B4 01排 13座"
    },
    {
        "id": "B4-01-14",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "内场B4 01排 14座"
    },
    {
        "id": "B4-01-15",
        "areaType": "内场",
        "block": "B4",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "内场B4 01排 15座"
    },
    {
        "id": "B4-02-01",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "内场B4 02排 01座"
    },
    {
        "id": "B4-02-02",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "内场B4 02排 02座"
    },
    {
        "id": "B4-02-03",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "内场B4 02排 03座"
    },
    {
        "id": "B4-02-04",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "内场B4 02排 04座"
    },
    {
        "id": "B4-02-05",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "内场B4 02排 05座"
    },
    {
        "id": "B4-02-06",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "内场B4 02排 06座"
    },
    {
        "id": "B4-02-07",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "内场B4 02排 07座"
    },
    {
        "id": "B4-02-08",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "内场B4 02排 08座"
    },
    {
        "id": "B4-02-09",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "内场B4 02排 09座"
    },
    {
        "id": "B4-02-10",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "内场B4 02排 10座"
    },
    {
        "id": "B4-02-11",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "内场B4 02排 11座"
    },
    {
        "id": "B4-02-12",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "内场B4 02排 12座"
    },
    {
        "id": "B4-02-13",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "内场B4 02排 13座"
    },
    {
        "id": "B4-02-14",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "内场B4 02排 14座"
    },
    {
        "id": "B4-02-15",
        "areaType": "内场",
        "block": "B4",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "内场B4 02排 15座"
    },
    {
        "id": "B4-03-01",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "内场B4 03排 01座"
    },
    {
        "id": "B4-03-02",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "内场B4 03排 02座"
    },
    {
        "id": "B4-03-03",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "内场B4 03排 03座"
    },
    {
        "id": "B4-03-04",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "内场B4 03排 04座"
    },
    {
        "id": "B4-03-05",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "内场B4 03排 05座"
    },
    {
        "id": "B4-03-06",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "内场B4 03排 06座"
    },
    {
        "id": "B4-03-07",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "内场B4 03排 07座"
    },
    {
        "id": "B4-03-08",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "内场B4 03排 08座"
    },
    {
        "id": "B4-03-09",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "内场B4 03排 09座"
    },
    {
        "id": "B4-03-10",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "内场B4 03排 10座"
    },
    {
        "id": "B4-03-11",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "内场B4 03排 11座"
    },
    {
        "id": "B4-03-12",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "内场B4 03排 12座"
    },
    {
        "id": "B4-03-13",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "内场B4 03排 13座"
    },
    {
        "id": "B4-03-14",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "内场B4 03排 14座"
    },
    {
        "id": "B4-03-15",
        "areaType": "内场",
        "block": "B4",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "内场B4 03排 15座"
    },
    {
        "id": "B4-04-01",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "内场B4 04排 01座"
    },
    {
        "id": "B4-04-02",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "内场B4 04排 02座"
    },
    {
        "id": "B4-04-03",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "内场B4 04排 03座"
    },
    {
        "id": "B4-04-04",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "内场B4 04排 04座"
    },
    {
        "id": "B4-04-05",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "内场B4 04排 05座"
    },
    {
        "id": "B4-04-06",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "内场B4 04排 06座"
    },
    {
        "id": "B4-04-07",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "内场B4 04排 07座"
    },
    {
        "id": "B4-04-08",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "内场B4 04排 08座"
    },
    {
        "id": "B4-04-09",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "内场B4 04排 09座"
    },
    {
        "id": "B4-04-10",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "内场B4 04排 10座"
    },
    {
        "id": "B4-04-11",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "内场B4 04排 11座"
    },
    {
        "id": "B4-04-12",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "内场B4 04排 12座"
    },
    {
        "id": "B4-04-13",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "内场B4 04排 13座"
    },
    {
        "id": "B4-04-14",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "内场B4 04排 14座"
    },
    {
        "id": "B4-04-15",
        "areaType": "内场",
        "block": "B4",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "内场B4 04排 15座"
    },
    {
        "id": "B4-05-01",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "内场B4 05排 01座"
    },
    {
        "id": "B4-05-02",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "内场B4 05排 02座"
    },
    {
        "id": "B4-05-03",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "内场B4 05排 03座"
    },
    {
        "id": "B4-05-04",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "内场B4 05排 04座"
    },
    {
        "id": "B4-05-05",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "内场B4 05排 05座"
    },
    {
        "id": "B4-05-06",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "内场B4 05排 06座"
    },
    {
        "id": "B4-05-07",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "内场B4 05排 07座"
    },
    {
        "id": "B4-05-08",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "内场B4 05排 08座"
    },
    {
        "id": "B4-05-09",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "内场B4 05排 09座"
    },
    {
        "id": "B4-05-10",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "内场B4 05排 10座"
    },
    {
        "id": "B4-05-11",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "内场B4 05排 11座"
    },
    {
        "id": "B4-05-12",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "内场B4 05排 12座"
    },
    {
        "id": "B4-05-13",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "内场B4 05排 13座"
    },
    {
        "id": "B4-05-14",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "内场B4 05排 14座"
    },
    {
        "id": "B4-05-15",
        "areaType": "内场",
        "block": "B4",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "内场B4 05排 15座"
    },
    {
        "id": "B4-06-01",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "内场B4 06排 01座"
    },
    {
        "id": "B4-06-02",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "内场B4 06排 02座"
    },
    {
        "id": "B4-06-03",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "内场B4 06排 03座"
    },
    {
        "id": "B4-06-04",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "内场B4 06排 04座"
    },
    {
        "id": "B4-06-05",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "内场B4 06排 05座"
    },
    {
        "id": "B4-06-06",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "内场B4 06排 06座"
    },
    {
        "id": "B4-06-07",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "内场B4 06排 07座"
    },
    {
        "id": "B4-06-08",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "内场B4 06排 08座"
    },
    {
        "id": "B4-06-09",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "内场B4 06排 09座"
    },
    {
        "id": "B4-06-10",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "内场B4 06排 10座"
    },
    {
        "id": "B4-06-11",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "内场B4 06排 11座"
    },
    {
        "id": "B4-06-12",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "内场B4 06排 12座"
    },
    {
        "id": "B4-06-13",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "内场B4 06排 13座"
    },
    {
        "id": "B4-06-14",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "内场B4 06排 14座"
    },
    {
        "id": "B4-06-15",
        "areaType": "内场",
        "block": "B4",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "内场B4 06排 15座"
    },
    {
        "id": "B4-07-01",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "内场B4 07排 01座"
    },
    {
        "id": "B4-07-02",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "内场B4 07排 02座"
    },
    {
        "id": "B4-07-03",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "内场B4 07排 03座"
    },
    {
        "id": "B4-07-04",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "内场B4 07排 04座"
    },
    {
        "id": "B4-07-05",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "内场B4 07排 05座"
    },
    {
        "id": "B4-07-06",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "内场B4 07排 06座"
    },
    {
        "id": "B4-07-07",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "内场B4 07排 07座"
    },
    {
        "id": "B4-07-08",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "内场B4 07排 08座"
    },
    {
        "id": "B4-07-09",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "内场B4 07排 09座"
    },
    {
        "id": "B4-07-10",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "内场B4 07排 10座"
    },
    {
        "id": "B4-07-11",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "内场B4 07排 11座"
    },
    {
        "id": "B4-07-12",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "内场B4 07排 12座"
    },
    {
        "id": "B4-07-13",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "内场B4 07排 13座"
    },
    {
        "id": "B4-07-14",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "内场B4 07排 14座"
    },
    {
        "id": "B4-07-15",
        "areaType": "内场",
        "block": "B4",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "内场B4 07排 15座"
    },
    {
        "id": "B4-08-01",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "内场B4 08排 01座"
    },
    {
        "id": "B4-08-02",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "内场B4 08排 02座"
    },
    {
        "id": "B4-08-03",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "内场B4 08排 03座"
    },
    {
        "id": "B4-08-04",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "内场B4 08排 04座"
    },
    {
        "id": "B4-08-05",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "内场B4 08排 05座"
    },
    {
        "id": "B4-08-06",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "内场B4 08排 06座"
    },
    {
        "id": "B4-08-07",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "内场B4 08排 07座"
    },
    {
        "id": "B4-08-08",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "内场B4 08排 08座"
    },
    {
        "id": "B4-08-09",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "内场B4 08排 09座"
    },
    {
        "id": "B4-08-10",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "内场B4 08排 10座"
    },
    {
        "id": "B4-08-11",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "内场B4 08排 11座"
    },
    {
        "id": "B4-08-12",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "内场B4 08排 12座"
    },
    {
        "id": "B4-08-13",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "内场B4 08排 13座"
    },
    {
        "id": "B4-08-14",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "内场B4 08排 14座"
    },
    {
        "id": "B4-08-15",
        "areaType": "内场",
        "block": "B4",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "内场B4 08排 15座"
    },
    {
        "id": "B4-09-01",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "内场B4 09排 01座"
    },
    {
        "id": "B4-09-02",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "内场B4 09排 02座"
    },
    {
        "id": "B4-09-03",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "内场B4 09排 03座"
    },
    {
        "id": "B4-09-04",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "内场B4 09排 04座"
    },
    {
        "id": "B4-09-05",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "内场B4 09排 05座"
    },
    {
        "id": "B4-09-06",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "内场B4 09排 06座"
    },
    {
        "id": "B4-09-07",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "内场B4 09排 07座"
    },
    {
        "id": "B4-09-08",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "内场B4 09排 08座"
    },
    {
        "id": "B4-09-09",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "内场B4 09排 09座"
    },
    {
        "id": "B4-09-10",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "内场B4 09排 10座"
    },
    {
        "id": "B4-09-11",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "内场B4 09排 11座"
    },
    {
        "id": "B4-09-12",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "内场B4 09排 12座"
    },
    {
        "id": "B4-09-13",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "内场B4 09排 13座"
    },
    {
        "id": "B4-09-14",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "内场B4 09排 14座"
    },
    {
        "id": "B4-09-15",
        "areaType": "内场",
        "block": "B4",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "内场B4 09排 15座"
    },
    {
        "id": "B4-10-01",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "内场B4 10排 01座"
    },
    {
        "id": "B4-10-02",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "内场B4 10排 02座"
    },
    {
        "id": "B4-10-03",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "内场B4 10排 03座"
    },
    {
        "id": "B4-10-04",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "内场B4 10排 04座"
    },
    {
        "id": "B4-10-05",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "内场B4 10排 05座"
    },
    {
        "id": "B4-10-06",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "内场B4 10排 06座"
    },
    {
        "id": "B4-10-07",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "内场B4 10排 07座"
    },
    {
        "id": "B4-10-08",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "内场B4 10排 08座"
    },
    {
        "id": "B4-10-09",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "内场B4 10排 09座"
    },
    {
        "id": "B4-10-10",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "内场B4 10排 10座"
    },
    {
        "id": "B4-10-11",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "内场B4 10排 11座"
    },
    {
        "id": "B4-10-12",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "内场B4 10排 12座"
    },
    {
        "id": "B4-10-13",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "内场B4 10排 13座"
    },
    {
        "id": "B4-10-14",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "内场B4 10排 14座"
    },
    {
        "id": "B4-10-15",
        "areaType": "内场",
        "block": "B4",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "内场B4 10排 15座"
    },
    {
        "id": "C102-01-01",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台C102 01排 01座"
    },
    {
        "id": "C102-01-02",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台C102 01排 02座"
    },
    {
        "id": "C102-01-03",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台C102 01排 03座"
    },
    {
        "id": "C102-01-04",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台C102 01排 04座"
    },
    {
        "id": "C102-01-05",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台C102 01排 05座"
    },
    {
        "id": "C102-01-06",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台C102 01排 06座"
    },
    {
        "id": "C102-01-07",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台C102 01排 07座"
    },
    {
        "id": "C102-01-08",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台C102 01排 08座"
    },
    {
        "id": "C102-01-09",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台C102 01排 09座"
    },
    {
        "id": "C102-01-10",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台C102 01排 10座"
    },
    {
        "id": "C102-01-11",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台C102 01排 11座"
    },
    {
        "id": "C102-01-12",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台C102 01排 12座"
    },
    {
        "id": "C102-01-13",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台C102 01排 13座"
    },
    {
        "id": "C102-01-14",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台C102 01排 14座"
    },
    {
        "id": "C102-01-15",
        "areaType": "看台",
        "block": "C102",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台C102 01排 15座"
    },
    {
        "id": "C102-02-01",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台C102 02排 01座"
    },
    {
        "id": "C102-02-02",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台C102 02排 02座"
    },
    {
        "id": "C102-02-03",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台C102 02排 03座"
    },
    {
        "id": "C102-02-04",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台C102 02排 04座"
    },
    {
        "id": "C102-02-05",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台C102 02排 05座"
    },
    {
        "id": "C102-02-06",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台C102 02排 06座"
    },
    {
        "id": "C102-02-07",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台C102 02排 07座"
    },
    {
        "id": "C102-02-08",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台C102 02排 08座"
    },
    {
        "id": "C102-02-09",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台C102 02排 09座"
    },
    {
        "id": "C102-02-10",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台C102 02排 10座"
    },
    {
        "id": "C102-02-11",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台C102 02排 11座"
    },
    {
        "id": "C102-02-12",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台C102 02排 12座"
    },
    {
        "id": "C102-02-13",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台C102 02排 13座"
    },
    {
        "id": "C102-02-14",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台C102 02排 14座"
    },
    {
        "id": "C102-02-15",
        "areaType": "看台",
        "block": "C102",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台C102 02排 15座"
    },
    {
        "id": "C102-03-01",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台C102 03排 01座"
    },
    {
        "id": "C102-03-02",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台C102 03排 02座"
    },
    {
        "id": "C102-03-03",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台C102 03排 03座"
    },
    {
        "id": "C102-03-04",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台C102 03排 04座"
    },
    {
        "id": "C102-03-05",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台C102 03排 05座"
    },
    {
        "id": "C102-03-06",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台C102 03排 06座"
    },
    {
        "id": "C102-03-07",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台C102 03排 07座"
    },
    {
        "id": "C102-03-08",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台C102 03排 08座"
    },
    {
        "id": "C102-03-09",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台C102 03排 09座"
    },
    {
        "id": "C102-03-10",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台C102 03排 10座"
    },
    {
        "id": "C102-03-11",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台C102 03排 11座"
    },
    {
        "id": "C102-03-12",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台C102 03排 12座"
    },
    {
        "id": "C102-03-13",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台C102 03排 13座"
    },
    {
        "id": "C102-03-14",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台C102 03排 14座"
    },
    {
        "id": "C102-03-15",
        "areaType": "看台",
        "block": "C102",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台C102 03排 15座"
    },
    {
        "id": "C102-04-01",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台C102 04排 01座"
    },
    {
        "id": "C102-04-02",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台C102 04排 02座"
    },
    {
        "id": "C102-04-03",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台C102 04排 03座"
    },
    {
        "id": "C102-04-04",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台C102 04排 04座"
    },
    {
        "id": "C102-04-05",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台C102 04排 05座"
    },
    {
        "id": "C102-04-06",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台C102 04排 06座"
    },
    {
        "id": "C102-04-07",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台C102 04排 07座"
    },
    {
        "id": "C102-04-08",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台C102 04排 08座"
    },
    {
        "id": "C102-04-09",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台C102 04排 09座"
    },
    {
        "id": "C102-04-10",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台C102 04排 10座"
    },
    {
        "id": "C102-04-11",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台C102 04排 11座"
    },
    {
        "id": "C102-04-12",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台C102 04排 12座"
    },
    {
        "id": "C102-04-13",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台C102 04排 13座"
    },
    {
        "id": "C102-04-14",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台C102 04排 14座"
    },
    {
        "id": "C102-04-15",
        "areaType": "看台",
        "block": "C102",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台C102 04排 15座"
    },
    {
        "id": "C102-05-01",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台C102 05排 01座"
    },
    {
        "id": "C102-05-02",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台C102 05排 02座"
    },
    {
        "id": "C102-05-03",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台C102 05排 03座"
    },
    {
        "id": "C102-05-04",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台C102 05排 04座"
    },
    {
        "id": "C102-05-05",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台C102 05排 05座"
    },
    {
        "id": "C102-05-06",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台C102 05排 06座"
    },
    {
        "id": "C102-05-07",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台C102 05排 07座"
    },
    {
        "id": "C102-05-08",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台C102 05排 08座"
    },
    {
        "id": "C102-05-09",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台C102 05排 09座"
    },
    {
        "id": "C102-05-10",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台C102 05排 10座"
    },
    {
        "id": "C102-05-11",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台C102 05排 11座"
    },
    {
        "id": "C102-05-12",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台C102 05排 12座"
    },
    {
        "id": "C102-05-13",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台C102 05排 13座"
    },
    {
        "id": "C102-05-14",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台C102 05排 14座"
    },
    {
        "id": "C102-05-15",
        "areaType": "看台",
        "block": "C102",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台C102 05排 15座"
    },
    {
        "id": "C102-06-01",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台C102 06排 01座"
    },
    {
        "id": "C102-06-02",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台C102 06排 02座"
    },
    {
        "id": "C102-06-03",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台C102 06排 03座"
    },
    {
        "id": "C102-06-04",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台C102 06排 04座"
    },
    {
        "id": "C102-06-05",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台C102 06排 05座"
    },
    {
        "id": "C102-06-06",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台C102 06排 06座"
    },
    {
        "id": "C102-06-07",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台C102 06排 07座"
    },
    {
        "id": "C102-06-08",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台C102 06排 08座"
    },
    {
        "id": "C102-06-09",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台C102 06排 09座"
    },
    {
        "id": "C102-06-10",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台C102 06排 10座"
    },
    {
        "id": "C102-06-11",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台C102 06排 11座"
    },
    {
        "id": "C102-06-12",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台C102 06排 12座"
    },
    {
        "id": "C102-06-13",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台C102 06排 13座"
    },
    {
        "id": "C102-06-14",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台C102 06排 14座"
    },
    {
        "id": "C102-06-15",
        "areaType": "看台",
        "block": "C102",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台C102 06排 15座"
    },
    {
        "id": "C102-07-01",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台C102 07排 01座"
    },
    {
        "id": "C102-07-02",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台C102 07排 02座"
    },
    {
        "id": "C102-07-03",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台C102 07排 03座"
    },
    {
        "id": "C102-07-04",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台C102 07排 04座"
    },
    {
        "id": "C102-07-05",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台C102 07排 05座"
    },
    {
        "id": "C102-07-06",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台C102 07排 06座"
    },
    {
        "id": "C102-07-07",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台C102 07排 07座"
    },
    {
        "id": "C102-07-08",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台C102 07排 08座"
    },
    {
        "id": "C102-07-09",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台C102 07排 09座"
    },
    {
        "id": "C102-07-10",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台C102 07排 10座"
    },
    {
        "id": "C102-07-11",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台C102 07排 11座"
    },
    {
        "id": "C102-07-12",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台C102 07排 12座"
    },
    {
        "id": "C102-07-13",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台C102 07排 13座"
    },
    {
        "id": "C102-07-14",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台C102 07排 14座"
    },
    {
        "id": "C102-07-15",
        "areaType": "看台",
        "block": "C102",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台C102 07排 15座"
    },
    {
        "id": "C102-08-01",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台C102 08排 01座"
    },
    {
        "id": "C102-08-02",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台C102 08排 02座"
    },
    {
        "id": "C102-08-03",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台C102 08排 03座"
    },
    {
        "id": "C102-08-04",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台C102 08排 04座"
    },
    {
        "id": "C102-08-05",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台C102 08排 05座"
    },
    {
        "id": "C102-08-06",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台C102 08排 06座"
    },
    {
        "id": "C102-08-07",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台C102 08排 07座"
    },
    {
        "id": "C102-08-08",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台C102 08排 08座"
    },
    {
        "id": "C102-08-09",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台C102 08排 09座"
    },
    {
        "id": "C102-08-10",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台C102 08排 10座"
    },
    {
        "id": "C102-08-11",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台C102 08排 11座"
    },
    {
        "id": "C102-08-12",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台C102 08排 12座"
    },
    {
        "id": "C102-08-13",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台C102 08排 13座"
    },
    {
        "id": "C102-08-14",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台C102 08排 14座"
    },
    {
        "id": "C102-08-15",
        "areaType": "看台",
        "block": "C102",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台C102 08排 15座"
    },
    {
        "id": "C102-09-01",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台C102 09排 01座"
    },
    {
        "id": "C102-09-02",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台C102 09排 02座"
    },
    {
        "id": "C102-09-03",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台C102 09排 03座"
    },
    {
        "id": "C102-09-04",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台C102 09排 04座"
    },
    {
        "id": "C102-09-05",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台C102 09排 05座"
    },
    {
        "id": "C102-09-06",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台C102 09排 06座"
    },
    {
        "id": "C102-09-07",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台C102 09排 07座"
    },
    {
        "id": "C102-09-08",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台C102 09排 08座"
    },
    {
        "id": "C102-09-09",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台C102 09排 09座"
    },
    {
        "id": "C102-09-10",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台C102 09排 10座"
    },
    {
        "id": "C102-09-11",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台C102 09排 11座"
    },
    {
        "id": "C102-09-12",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台C102 09排 12座"
    },
    {
        "id": "C102-09-13",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台C102 09排 13座"
    },
    {
        "id": "C102-09-14",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台C102 09排 14座"
    },
    {
        "id": "C102-09-15",
        "areaType": "看台",
        "block": "C102",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台C102 09排 15座"
    },
    {
        "id": "C102-10-01",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台C102 10排 01座"
    },
    {
        "id": "C102-10-02",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台C102 10排 02座"
    },
    {
        "id": "C102-10-03",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台C102 10排 03座"
    },
    {
        "id": "C102-10-04",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台C102 10排 04座"
    },
    {
        "id": "C102-10-05",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台C102 10排 05座"
    },
    {
        "id": "C102-10-06",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台C102 10排 06座"
    },
    {
        "id": "C102-10-07",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台C102 10排 07座"
    },
    {
        "id": "C102-10-08",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台C102 10排 08座"
    },
    {
        "id": "C102-10-09",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台C102 10排 09座"
    },
    {
        "id": "C102-10-10",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台C102 10排 10座"
    },
    {
        "id": "C102-10-11",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台C102 10排 11座"
    },
    {
        "id": "C102-10-12",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台C102 10排 12座"
    },
    {
        "id": "C102-10-13",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台C102 10排 13座"
    },
    {
        "id": "C102-10-14",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台C102 10排 14座"
    },
    {
        "id": "C102-10-15",
        "areaType": "看台",
        "block": "C102",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台C102 10排 15座"
    },
    {
        "id": "C103-01-01",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台C103 01排 01座"
    },
    {
        "id": "C103-01-02",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台C103 01排 02座"
    },
    {
        "id": "C103-01-03",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台C103 01排 03座"
    },
    {
        "id": "C103-01-04",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台C103 01排 04座"
    },
    {
        "id": "C103-01-05",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台C103 01排 05座"
    },
    {
        "id": "C103-01-06",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台C103 01排 06座"
    },
    {
        "id": "C103-01-07",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台C103 01排 07座"
    },
    {
        "id": "C103-01-08",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台C103 01排 08座"
    },
    {
        "id": "C103-01-09",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台C103 01排 09座"
    },
    {
        "id": "C103-01-10",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台C103 01排 10座"
    },
    {
        "id": "C103-01-11",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台C103 01排 11座"
    },
    {
        "id": "C103-01-12",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台C103 01排 12座"
    },
    {
        "id": "C103-01-13",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台C103 01排 13座"
    },
    {
        "id": "C103-01-14",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台C103 01排 14座"
    },
    {
        "id": "C103-01-15",
        "areaType": "看台",
        "block": "C103",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台C103 01排 15座"
    },
    {
        "id": "C103-02-01",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台C103 02排 01座"
    },
    {
        "id": "C103-02-02",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台C103 02排 02座"
    },
    {
        "id": "C103-02-03",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台C103 02排 03座"
    },
    {
        "id": "C103-02-04",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台C103 02排 04座"
    },
    {
        "id": "C103-02-05",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台C103 02排 05座"
    },
    {
        "id": "C103-02-06",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台C103 02排 06座"
    },
    {
        "id": "C103-02-07",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台C103 02排 07座"
    },
    {
        "id": "C103-02-08",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台C103 02排 08座"
    },
    {
        "id": "C103-02-09",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台C103 02排 09座"
    },
    {
        "id": "C103-02-10",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台C103 02排 10座"
    },
    {
        "id": "C103-02-11",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台C103 02排 11座"
    },
    {
        "id": "C103-02-12",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台C103 02排 12座"
    },
    {
        "id": "C103-02-13",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台C103 02排 13座"
    },
    {
        "id": "C103-02-14",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台C103 02排 14座"
    },
    {
        "id": "C103-02-15",
        "areaType": "看台",
        "block": "C103",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台C103 02排 15座"
    },
    {
        "id": "C103-03-01",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台C103 03排 01座"
    },
    {
        "id": "C103-03-02",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台C103 03排 02座"
    },
    {
        "id": "C103-03-03",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台C103 03排 03座"
    },
    {
        "id": "C103-03-04",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台C103 03排 04座"
    },
    {
        "id": "C103-03-05",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台C103 03排 05座"
    },
    {
        "id": "C103-03-06",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台C103 03排 06座"
    },
    {
        "id": "C103-03-07",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台C103 03排 07座"
    },
    {
        "id": "C103-03-08",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台C103 03排 08座"
    },
    {
        "id": "C103-03-09",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台C103 03排 09座"
    },
    {
        "id": "C103-03-10",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台C103 03排 10座"
    },
    {
        "id": "C103-03-11",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台C103 03排 11座"
    },
    {
        "id": "C103-03-12",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台C103 03排 12座"
    },
    {
        "id": "C103-03-13",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台C103 03排 13座"
    },
    {
        "id": "C103-03-14",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台C103 03排 14座"
    },
    {
        "id": "C103-03-15",
        "areaType": "看台",
        "block": "C103",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台C103 03排 15座"
    },
    {
        "id": "C103-04-01",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台C103 04排 01座"
    },
    {
        "id": "C103-04-02",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台C103 04排 02座"
    },
    {
        "id": "C103-04-03",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台C103 04排 03座"
    },
    {
        "id": "C103-04-04",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台C103 04排 04座"
    },
    {
        "id": "C103-04-05",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台C103 04排 05座"
    },
    {
        "id": "C103-04-06",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台C103 04排 06座"
    },
    {
        "id": "C103-04-07",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台C103 04排 07座"
    },
    {
        "id": "C103-04-08",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台C103 04排 08座"
    },
    {
        "id": "C103-04-09",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台C103 04排 09座"
    },
    {
        "id": "C103-04-10",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台C103 04排 10座"
    },
    {
        "id": "C103-04-11",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台C103 04排 11座"
    },
    {
        "id": "C103-04-12",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台C103 04排 12座"
    },
    {
        "id": "C103-04-13",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台C103 04排 13座"
    },
    {
        "id": "C103-04-14",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台C103 04排 14座"
    },
    {
        "id": "C103-04-15",
        "areaType": "看台",
        "block": "C103",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台C103 04排 15座"
    },
    {
        "id": "C103-05-01",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台C103 05排 01座"
    },
    {
        "id": "C103-05-02",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台C103 05排 02座"
    },
    {
        "id": "C103-05-03",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台C103 05排 03座"
    },
    {
        "id": "C103-05-04",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台C103 05排 04座"
    },
    {
        "id": "C103-05-05",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台C103 05排 05座"
    },
    {
        "id": "C103-05-06",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台C103 05排 06座"
    },
    {
        "id": "C103-05-07",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台C103 05排 07座"
    },
    {
        "id": "C103-05-08",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台C103 05排 08座"
    },
    {
        "id": "C103-05-09",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台C103 05排 09座"
    },
    {
        "id": "C103-05-10",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台C103 05排 10座"
    },
    {
        "id": "C103-05-11",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台C103 05排 11座"
    },
    {
        "id": "C103-05-12",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台C103 05排 12座"
    },
    {
        "id": "C103-05-13",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台C103 05排 13座"
    },
    {
        "id": "C103-05-14",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台C103 05排 14座"
    },
    {
        "id": "C103-05-15",
        "areaType": "看台",
        "block": "C103",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台C103 05排 15座"
    },
    {
        "id": "C103-06-01",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台C103 06排 01座"
    },
    {
        "id": "C103-06-02",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台C103 06排 02座"
    },
    {
        "id": "C103-06-03",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台C103 06排 03座"
    },
    {
        "id": "C103-06-04",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台C103 06排 04座"
    },
    {
        "id": "C103-06-05",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台C103 06排 05座"
    },
    {
        "id": "C103-06-06",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台C103 06排 06座"
    },
    {
        "id": "C103-06-07",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台C103 06排 07座"
    },
    {
        "id": "C103-06-08",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台C103 06排 08座"
    },
    {
        "id": "C103-06-09",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台C103 06排 09座"
    },
    {
        "id": "C103-06-10",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台C103 06排 10座"
    },
    {
        "id": "C103-06-11",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台C103 06排 11座"
    },
    {
        "id": "C103-06-12",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台C103 06排 12座"
    },
    {
        "id": "C103-06-13",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台C103 06排 13座"
    },
    {
        "id": "C103-06-14",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台C103 06排 14座"
    },
    {
        "id": "C103-06-15",
        "areaType": "看台",
        "block": "C103",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台C103 06排 15座"
    },
    {
        "id": "C103-07-01",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台C103 07排 01座"
    },
    {
        "id": "C103-07-02",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台C103 07排 02座"
    },
    {
        "id": "C103-07-03",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台C103 07排 03座"
    },
    {
        "id": "C103-07-04",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台C103 07排 04座"
    },
    {
        "id": "C103-07-05",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台C103 07排 05座"
    },
    {
        "id": "C103-07-06",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台C103 07排 06座"
    },
    {
        "id": "C103-07-07",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台C103 07排 07座"
    },
    {
        "id": "C103-07-08",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台C103 07排 08座"
    },
    {
        "id": "C103-07-09",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台C103 07排 09座"
    },
    {
        "id": "C103-07-10",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台C103 07排 10座"
    },
    {
        "id": "C103-07-11",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台C103 07排 11座"
    },
    {
        "id": "C103-07-12",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台C103 07排 12座"
    },
    {
        "id": "C103-07-13",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台C103 07排 13座"
    },
    {
        "id": "C103-07-14",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台C103 07排 14座"
    },
    {
        "id": "C103-07-15",
        "areaType": "看台",
        "block": "C103",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台C103 07排 15座"
    },
    {
        "id": "C103-08-01",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台C103 08排 01座"
    },
    {
        "id": "C103-08-02",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台C103 08排 02座"
    },
    {
        "id": "C103-08-03",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台C103 08排 03座"
    },
    {
        "id": "C103-08-04",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台C103 08排 04座"
    },
    {
        "id": "C103-08-05",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台C103 08排 05座"
    },
    {
        "id": "C103-08-06",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台C103 08排 06座"
    },
    {
        "id": "C103-08-07",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台C103 08排 07座"
    },
    {
        "id": "C103-08-08",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台C103 08排 08座"
    },
    {
        "id": "C103-08-09",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台C103 08排 09座"
    },
    {
        "id": "C103-08-10",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台C103 08排 10座"
    },
    {
        "id": "C103-08-11",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台C103 08排 11座"
    },
    {
        "id": "C103-08-12",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台C103 08排 12座"
    },
    {
        "id": "C103-08-13",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台C103 08排 13座"
    },
    {
        "id": "C103-08-14",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台C103 08排 14座"
    },
    {
        "id": "C103-08-15",
        "areaType": "看台",
        "block": "C103",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台C103 08排 15座"
    },
    {
        "id": "C103-09-01",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台C103 09排 01座"
    },
    {
        "id": "C103-09-02",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台C103 09排 02座"
    },
    {
        "id": "C103-09-03",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台C103 09排 03座"
    },
    {
        "id": "C103-09-04",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台C103 09排 04座"
    },
    {
        "id": "C103-09-05",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台C103 09排 05座"
    },
    {
        "id": "C103-09-06",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台C103 09排 06座"
    },
    {
        "id": "C103-09-07",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台C103 09排 07座"
    },
    {
        "id": "C103-09-08",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台C103 09排 08座"
    },
    {
        "id": "C103-09-09",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台C103 09排 09座"
    },
    {
        "id": "C103-09-10",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台C103 09排 10座"
    },
    {
        "id": "C103-09-11",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台C103 09排 11座"
    },
    {
        "id": "C103-09-12",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台C103 09排 12座"
    },
    {
        "id": "C103-09-13",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台C103 09排 13座"
    },
    {
        "id": "C103-09-14",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台C103 09排 14座"
    },
    {
        "id": "C103-09-15",
        "areaType": "看台",
        "block": "C103",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台C103 09排 15座"
    },
    {
        "id": "C103-10-01",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台C103 10排 01座"
    },
    {
        "id": "C103-10-02",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台C103 10排 02座"
    },
    {
        "id": "C103-10-03",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台C103 10排 03座"
    },
    {
        "id": "C103-10-04",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台C103 10排 04座"
    },
    {
        "id": "C103-10-05",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台C103 10排 05座"
    },
    {
        "id": "C103-10-06",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台C103 10排 06座"
    },
    {
        "id": "C103-10-07",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台C103 10排 07座"
    },
    {
        "id": "C103-10-08",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台C103 10排 08座"
    },
    {
        "id": "C103-10-09",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台C103 10排 09座"
    },
    {
        "id": "C103-10-10",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台C103 10排 10座"
    },
    {
        "id": "C103-10-11",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台C103 10排 11座"
    },
    {
        "id": "C103-10-12",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台C103 10排 12座"
    },
    {
        "id": "C103-10-13",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台C103 10排 13座"
    },
    {
        "id": "C103-10-14",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台C103 10排 14座"
    },
    {
        "id": "C103-10-15",
        "areaType": "看台",
        "block": "C103",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台C103 10排 15座"
    },
    {
        "id": "C104-01-01",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台C104 01排 01座"
    },
    {
        "id": "C104-01-02",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台C104 01排 02座"
    },
    {
        "id": "C104-01-03",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台C104 01排 03座"
    },
    {
        "id": "C104-01-04",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台C104 01排 04座"
    },
    {
        "id": "C104-01-05",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台C104 01排 05座"
    },
    {
        "id": "C104-01-06",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台C104 01排 06座"
    },
    {
        "id": "C104-01-07",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台C104 01排 07座"
    },
    {
        "id": "C104-01-08",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台C104 01排 08座"
    },
    {
        "id": "C104-01-09",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台C104 01排 09座"
    },
    {
        "id": "C104-01-10",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台C104 01排 10座"
    },
    {
        "id": "C104-01-11",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台C104 01排 11座"
    },
    {
        "id": "C104-01-12",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台C104 01排 12座"
    },
    {
        "id": "C104-01-13",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台C104 01排 13座"
    },
    {
        "id": "C104-01-14",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台C104 01排 14座"
    },
    {
        "id": "C104-01-15",
        "areaType": "看台",
        "block": "C104",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台C104 01排 15座"
    },
    {
        "id": "C104-02-01",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台C104 02排 01座"
    },
    {
        "id": "C104-02-02",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台C104 02排 02座"
    },
    {
        "id": "C104-02-03",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台C104 02排 03座"
    },
    {
        "id": "C104-02-04",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台C104 02排 04座"
    },
    {
        "id": "C104-02-05",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台C104 02排 05座"
    },
    {
        "id": "C104-02-06",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台C104 02排 06座"
    },
    {
        "id": "C104-02-07",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台C104 02排 07座"
    },
    {
        "id": "C104-02-08",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台C104 02排 08座"
    },
    {
        "id": "C104-02-09",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台C104 02排 09座"
    },
    {
        "id": "C104-02-10",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台C104 02排 10座"
    },
    {
        "id": "C104-02-11",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台C104 02排 11座"
    },
    {
        "id": "C104-02-12",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台C104 02排 12座"
    },
    {
        "id": "C104-02-13",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台C104 02排 13座"
    },
    {
        "id": "C104-02-14",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台C104 02排 14座"
    },
    {
        "id": "C104-02-15",
        "areaType": "看台",
        "block": "C104",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台C104 02排 15座"
    },
    {
        "id": "C104-03-01",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台C104 03排 01座"
    },
    {
        "id": "C104-03-02",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台C104 03排 02座"
    },
    {
        "id": "C104-03-03",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台C104 03排 03座"
    },
    {
        "id": "C104-03-04",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台C104 03排 04座"
    },
    {
        "id": "C104-03-05",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台C104 03排 05座"
    },
    {
        "id": "C104-03-06",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台C104 03排 06座"
    },
    {
        "id": "C104-03-07",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台C104 03排 07座"
    },
    {
        "id": "C104-03-08",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台C104 03排 08座"
    },
    {
        "id": "C104-03-09",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台C104 03排 09座"
    },
    {
        "id": "C104-03-10",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台C104 03排 10座"
    },
    {
        "id": "C104-03-11",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台C104 03排 11座"
    },
    {
        "id": "C104-03-12",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台C104 03排 12座"
    },
    {
        "id": "C104-03-13",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台C104 03排 13座"
    },
    {
        "id": "C104-03-14",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台C104 03排 14座"
    },
    {
        "id": "C104-03-15",
        "areaType": "看台",
        "block": "C104",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台C104 03排 15座"
    },
    {
        "id": "C104-04-01",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台C104 04排 01座"
    },
    {
        "id": "C104-04-02",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台C104 04排 02座"
    },
    {
        "id": "C104-04-03",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台C104 04排 03座"
    },
    {
        "id": "C104-04-04",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台C104 04排 04座"
    },
    {
        "id": "C104-04-05",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台C104 04排 05座"
    },
    {
        "id": "C104-04-06",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台C104 04排 06座"
    },
    {
        "id": "C104-04-07",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台C104 04排 07座"
    },
    {
        "id": "C104-04-08",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台C104 04排 08座"
    },
    {
        "id": "C104-04-09",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台C104 04排 09座"
    },
    {
        "id": "C104-04-10",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台C104 04排 10座"
    },
    {
        "id": "C104-04-11",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台C104 04排 11座"
    },
    {
        "id": "C104-04-12",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台C104 04排 12座"
    },
    {
        "id": "C104-04-13",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台C104 04排 13座"
    },
    {
        "id": "C104-04-14",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台C104 04排 14座"
    },
    {
        "id": "C104-04-15",
        "areaType": "看台",
        "block": "C104",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台C104 04排 15座"
    },
    {
        "id": "C104-05-01",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台C104 05排 01座"
    },
    {
        "id": "C104-05-02",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台C104 05排 02座"
    },
    {
        "id": "C104-05-03",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台C104 05排 03座"
    },
    {
        "id": "C104-05-04",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台C104 05排 04座"
    },
    {
        "id": "C104-05-05",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台C104 05排 05座"
    },
    {
        "id": "C104-05-06",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台C104 05排 06座"
    },
    {
        "id": "C104-05-07",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台C104 05排 07座"
    },
    {
        "id": "C104-05-08",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台C104 05排 08座"
    },
    {
        "id": "C104-05-09",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台C104 05排 09座"
    },
    {
        "id": "C104-05-10",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台C104 05排 10座"
    },
    {
        "id": "C104-05-11",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台C104 05排 11座"
    },
    {
        "id": "C104-05-12",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台C104 05排 12座"
    },
    {
        "id": "C104-05-13",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台C104 05排 13座"
    },
    {
        "id": "C104-05-14",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台C104 05排 14座"
    },
    {
        "id": "C104-05-15",
        "areaType": "看台",
        "block": "C104",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台C104 05排 15座"
    },
    {
        "id": "C104-06-01",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台C104 06排 01座"
    },
    {
        "id": "C104-06-02",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台C104 06排 02座"
    },
    {
        "id": "C104-06-03",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台C104 06排 03座"
    },
    {
        "id": "C104-06-04",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台C104 06排 04座"
    },
    {
        "id": "C104-06-05",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台C104 06排 05座"
    },
    {
        "id": "C104-06-06",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台C104 06排 06座"
    },
    {
        "id": "C104-06-07",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台C104 06排 07座"
    },
    {
        "id": "C104-06-08",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台C104 06排 08座"
    },
    {
        "id": "C104-06-09",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台C104 06排 09座"
    },
    {
        "id": "C104-06-10",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台C104 06排 10座"
    },
    {
        "id": "C104-06-11",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台C104 06排 11座"
    },
    {
        "id": "C104-06-12",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台C104 06排 12座"
    },
    {
        "id": "C104-06-13",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台C104 06排 13座"
    },
    {
        "id": "C104-06-14",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台C104 06排 14座"
    },
    {
        "id": "C104-06-15",
        "areaType": "看台",
        "block": "C104",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台C104 06排 15座"
    },
    {
        "id": "C104-07-01",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台C104 07排 01座"
    },
    {
        "id": "C104-07-02",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台C104 07排 02座"
    },
    {
        "id": "C104-07-03",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台C104 07排 03座"
    },
    {
        "id": "C104-07-04",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台C104 07排 04座"
    },
    {
        "id": "C104-07-05",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台C104 07排 05座"
    },
    {
        "id": "C104-07-06",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台C104 07排 06座"
    },
    {
        "id": "C104-07-07",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台C104 07排 07座"
    },
    {
        "id": "C104-07-08",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台C104 07排 08座"
    },
    {
        "id": "C104-07-09",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台C104 07排 09座"
    },
    {
        "id": "C104-07-10",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台C104 07排 10座"
    },
    {
        "id": "C104-07-11",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台C104 07排 11座"
    },
    {
        "id": "C104-07-12",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台C104 07排 12座"
    },
    {
        "id": "C104-07-13",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台C104 07排 13座"
    },
    {
        "id": "C104-07-14",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台C104 07排 14座"
    },
    {
        "id": "C104-07-15",
        "areaType": "看台",
        "block": "C104",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台C104 07排 15座"
    },
    {
        "id": "C104-08-01",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台C104 08排 01座"
    },
    {
        "id": "C104-08-02",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台C104 08排 02座"
    },
    {
        "id": "C104-08-03",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台C104 08排 03座"
    },
    {
        "id": "C104-08-04",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台C104 08排 04座"
    },
    {
        "id": "C104-08-05",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台C104 08排 05座"
    },
    {
        "id": "C104-08-06",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台C104 08排 06座"
    },
    {
        "id": "C104-08-07",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台C104 08排 07座"
    },
    {
        "id": "C104-08-08",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台C104 08排 08座"
    },
    {
        "id": "C104-08-09",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台C104 08排 09座"
    },
    {
        "id": "C104-08-10",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台C104 08排 10座"
    },
    {
        "id": "C104-08-11",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台C104 08排 11座"
    },
    {
        "id": "C104-08-12",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台C104 08排 12座"
    },
    {
        "id": "C104-08-13",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台C104 08排 13座"
    },
    {
        "id": "C104-08-14",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台C104 08排 14座"
    },
    {
        "id": "C104-08-15",
        "areaType": "看台",
        "block": "C104",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台C104 08排 15座"
    },
    {
        "id": "C104-09-01",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台C104 09排 01座"
    },
    {
        "id": "C104-09-02",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台C104 09排 02座"
    },
    {
        "id": "C104-09-03",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台C104 09排 03座"
    },
    {
        "id": "C104-09-04",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台C104 09排 04座"
    },
    {
        "id": "C104-09-05",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台C104 09排 05座"
    },
    {
        "id": "C104-09-06",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台C104 09排 06座"
    },
    {
        "id": "C104-09-07",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台C104 09排 07座"
    },
    {
        "id": "C104-09-08",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台C104 09排 08座"
    },
    {
        "id": "C104-09-09",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台C104 09排 09座"
    },
    {
        "id": "C104-09-10",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台C104 09排 10座"
    },
    {
        "id": "C104-09-11",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台C104 09排 11座"
    },
    {
        "id": "C104-09-12",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台C104 09排 12座"
    },
    {
        "id": "C104-09-13",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台C104 09排 13座"
    },
    {
        "id": "C104-09-14",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台C104 09排 14座"
    },
    {
        "id": "C104-09-15",
        "areaType": "看台",
        "block": "C104",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台C104 09排 15座"
    },
    {
        "id": "C104-10-01",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台C104 10排 01座"
    },
    {
        "id": "C104-10-02",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台C104 10排 02座"
    },
    {
        "id": "C104-10-03",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台C104 10排 03座"
    },
    {
        "id": "C104-10-04",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台C104 10排 04座"
    },
    {
        "id": "C104-10-05",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台C104 10排 05座"
    },
    {
        "id": "C104-10-06",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台C104 10排 06座"
    },
    {
        "id": "C104-10-07",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台C104 10排 07座"
    },
    {
        "id": "C104-10-08",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台C104 10排 08座"
    },
    {
        "id": "C104-10-09",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台C104 10排 09座"
    },
    {
        "id": "C104-10-10",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台C104 10排 10座"
    },
    {
        "id": "C104-10-11",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台C104 10排 11座"
    },
    {
        "id": "C104-10-12",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台C104 10排 12座"
    },
    {
        "id": "C104-10-13",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台C104 10排 13座"
    },
    {
        "id": "C104-10-14",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台C104 10排 14座"
    },
    {
        "id": "C104-10-15",
        "areaType": "看台",
        "block": "C104",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台C104 10排 15座"
    },
    {
        "id": "C105-01-01",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台C105 01排 01座"
    },
    {
        "id": "C105-01-02",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台C105 01排 02座"
    },
    {
        "id": "C105-01-03",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台C105 01排 03座"
    },
    {
        "id": "C105-01-04",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台C105 01排 04座"
    },
    {
        "id": "C105-01-05",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台C105 01排 05座"
    },
    {
        "id": "C105-01-06",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台C105 01排 06座"
    },
    {
        "id": "C105-01-07",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台C105 01排 07座"
    },
    {
        "id": "C105-01-08",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台C105 01排 08座"
    },
    {
        "id": "C105-01-09",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台C105 01排 09座"
    },
    {
        "id": "C105-01-10",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台C105 01排 10座"
    },
    {
        "id": "C105-01-11",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台C105 01排 11座"
    },
    {
        "id": "C105-01-12",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台C105 01排 12座"
    },
    {
        "id": "C105-01-13",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台C105 01排 13座"
    },
    {
        "id": "C105-01-14",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台C105 01排 14座"
    },
    {
        "id": "C105-01-15",
        "areaType": "看台",
        "block": "C105",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台C105 01排 15座"
    },
    {
        "id": "C105-02-01",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台C105 02排 01座"
    },
    {
        "id": "C105-02-02",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台C105 02排 02座"
    },
    {
        "id": "C105-02-03",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台C105 02排 03座"
    },
    {
        "id": "C105-02-04",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台C105 02排 04座"
    },
    {
        "id": "C105-02-05",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台C105 02排 05座"
    },
    {
        "id": "C105-02-06",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台C105 02排 06座"
    },
    {
        "id": "C105-02-07",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台C105 02排 07座"
    },
    {
        "id": "C105-02-08",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台C105 02排 08座"
    },
    {
        "id": "C105-02-09",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台C105 02排 09座"
    },
    {
        "id": "C105-02-10",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台C105 02排 10座"
    },
    {
        "id": "C105-02-11",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台C105 02排 11座"
    },
    {
        "id": "C105-02-12",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台C105 02排 12座"
    },
    {
        "id": "C105-02-13",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台C105 02排 13座"
    },
    {
        "id": "C105-02-14",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台C105 02排 14座"
    },
    {
        "id": "C105-02-15",
        "areaType": "看台",
        "block": "C105",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台C105 02排 15座"
    },
    {
        "id": "C105-03-01",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台C105 03排 01座"
    },
    {
        "id": "C105-03-02",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台C105 03排 02座"
    },
    {
        "id": "C105-03-03",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台C105 03排 03座"
    },
    {
        "id": "C105-03-04",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台C105 03排 04座"
    },
    {
        "id": "C105-03-05",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台C105 03排 05座"
    },
    {
        "id": "C105-03-06",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台C105 03排 06座"
    },
    {
        "id": "C105-03-07",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台C105 03排 07座"
    },
    {
        "id": "C105-03-08",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台C105 03排 08座"
    },
    {
        "id": "C105-03-09",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台C105 03排 09座"
    },
    {
        "id": "C105-03-10",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台C105 03排 10座"
    },
    {
        "id": "C105-03-11",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台C105 03排 11座"
    },
    {
        "id": "C105-03-12",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台C105 03排 12座"
    },
    {
        "id": "C105-03-13",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台C105 03排 13座"
    },
    {
        "id": "C105-03-14",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台C105 03排 14座"
    },
    {
        "id": "C105-03-15",
        "areaType": "看台",
        "block": "C105",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台C105 03排 15座"
    },
    {
        "id": "C105-04-01",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台C105 04排 01座"
    },
    {
        "id": "C105-04-02",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台C105 04排 02座"
    },
    {
        "id": "C105-04-03",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台C105 04排 03座"
    },
    {
        "id": "C105-04-04",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台C105 04排 04座"
    },
    {
        "id": "C105-04-05",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台C105 04排 05座"
    },
    {
        "id": "C105-04-06",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台C105 04排 06座"
    },
    {
        "id": "C105-04-07",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台C105 04排 07座"
    },
    {
        "id": "C105-04-08",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台C105 04排 08座"
    },
    {
        "id": "C105-04-09",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台C105 04排 09座"
    },
    {
        "id": "C105-04-10",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台C105 04排 10座"
    },
    {
        "id": "C105-04-11",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台C105 04排 11座"
    },
    {
        "id": "C105-04-12",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台C105 04排 12座"
    },
    {
        "id": "C105-04-13",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台C105 04排 13座"
    },
    {
        "id": "C105-04-14",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台C105 04排 14座"
    },
    {
        "id": "C105-04-15",
        "areaType": "看台",
        "block": "C105",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台C105 04排 15座"
    },
    {
        "id": "C105-05-01",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台C105 05排 01座"
    },
    {
        "id": "C105-05-02",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台C105 05排 02座"
    },
    {
        "id": "C105-05-03",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台C105 05排 03座"
    },
    {
        "id": "C105-05-04",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台C105 05排 04座"
    },
    {
        "id": "C105-05-05",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台C105 05排 05座"
    },
    {
        "id": "C105-05-06",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台C105 05排 06座"
    },
    {
        "id": "C105-05-07",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台C105 05排 07座"
    },
    {
        "id": "C105-05-08",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台C105 05排 08座"
    },
    {
        "id": "C105-05-09",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台C105 05排 09座"
    },
    {
        "id": "C105-05-10",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台C105 05排 10座"
    },
    {
        "id": "C105-05-11",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台C105 05排 11座"
    },
    {
        "id": "C105-05-12",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台C105 05排 12座"
    },
    {
        "id": "C105-05-13",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台C105 05排 13座"
    },
    {
        "id": "C105-05-14",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台C105 05排 14座"
    },
    {
        "id": "C105-05-15",
        "areaType": "看台",
        "block": "C105",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台C105 05排 15座"
    },
    {
        "id": "C105-06-01",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台C105 06排 01座"
    },
    {
        "id": "C105-06-02",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台C105 06排 02座"
    },
    {
        "id": "C105-06-03",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台C105 06排 03座"
    },
    {
        "id": "C105-06-04",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台C105 06排 04座"
    },
    {
        "id": "C105-06-05",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台C105 06排 05座"
    },
    {
        "id": "C105-06-06",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台C105 06排 06座"
    },
    {
        "id": "C105-06-07",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台C105 06排 07座"
    },
    {
        "id": "C105-06-08",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台C105 06排 08座"
    },
    {
        "id": "C105-06-09",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台C105 06排 09座"
    },
    {
        "id": "C105-06-10",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台C105 06排 10座"
    },
    {
        "id": "C105-06-11",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台C105 06排 11座"
    },
    {
        "id": "C105-06-12",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台C105 06排 12座"
    },
    {
        "id": "C105-06-13",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台C105 06排 13座"
    },
    {
        "id": "C105-06-14",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台C105 06排 14座"
    },
    {
        "id": "C105-06-15",
        "areaType": "看台",
        "block": "C105",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台C105 06排 15座"
    },
    {
        "id": "C105-07-01",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台C105 07排 01座"
    },
    {
        "id": "C105-07-02",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台C105 07排 02座"
    },
    {
        "id": "C105-07-03",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台C105 07排 03座"
    },
    {
        "id": "C105-07-04",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台C105 07排 04座"
    },
    {
        "id": "C105-07-05",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台C105 07排 05座"
    },
    {
        "id": "C105-07-06",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台C105 07排 06座"
    },
    {
        "id": "C105-07-07",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台C105 07排 07座"
    },
    {
        "id": "C105-07-08",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台C105 07排 08座"
    },
    {
        "id": "C105-07-09",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台C105 07排 09座"
    },
    {
        "id": "C105-07-10",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台C105 07排 10座"
    },
    {
        "id": "C105-07-11",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台C105 07排 11座"
    },
    {
        "id": "C105-07-12",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台C105 07排 12座"
    },
    {
        "id": "C105-07-13",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台C105 07排 13座"
    },
    {
        "id": "C105-07-14",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台C105 07排 14座"
    },
    {
        "id": "C105-07-15",
        "areaType": "看台",
        "block": "C105",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台C105 07排 15座"
    },
    {
        "id": "C105-08-01",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台C105 08排 01座"
    },
    {
        "id": "C105-08-02",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台C105 08排 02座"
    },
    {
        "id": "C105-08-03",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台C105 08排 03座"
    },
    {
        "id": "C105-08-04",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台C105 08排 04座"
    },
    {
        "id": "C105-08-05",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台C105 08排 05座"
    },
    {
        "id": "C105-08-06",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台C105 08排 06座"
    },
    {
        "id": "C105-08-07",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台C105 08排 07座"
    },
    {
        "id": "C105-08-08",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台C105 08排 08座"
    },
    {
        "id": "C105-08-09",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台C105 08排 09座"
    },
    {
        "id": "C105-08-10",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台C105 08排 10座"
    },
    {
        "id": "C105-08-11",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台C105 08排 11座"
    },
    {
        "id": "C105-08-12",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台C105 08排 12座"
    },
    {
        "id": "C105-08-13",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台C105 08排 13座"
    },
    {
        "id": "C105-08-14",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台C105 08排 14座"
    },
    {
        "id": "C105-08-15",
        "areaType": "看台",
        "block": "C105",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台C105 08排 15座"
    },
    {
        "id": "C105-09-01",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台C105 09排 01座"
    },
    {
        "id": "C105-09-02",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台C105 09排 02座"
    },
    {
        "id": "C105-09-03",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台C105 09排 03座"
    },
    {
        "id": "C105-09-04",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台C105 09排 04座"
    },
    {
        "id": "C105-09-05",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台C105 09排 05座"
    },
    {
        "id": "C105-09-06",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台C105 09排 06座"
    },
    {
        "id": "C105-09-07",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台C105 09排 07座"
    },
    {
        "id": "C105-09-08",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台C105 09排 08座"
    },
    {
        "id": "C105-09-09",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台C105 09排 09座"
    },
    {
        "id": "C105-09-10",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台C105 09排 10座"
    },
    {
        "id": "C105-09-11",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台C105 09排 11座"
    },
    {
        "id": "C105-09-12",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台C105 09排 12座"
    },
    {
        "id": "C105-09-13",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台C105 09排 13座"
    },
    {
        "id": "C105-09-14",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台C105 09排 14座"
    },
    {
        "id": "C105-09-15",
        "areaType": "看台",
        "block": "C105",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台C105 09排 15座"
    },
    {
        "id": "C105-10-01",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台C105 10排 01座"
    },
    {
        "id": "C105-10-02",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台C105 10排 02座"
    },
    {
        "id": "C105-10-03",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台C105 10排 03座"
    },
    {
        "id": "C105-10-04",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台C105 10排 04座"
    },
    {
        "id": "C105-10-05",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台C105 10排 05座"
    },
    {
        "id": "C105-10-06",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台C105 10排 06座"
    },
    {
        "id": "C105-10-07",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台C105 10排 07座"
    },
    {
        "id": "C105-10-08",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台C105 10排 08座"
    },
    {
        "id": "C105-10-09",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台C105 10排 09座"
    },
    {
        "id": "C105-10-10",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台C105 10排 10座"
    },
    {
        "id": "C105-10-11",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台C105 10排 11座"
    },
    {
        "id": "C105-10-12",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台C105 10排 12座"
    },
    {
        "id": "C105-10-13",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台C105 10排 13座"
    },
    {
        "id": "C105-10-14",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台C105 10排 14座"
    },
    {
        "id": "C105-10-15",
        "areaType": "看台",
        "block": "C105",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台C105 10排 15座"
    },
    {
        "id": "C122-01-01",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台C122 01排 01座"
    },
    {
        "id": "C122-01-02",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台C122 01排 02座"
    },
    {
        "id": "C122-01-03",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台C122 01排 03座"
    },
    {
        "id": "C122-01-04",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台C122 01排 04座"
    },
    {
        "id": "C122-01-05",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台C122 01排 05座"
    },
    {
        "id": "C122-01-06",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台C122 01排 06座"
    },
    {
        "id": "C122-01-07",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台C122 01排 07座"
    },
    {
        "id": "C122-01-08",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台C122 01排 08座"
    },
    {
        "id": "C122-01-09",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台C122 01排 09座"
    },
    {
        "id": "C122-01-10",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台C122 01排 10座"
    },
    {
        "id": "C122-01-11",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台C122 01排 11座"
    },
    {
        "id": "C122-01-12",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台C122 01排 12座"
    },
    {
        "id": "C122-01-13",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台C122 01排 13座"
    },
    {
        "id": "C122-01-14",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台C122 01排 14座"
    },
    {
        "id": "C122-01-15",
        "areaType": "看台",
        "block": "C122",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台C122 01排 15座"
    },
    {
        "id": "C122-02-01",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台C122 02排 01座"
    },
    {
        "id": "C122-02-02",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台C122 02排 02座"
    },
    {
        "id": "C122-02-03",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台C122 02排 03座"
    },
    {
        "id": "C122-02-04",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台C122 02排 04座"
    },
    {
        "id": "C122-02-05",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台C122 02排 05座"
    },
    {
        "id": "C122-02-06",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台C122 02排 06座"
    },
    {
        "id": "C122-02-07",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台C122 02排 07座"
    },
    {
        "id": "C122-02-08",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台C122 02排 08座"
    },
    {
        "id": "C122-02-09",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台C122 02排 09座"
    },
    {
        "id": "C122-02-10",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台C122 02排 10座"
    },
    {
        "id": "C122-02-11",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台C122 02排 11座"
    },
    {
        "id": "C122-02-12",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台C122 02排 12座"
    },
    {
        "id": "C122-02-13",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台C122 02排 13座"
    },
    {
        "id": "C122-02-14",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台C122 02排 14座"
    },
    {
        "id": "C122-02-15",
        "areaType": "看台",
        "block": "C122",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台C122 02排 15座"
    },
    {
        "id": "C122-03-01",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台C122 03排 01座"
    },
    {
        "id": "C122-03-02",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台C122 03排 02座"
    },
    {
        "id": "C122-03-03",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台C122 03排 03座"
    },
    {
        "id": "C122-03-04",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台C122 03排 04座"
    },
    {
        "id": "C122-03-05",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台C122 03排 05座"
    },
    {
        "id": "C122-03-06",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台C122 03排 06座"
    },
    {
        "id": "C122-03-07",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台C122 03排 07座"
    },
    {
        "id": "C122-03-08",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台C122 03排 08座"
    },
    {
        "id": "C122-03-09",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台C122 03排 09座"
    },
    {
        "id": "C122-03-10",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台C122 03排 10座"
    },
    {
        "id": "C122-03-11",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台C122 03排 11座"
    },
    {
        "id": "C122-03-12",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台C122 03排 12座"
    },
    {
        "id": "C122-03-13",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台C122 03排 13座"
    },
    {
        "id": "C122-03-14",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台C122 03排 14座"
    },
    {
        "id": "C122-03-15",
        "areaType": "看台",
        "block": "C122",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台C122 03排 15座"
    },
    {
        "id": "C122-04-01",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台C122 04排 01座"
    },
    {
        "id": "C122-04-02",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台C122 04排 02座"
    },
    {
        "id": "C122-04-03",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台C122 04排 03座"
    },
    {
        "id": "C122-04-04",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台C122 04排 04座"
    },
    {
        "id": "C122-04-05",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台C122 04排 05座"
    },
    {
        "id": "C122-04-06",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台C122 04排 06座"
    },
    {
        "id": "C122-04-07",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台C122 04排 07座"
    },
    {
        "id": "C122-04-08",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台C122 04排 08座"
    },
    {
        "id": "C122-04-09",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台C122 04排 09座"
    },
    {
        "id": "C122-04-10",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台C122 04排 10座"
    },
    {
        "id": "C122-04-11",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台C122 04排 11座"
    },
    {
        "id": "C122-04-12",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台C122 04排 12座"
    },
    {
        "id": "C122-04-13",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台C122 04排 13座"
    },
    {
        "id": "C122-04-14",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台C122 04排 14座"
    },
    {
        "id": "C122-04-15",
        "areaType": "看台",
        "block": "C122",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台C122 04排 15座"
    },
    {
        "id": "C122-05-01",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台C122 05排 01座"
    },
    {
        "id": "C122-05-02",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台C122 05排 02座"
    },
    {
        "id": "C122-05-03",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台C122 05排 03座"
    },
    {
        "id": "C122-05-04",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台C122 05排 04座"
    },
    {
        "id": "C122-05-05",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台C122 05排 05座"
    },
    {
        "id": "C122-05-06",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台C122 05排 06座"
    },
    {
        "id": "C122-05-07",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台C122 05排 07座"
    },
    {
        "id": "C122-05-08",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台C122 05排 08座"
    },
    {
        "id": "C122-05-09",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台C122 05排 09座"
    },
    {
        "id": "C122-05-10",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台C122 05排 10座"
    },
    {
        "id": "C122-05-11",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台C122 05排 11座"
    },
    {
        "id": "C122-05-12",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台C122 05排 12座"
    },
    {
        "id": "C122-05-13",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台C122 05排 13座"
    },
    {
        "id": "C122-05-14",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台C122 05排 14座"
    },
    {
        "id": "C122-05-15",
        "areaType": "看台",
        "block": "C122",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台C122 05排 15座"
    },
    {
        "id": "C122-06-01",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台C122 06排 01座"
    },
    {
        "id": "C122-06-02",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台C122 06排 02座"
    },
    {
        "id": "C122-06-03",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台C122 06排 03座"
    },
    {
        "id": "C122-06-04",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台C122 06排 04座"
    },
    {
        "id": "C122-06-05",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台C122 06排 05座"
    },
    {
        "id": "C122-06-06",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台C122 06排 06座"
    },
    {
        "id": "C122-06-07",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台C122 06排 07座"
    },
    {
        "id": "C122-06-08",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台C122 06排 08座"
    },
    {
        "id": "C122-06-09",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台C122 06排 09座"
    },
    {
        "id": "C122-06-10",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台C122 06排 10座"
    },
    {
        "id": "C122-06-11",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台C122 06排 11座"
    },
    {
        "id": "C122-06-12",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台C122 06排 12座"
    },
    {
        "id": "C122-06-13",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台C122 06排 13座"
    },
    {
        "id": "C122-06-14",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台C122 06排 14座"
    },
    {
        "id": "C122-06-15",
        "areaType": "看台",
        "block": "C122",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台C122 06排 15座"
    },
    {
        "id": "C122-07-01",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台C122 07排 01座"
    },
    {
        "id": "C122-07-02",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台C122 07排 02座"
    },
    {
        "id": "C122-07-03",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台C122 07排 03座"
    },
    {
        "id": "C122-07-04",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台C122 07排 04座"
    },
    {
        "id": "C122-07-05",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台C122 07排 05座"
    },
    {
        "id": "C122-07-06",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台C122 07排 06座"
    },
    {
        "id": "C122-07-07",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台C122 07排 07座"
    },
    {
        "id": "C122-07-08",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台C122 07排 08座"
    },
    {
        "id": "C122-07-09",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台C122 07排 09座"
    },
    {
        "id": "C122-07-10",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台C122 07排 10座"
    },
    {
        "id": "C122-07-11",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台C122 07排 11座"
    },
    {
        "id": "C122-07-12",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台C122 07排 12座"
    },
    {
        "id": "C122-07-13",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台C122 07排 13座"
    },
    {
        "id": "C122-07-14",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台C122 07排 14座"
    },
    {
        "id": "C122-07-15",
        "areaType": "看台",
        "block": "C122",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台C122 07排 15座"
    },
    {
        "id": "C122-08-01",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台C122 08排 01座"
    },
    {
        "id": "C122-08-02",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台C122 08排 02座"
    },
    {
        "id": "C122-08-03",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台C122 08排 03座"
    },
    {
        "id": "C122-08-04",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台C122 08排 04座"
    },
    {
        "id": "C122-08-05",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台C122 08排 05座"
    },
    {
        "id": "C122-08-06",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台C122 08排 06座"
    },
    {
        "id": "C122-08-07",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台C122 08排 07座"
    },
    {
        "id": "C122-08-08",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台C122 08排 08座"
    },
    {
        "id": "C122-08-09",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台C122 08排 09座"
    },
    {
        "id": "C122-08-10",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台C122 08排 10座"
    },
    {
        "id": "C122-08-11",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台C122 08排 11座"
    },
    {
        "id": "C122-08-12",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台C122 08排 12座"
    },
    {
        "id": "C122-08-13",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台C122 08排 13座"
    },
    {
        "id": "C122-08-14",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台C122 08排 14座"
    },
    {
        "id": "C122-08-15",
        "areaType": "看台",
        "block": "C122",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台C122 08排 15座"
    },
    {
        "id": "C122-09-01",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台C122 09排 01座"
    },
    {
        "id": "C122-09-02",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台C122 09排 02座"
    },
    {
        "id": "C122-09-03",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台C122 09排 03座"
    },
    {
        "id": "C122-09-04",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台C122 09排 04座"
    },
    {
        "id": "C122-09-05",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台C122 09排 05座"
    },
    {
        "id": "C122-09-06",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台C122 09排 06座"
    },
    {
        "id": "C122-09-07",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台C122 09排 07座"
    },
    {
        "id": "C122-09-08",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台C122 09排 08座"
    },
    {
        "id": "C122-09-09",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台C122 09排 09座"
    },
    {
        "id": "C122-09-10",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台C122 09排 10座"
    },
    {
        "id": "C122-09-11",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台C122 09排 11座"
    },
    {
        "id": "C122-09-12",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台C122 09排 12座"
    },
    {
        "id": "C122-09-13",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台C122 09排 13座"
    },
    {
        "id": "C122-09-14",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台C122 09排 14座"
    },
    {
        "id": "C122-09-15",
        "areaType": "看台",
        "block": "C122",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台C122 09排 15座"
    },
    {
        "id": "C122-10-01",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台C122 10排 01座"
    },
    {
        "id": "C122-10-02",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台C122 10排 02座"
    },
    {
        "id": "C122-10-03",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台C122 10排 03座"
    },
    {
        "id": "C122-10-04",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台C122 10排 04座"
    },
    {
        "id": "C122-10-05",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台C122 10排 05座"
    },
    {
        "id": "C122-10-06",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台C122 10排 06座"
    },
    {
        "id": "C122-10-07",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台C122 10排 07座"
    },
    {
        "id": "C122-10-08",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台C122 10排 08座"
    },
    {
        "id": "C122-10-09",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台C122 10排 09座"
    },
    {
        "id": "C122-10-10",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台C122 10排 10座"
    },
    {
        "id": "C122-10-11",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台C122 10排 11座"
    },
    {
        "id": "C122-10-12",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台C122 10排 12座"
    },
    {
        "id": "C122-10-13",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台C122 10排 13座"
    },
    {
        "id": "C122-10-14",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台C122 10排 14座"
    },
    {
        "id": "C122-10-15",
        "areaType": "看台",
        "block": "C122",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台C122 10排 15座"
    },
    {
        "id": "D112-01-01",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台D112 01排 01座"
    },
    {
        "id": "D112-01-02",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台D112 01排 02座"
    },
    {
        "id": "D112-01-03",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台D112 01排 03座"
    },
    {
        "id": "D112-01-04",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台D112 01排 04座"
    },
    {
        "id": "D112-01-05",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台D112 01排 05座"
    },
    {
        "id": "D112-01-06",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台D112 01排 06座"
    },
    {
        "id": "D112-01-07",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台D112 01排 07座"
    },
    {
        "id": "D112-01-08",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台D112 01排 08座"
    },
    {
        "id": "D112-01-09",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台D112 01排 09座"
    },
    {
        "id": "D112-01-10",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台D112 01排 10座"
    },
    {
        "id": "D112-01-11",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台D112 01排 11座"
    },
    {
        "id": "D112-01-12",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台D112 01排 12座"
    },
    {
        "id": "D112-01-13",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台D112 01排 13座"
    },
    {
        "id": "D112-01-14",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台D112 01排 14座"
    },
    {
        "id": "D112-01-15",
        "areaType": "看台",
        "block": "D112",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台D112 01排 15座"
    },
    {
        "id": "D112-02-01",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台D112 02排 01座"
    },
    {
        "id": "D112-02-02",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台D112 02排 02座"
    },
    {
        "id": "D112-02-03",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台D112 02排 03座"
    },
    {
        "id": "D112-02-04",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台D112 02排 04座"
    },
    {
        "id": "D112-02-05",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台D112 02排 05座"
    },
    {
        "id": "D112-02-06",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台D112 02排 06座"
    },
    {
        "id": "D112-02-07",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台D112 02排 07座"
    },
    {
        "id": "D112-02-08",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台D112 02排 08座"
    },
    {
        "id": "D112-02-09",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台D112 02排 09座"
    },
    {
        "id": "D112-02-10",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台D112 02排 10座"
    },
    {
        "id": "D112-02-11",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台D112 02排 11座"
    },
    {
        "id": "D112-02-12",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台D112 02排 12座"
    },
    {
        "id": "D112-02-13",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台D112 02排 13座"
    },
    {
        "id": "D112-02-14",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台D112 02排 14座"
    },
    {
        "id": "D112-02-15",
        "areaType": "看台",
        "block": "D112",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台D112 02排 15座"
    },
    {
        "id": "D112-03-01",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台D112 03排 01座"
    },
    {
        "id": "D112-03-02",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台D112 03排 02座"
    },
    {
        "id": "D112-03-03",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台D112 03排 03座"
    },
    {
        "id": "D112-03-04",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台D112 03排 04座"
    },
    {
        "id": "D112-03-05",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台D112 03排 05座"
    },
    {
        "id": "D112-03-06",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台D112 03排 06座"
    },
    {
        "id": "D112-03-07",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台D112 03排 07座"
    },
    {
        "id": "D112-03-08",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台D112 03排 08座"
    },
    {
        "id": "D112-03-09",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台D112 03排 09座"
    },
    {
        "id": "D112-03-10",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台D112 03排 10座"
    },
    {
        "id": "D112-03-11",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台D112 03排 11座"
    },
    {
        "id": "D112-03-12",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台D112 03排 12座"
    },
    {
        "id": "D112-03-13",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台D112 03排 13座"
    },
    {
        "id": "D112-03-14",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台D112 03排 14座"
    },
    {
        "id": "D112-03-15",
        "areaType": "看台",
        "block": "D112",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台D112 03排 15座"
    },
    {
        "id": "D112-04-01",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台D112 04排 01座"
    },
    {
        "id": "D112-04-02",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台D112 04排 02座"
    },
    {
        "id": "D112-04-03",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台D112 04排 03座"
    },
    {
        "id": "D112-04-04",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台D112 04排 04座"
    },
    {
        "id": "D112-04-05",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台D112 04排 05座"
    },
    {
        "id": "D112-04-06",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台D112 04排 06座"
    },
    {
        "id": "D112-04-07",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台D112 04排 07座"
    },
    {
        "id": "D112-04-08",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台D112 04排 08座"
    },
    {
        "id": "D112-04-09",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台D112 04排 09座"
    },
    {
        "id": "D112-04-10",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台D112 04排 10座"
    },
    {
        "id": "D112-04-11",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台D112 04排 11座"
    },
    {
        "id": "D112-04-12",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台D112 04排 12座"
    },
    {
        "id": "D112-04-13",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台D112 04排 13座"
    },
    {
        "id": "D112-04-14",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台D112 04排 14座"
    },
    {
        "id": "D112-04-15",
        "areaType": "看台",
        "block": "D112",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台D112 04排 15座"
    },
    {
        "id": "D112-05-01",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台D112 05排 01座"
    },
    {
        "id": "D112-05-02",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台D112 05排 02座"
    },
    {
        "id": "D112-05-03",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台D112 05排 03座"
    },
    {
        "id": "D112-05-04",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台D112 05排 04座"
    },
    {
        "id": "D112-05-05",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台D112 05排 05座"
    },
    {
        "id": "D112-05-06",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台D112 05排 06座"
    },
    {
        "id": "D112-05-07",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台D112 05排 07座"
    },
    {
        "id": "D112-05-08",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台D112 05排 08座"
    },
    {
        "id": "D112-05-09",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台D112 05排 09座"
    },
    {
        "id": "D112-05-10",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台D112 05排 10座"
    },
    {
        "id": "D112-05-11",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台D112 05排 11座"
    },
    {
        "id": "D112-05-12",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台D112 05排 12座"
    },
    {
        "id": "D112-05-13",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台D112 05排 13座"
    },
    {
        "id": "D112-05-14",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台D112 05排 14座"
    },
    {
        "id": "D112-05-15",
        "areaType": "看台",
        "block": "D112",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台D112 05排 15座"
    },
    {
        "id": "D112-06-01",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台D112 06排 01座"
    },
    {
        "id": "D112-06-02",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台D112 06排 02座"
    },
    {
        "id": "D112-06-03",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台D112 06排 03座"
    },
    {
        "id": "D112-06-04",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台D112 06排 04座"
    },
    {
        "id": "D112-06-05",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台D112 06排 05座"
    },
    {
        "id": "D112-06-06",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台D112 06排 06座"
    },
    {
        "id": "D112-06-07",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台D112 06排 07座"
    },
    {
        "id": "D112-06-08",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台D112 06排 08座"
    },
    {
        "id": "D112-06-09",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台D112 06排 09座"
    },
    {
        "id": "D112-06-10",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台D112 06排 10座"
    },
    {
        "id": "D112-06-11",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台D112 06排 11座"
    },
    {
        "id": "D112-06-12",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台D112 06排 12座"
    },
    {
        "id": "D112-06-13",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台D112 06排 13座"
    },
    {
        "id": "D112-06-14",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台D112 06排 14座"
    },
    {
        "id": "D112-06-15",
        "areaType": "看台",
        "block": "D112",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台D112 06排 15座"
    },
    {
        "id": "D112-07-01",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台D112 07排 01座"
    },
    {
        "id": "D112-07-02",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台D112 07排 02座"
    },
    {
        "id": "D112-07-03",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台D112 07排 03座"
    },
    {
        "id": "D112-07-04",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台D112 07排 04座"
    },
    {
        "id": "D112-07-05",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台D112 07排 05座"
    },
    {
        "id": "D112-07-06",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台D112 07排 06座"
    },
    {
        "id": "D112-07-07",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台D112 07排 07座"
    },
    {
        "id": "D112-07-08",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台D112 07排 08座"
    },
    {
        "id": "D112-07-09",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台D112 07排 09座"
    },
    {
        "id": "D112-07-10",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台D112 07排 10座"
    },
    {
        "id": "D112-07-11",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台D112 07排 11座"
    },
    {
        "id": "D112-07-12",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台D112 07排 12座"
    },
    {
        "id": "D112-07-13",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台D112 07排 13座"
    },
    {
        "id": "D112-07-14",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台D112 07排 14座"
    },
    {
        "id": "D112-07-15",
        "areaType": "看台",
        "block": "D112",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台D112 07排 15座"
    },
    {
        "id": "D112-08-01",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台D112 08排 01座"
    },
    {
        "id": "D112-08-02",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台D112 08排 02座"
    },
    {
        "id": "D112-08-03",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台D112 08排 03座"
    },
    {
        "id": "D112-08-04",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台D112 08排 04座"
    },
    {
        "id": "D112-08-05",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台D112 08排 05座"
    },
    {
        "id": "D112-08-06",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台D112 08排 06座"
    },
    {
        "id": "D112-08-07",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台D112 08排 07座"
    },
    {
        "id": "D112-08-08",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台D112 08排 08座"
    },
    {
        "id": "D112-08-09",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台D112 08排 09座"
    },
    {
        "id": "D112-08-10",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台D112 08排 10座"
    },
    {
        "id": "D112-08-11",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台D112 08排 11座"
    },
    {
        "id": "D112-08-12",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台D112 08排 12座"
    },
    {
        "id": "D112-08-13",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台D112 08排 13座"
    },
    {
        "id": "D112-08-14",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台D112 08排 14座"
    },
    {
        "id": "D112-08-15",
        "areaType": "看台",
        "block": "D112",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台D112 08排 15座"
    },
    {
        "id": "D112-09-01",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台D112 09排 01座"
    },
    {
        "id": "D112-09-02",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台D112 09排 02座"
    },
    {
        "id": "D112-09-03",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台D112 09排 03座"
    },
    {
        "id": "D112-09-04",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台D112 09排 04座"
    },
    {
        "id": "D112-09-05",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台D112 09排 05座"
    },
    {
        "id": "D112-09-06",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台D112 09排 06座"
    },
    {
        "id": "D112-09-07",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台D112 09排 07座"
    },
    {
        "id": "D112-09-08",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台D112 09排 08座"
    },
    {
        "id": "D112-09-09",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台D112 09排 09座"
    },
    {
        "id": "D112-09-10",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台D112 09排 10座"
    },
    {
        "id": "D112-09-11",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台D112 09排 11座"
    },
    {
        "id": "D112-09-12",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台D112 09排 12座"
    },
    {
        "id": "D112-09-13",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台D112 09排 13座"
    },
    {
        "id": "D112-09-14",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台D112 09排 14座"
    },
    {
        "id": "D112-09-15",
        "areaType": "看台",
        "block": "D112",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台D112 09排 15座"
    },
    {
        "id": "D112-10-01",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台D112 10排 01座"
    },
    {
        "id": "D112-10-02",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台D112 10排 02座"
    },
    {
        "id": "D112-10-03",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台D112 10排 03座"
    },
    {
        "id": "D112-10-04",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台D112 10排 04座"
    },
    {
        "id": "D112-10-05",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台D112 10排 05座"
    },
    {
        "id": "D112-10-06",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台D112 10排 06座"
    },
    {
        "id": "D112-10-07",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台D112 10排 07座"
    },
    {
        "id": "D112-10-08",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台D112 10排 08座"
    },
    {
        "id": "D112-10-09",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台D112 10排 09座"
    },
    {
        "id": "D112-10-10",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台D112 10排 10座"
    },
    {
        "id": "D112-10-11",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台D112 10排 11座"
    },
    {
        "id": "D112-10-12",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台D112 10排 12座"
    },
    {
        "id": "D112-10-13",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台D112 10排 13座"
    },
    {
        "id": "D112-10-14",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台D112 10排 14座"
    },
    {
        "id": "D112-10-15",
        "areaType": "看台",
        "block": "D112",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台D112 10排 15座"
    },
    {
        "id": "D111-01-01",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台D111 01排 01座"
    },
    {
        "id": "D111-01-02",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台D111 01排 02座"
    },
    {
        "id": "D111-01-03",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台D111 01排 03座"
    },
    {
        "id": "D111-01-04",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台D111 01排 04座"
    },
    {
        "id": "D111-01-05",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台D111 01排 05座"
    },
    {
        "id": "D111-01-06",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台D111 01排 06座"
    },
    {
        "id": "D111-01-07",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台D111 01排 07座"
    },
    {
        "id": "D111-01-08",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台D111 01排 08座"
    },
    {
        "id": "D111-01-09",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台D111 01排 09座"
    },
    {
        "id": "D111-01-10",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台D111 01排 10座"
    },
    {
        "id": "D111-01-11",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台D111 01排 11座"
    },
    {
        "id": "D111-01-12",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台D111 01排 12座"
    },
    {
        "id": "D111-01-13",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台D111 01排 13座"
    },
    {
        "id": "D111-01-14",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台D111 01排 14座"
    },
    {
        "id": "D111-01-15",
        "areaType": "看台",
        "block": "D111",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台D111 01排 15座"
    },
    {
        "id": "D111-02-01",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台D111 02排 01座"
    },
    {
        "id": "D111-02-02",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台D111 02排 02座"
    },
    {
        "id": "D111-02-03",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台D111 02排 03座"
    },
    {
        "id": "D111-02-04",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台D111 02排 04座"
    },
    {
        "id": "D111-02-05",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台D111 02排 05座"
    },
    {
        "id": "D111-02-06",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台D111 02排 06座"
    },
    {
        "id": "D111-02-07",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台D111 02排 07座"
    },
    {
        "id": "D111-02-08",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台D111 02排 08座"
    },
    {
        "id": "D111-02-09",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台D111 02排 09座"
    },
    {
        "id": "D111-02-10",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台D111 02排 10座"
    },
    {
        "id": "D111-02-11",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台D111 02排 11座"
    },
    {
        "id": "D111-02-12",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台D111 02排 12座"
    },
    {
        "id": "D111-02-13",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台D111 02排 13座"
    },
    {
        "id": "D111-02-14",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台D111 02排 14座"
    },
    {
        "id": "D111-02-15",
        "areaType": "看台",
        "block": "D111",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台D111 02排 15座"
    },
    {
        "id": "D111-03-01",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台D111 03排 01座"
    },
    {
        "id": "D111-03-02",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台D111 03排 02座"
    },
    {
        "id": "D111-03-03",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台D111 03排 03座"
    },
    {
        "id": "D111-03-04",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台D111 03排 04座"
    },
    {
        "id": "D111-03-05",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台D111 03排 05座"
    },
    {
        "id": "D111-03-06",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台D111 03排 06座"
    },
    {
        "id": "D111-03-07",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台D111 03排 07座"
    },
    {
        "id": "D111-03-08",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台D111 03排 08座"
    },
    {
        "id": "D111-03-09",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台D111 03排 09座"
    },
    {
        "id": "D111-03-10",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台D111 03排 10座"
    },
    {
        "id": "D111-03-11",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台D111 03排 11座"
    },
    {
        "id": "D111-03-12",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台D111 03排 12座"
    },
    {
        "id": "D111-03-13",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台D111 03排 13座"
    },
    {
        "id": "D111-03-14",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台D111 03排 14座"
    },
    {
        "id": "D111-03-15",
        "areaType": "看台",
        "block": "D111",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台D111 03排 15座"
    },
    {
        "id": "D111-04-01",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台D111 04排 01座"
    },
    {
        "id": "D111-04-02",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台D111 04排 02座"
    },
    {
        "id": "D111-04-03",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台D111 04排 03座"
    },
    {
        "id": "D111-04-04",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台D111 04排 04座"
    },
    {
        "id": "D111-04-05",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台D111 04排 05座"
    },
    {
        "id": "D111-04-06",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台D111 04排 06座"
    },
    {
        "id": "D111-04-07",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台D111 04排 07座"
    },
    {
        "id": "D111-04-08",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台D111 04排 08座"
    },
    {
        "id": "D111-04-09",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台D111 04排 09座"
    },
    {
        "id": "D111-04-10",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台D111 04排 10座"
    },
    {
        "id": "D111-04-11",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台D111 04排 11座"
    },
    {
        "id": "D111-04-12",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台D111 04排 12座"
    },
    {
        "id": "D111-04-13",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台D111 04排 13座"
    },
    {
        "id": "D111-04-14",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台D111 04排 14座"
    },
    {
        "id": "D111-04-15",
        "areaType": "看台",
        "block": "D111",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台D111 04排 15座"
    },
    {
        "id": "D111-05-01",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台D111 05排 01座"
    },
    {
        "id": "D111-05-02",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台D111 05排 02座"
    },
    {
        "id": "D111-05-03",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台D111 05排 03座"
    },
    {
        "id": "D111-05-04",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台D111 05排 04座"
    },
    {
        "id": "D111-05-05",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台D111 05排 05座"
    },
    {
        "id": "D111-05-06",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台D111 05排 06座"
    },
    {
        "id": "D111-05-07",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台D111 05排 07座"
    },
    {
        "id": "D111-05-08",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台D111 05排 08座"
    },
    {
        "id": "D111-05-09",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台D111 05排 09座"
    },
    {
        "id": "D111-05-10",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台D111 05排 10座"
    },
    {
        "id": "D111-05-11",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台D111 05排 11座"
    },
    {
        "id": "D111-05-12",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台D111 05排 12座"
    },
    {
        "id": "D111-05-13",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台D111 05排 13座"
    },
    {
        "id": "D111-05-14",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台D111 05排 14座"
    },
    {
        "id": "D111-05-15",
        "areaType": "看台",
        "block": "D111",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台D111 05排 15座"
    },
    {
        "id": "D111-06-01",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台D111 06排 01座"
    },
    {
        "id": "D111-06-02",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台D111 06排 02座"
    },
    {
        "id": "D111-06-03",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台D111 06排 03座"
    },
    {
        "id": "D111-06-04",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台D111 06排 04座"
    },
    {
        "id": "D111-06-05",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台D111 06排 05座"
    },
    {
        "id": "D111-06-06",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台D111 06排 06座"
    },
    {
        "id": "D111-06-07",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台D111 06排 07座"
    },
    {
        "id": "D111-06-08",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台D111 06排 08座"
    },
    {
        "id": "D111-06-09",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台D111 06排 09座"
    },
    {
        "id": "D111-06-10",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台D111 06排 10座"
    },
    {
        "id": "D111-06-11",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台D111 06排 11座"
    },
    {
        "id": "D111-06-12",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台D111 06排 12座"
    },
    {
        "id": "D111-06-13",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台D111 06排 13座"
    },
    {
        "id": "D111-06-14",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台D111 06排 14座"
    },
    {
        "id": "D111-06-15",
        "areaType": "看台",
        "block": "D111",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台D111 06排 15座"
    },
    {
        "id": "D111-07-01",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台D111 07排 01座"
    },
    {
        "id": "D111-07-02",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台D111 07排 02座"
    },
    {
        "id": "D111-07-03",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台D111 07排 03座"
    },
    {
        "id": "D111-07-04",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台D111 07排 04座"
    },
    {
        "id": "D111-07-05",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台D111 07排 05座"
    },
    {
        "id": "D111-07-06",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台D111 07排 06座"
    },
    {
        "id": "D111-07-07",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台D111 07排 07座"
    },
    {
        "id": "D111-07-08",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台D111 07排 08座"
    },
    {
        "id": "D111-07-09",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台D111 07排 09座"
    },
    {
        "id": "D111-07-10",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台D111 07排 10座"
    },
    {
        "id": "D111-07-11",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台D111 07排 11座"
    },
    {
        "id": "D111-07-12",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台D111 07排 12座"
    },
    {
        "id": "D111-07-13",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台D111 07排 13座"
    },
    {
        "id": "D111-07-14",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台D111 07排 14座"
    },
    {
        "id": "D111-07-15",
        "areaType": "看台",
        "block": "D111",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台D111 07排 15座"
    },
    {
        "id": "D111-08-01",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台D111 08排 01座"
    },
    {
        "id": "D111-08-02",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台D111 08排 02座"
    },
    {
        "id": "D111-08-03",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台D111 08排 03座"
    },
    {
        "id": "D111-08-04",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台D111 08排 04座"
    },
    {
        "id": "D111-08-05",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台D111 08排 05座"
    },
    {
        "id": "D111-08-06",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台D111 08排 06座"
    },
    {
        "id": "D111-08-07",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台D111 08排 07座"
    },
    {
        "id": "D111-08-08",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台D111 08排 08座"
    },
    {
        "id": "D111-08-09",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台D111 08排 09座"
    },
    {
        "id": "D111-08-10",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台D111 08排 10座"
    },
    {
        "id": "D111-08-11",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台D111 08排 11座"
    },
    {
        "id": "D111-08-12",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台D111 08排 12座"
    },
    {
        "id": "D111-08-13",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台D111 08排 13座"
    },
    {
        "id": "D111-08-14",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台D111 08排 14座"
    },
    {
        "id": "D111-08-15",
        "areaType": "看台",
        "block": "D111",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台D111 08排 15座"
    },
    {
        "id": "D111-09-01",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台D111 09排 01座"
    },
    {
        "id": "D111-09-02",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台D111 09排 02座"
    },
    {
        "id": "D111-09-03",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台D111 09排 03座"
    },
    {
        "id": "D111-09-04",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台D111 09排 04座"
    },
    {
        "id": "D111-09-05",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台D111 09排 05座"
    },
    {
        "id": "D111-09-06",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台D111 09排 06座"
    },
    {
        "id": "D111-09-07",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台D111 09排 07座"
    },
    {
        "id": "D111-09-08",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台D111 09排 08座"
    },
    {
        "id": "D111-09-09",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台D111 09排 09座"
    },
    {
        "id": "D111-09-10",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台D111 09排 10座"
    },
    {
        "id": "D111-09-11",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台D111 09排 11座"
    },
    {
        "id": "D111-09-12",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台D111 09排 12座"
    },
    {
        "id": "D111-09-13",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台D111 09排 13座"
    },
    {
        "id": "D111-09-14",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台D111 09排 14座"
    },
    {
        "id": "D111-09-15",
        "areaType": "看台",
        "block": "D111",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台D111 09排 15座"
    },
    {
        "id": "D111-10-01",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台D111 10排 01座"
    },
    {
        "id": "D111-10-02",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台D111 10排 02座"
    },
    {
        "id": "D111-10-03",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台D111 10排 03座"
    },
    {
        "id": "D111-10-04",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台D111 10排 04座"
    },
    {
        "id": "D111-10-05",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台D111 10排 05座"
    },
    {
        "id": "D111-10-06",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台D111 10排 06座"
    },
    {
        "id": "D111-10-07",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台D111 10排 07座"
    },
    {
        "id": "D111-10-08",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台D111 10排 08座"
    },
    {
        "id": "D111-10-09",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台D111 10排 09座"
    },
    {
        "id": "D111-10-10",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台D111 10排 10座"
    },
    {
        "id": "D111-10-11",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台D111 10排 11座"
    },
    {
        "id": "D111-10-12",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台D111 10排 12座"
    },
    {
        "id": "D111-10-13",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台D111 10排 13座"
    },
    {
        "id": "D111-10-14",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台D111 10排 14座"
    },
    {
        "id": "D111-10-15",
        "areaType": "看台",
        "block": "D111",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台D111 10排 15座"
    },
    {
        "id": "D110-01-01",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台D110 01排 01座"
    },
    {
        "id": "D110-01-02",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台D110 01排 02座"
    },
    {
        "id": "D110-01-03",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台D110 01排 03座"
    },
    {
        "id": "D110-01-04",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台D110 01排 04座"
    },
    {
        "id": "D110-01-05",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台D110 01排 05座"
    },
    {
        "id": "D110-01-06",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台D110 01排 06座"
    },
    {
        "id": "D110-01-07",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台D110 01排 07座"
    },
    {
        "id": "D110-01-08",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台D110 01排 08座"
    },
    {
        "id": "D110-01-09",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台D110 01排 09座"
    },
    {
        "id": "D110-01-10",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台D110 01排 10座"
    },
    {
        "id": "D110-01-11",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台D110 01排 11座"
    },
    {
        "id": "D110-01-12",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台D110 01排 12座"
    },
    {
        "id": "D110-01-13",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台D110 01排 13座"
    },
    {
        "id": "D110-01-14",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台D110 01排 14座"
    },
    {
        "id": "D110-01-15",
        "areaType": "看台",
        "block": "D110",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台D110 01排 15座"
    },
    {
        "id": "D110-02-01",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台D110 02排 01座"
    },
    {
        "id": "D110-02-02",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台D110 02排 02座"
    },
    {
        "id": "D110-02-03",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台D110 02排 03座"
    },
    {
        "id": "D110-02-04",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台D110 02排 04座"
    },
    {
        "id": "D110-02-05",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台D110 02排 05座"
    },
    {
        "id": "D110-02-06",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台D110 02排 06座"
    },
    {
        "id": "D110-02-07",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台D110 02排 07座"
    },
    {
        "id": "D110-02-08",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台D110 02排 08座"
    },
    {
        "id": "D110-02-09",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台D110 02排 09座"
    },
    {
        "id": "D110-02-10",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台D110 02排 10座"
    },
    {
        "id": "D110-02-11",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台D110 02排 11座"
    },
    {
        "id": "D110-02-12",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台D110 02排 12座"
    },
    {
        "id": "D110-02-13",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台D110 02排 13座"
    },
    {
        "id": "D110-02-14",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台D110 02排 14座"
    },
    {
        "id": "D110-02-15",
        "areaType": "看台",
        "block": "D110",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台D110 02排 15座"
    },
    {
        "id": "D110-03-01",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台D110 03排 01座"
    },
    {
        "id": "D110-03-02",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台D110 03排 02座"
    },
    {
        "id": "D110-03-03",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台D110 03排 03座"
    },
    {
        "id": "D110-03-04",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台D110 03排 04座"
    },
    {
        "id": "D110-03-05",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台D110 03排 05座"
    },
    {
        "id": "D110-03-06",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台D110 03排 06座"
    },
    {
        "id": "D110-03-07",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台D110 03排 07座"
    },
    {
        "id": "D110-03-08",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台D110 03排 08座"
    },
    {
        "id": "D110-03-09",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台D110 03排 09座"
    },
    {
        "id": "D110-03-10",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台D110 03排 10座"
    },
    {
        "id": "D110-03-11",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台D110 03排 11座"
    },
    {
        "id": "D110-03-12",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台D110 03排 12座"
    },
    {
        "id": "D110-03-13",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台D110 03排 13座"
    },
    {
        "id": "D110-03-14",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台D110 03排 14座"
    },
    {
        "id": "D110-03-15",
        "areaType": "看台",
        "block": "D110",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台D110 03排 15座"
    },
    {
        "id": "D110-04-01",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台D110 04排 01座"
    },
    {
        "id": "D110-04-02",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台D110 04排 02座"
    },
    {
        "id": "D110-04-03",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台D110 04排 03座"
    },
    {
        "id": "D110-04-04",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台D110 04排 04座"
    },
    {
        "id": "D110-04-05",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台D110 04排 05座"
    },
    {
        "id": "D110-04-06",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台D110 04排 06座"
    },
    {
        "id": "D110-04-07",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台D110 04排 07座"
    },
    {
        "id": "D110-04-08",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台D110 04排 08座"
    },
    {
        "id": "D110-04-09",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台D110 04排 09座"
    },
    {
        "id": "D110-04-10",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台D110 04排 10座"
    },
    {
        "id": "D110-04-11",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台D110 04排 11座"
    },
    {
        "id": "D110-04-12",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台D110 04排 12座"
    },
    {
        "id": "D110-04-13",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台D110 04排 13座"
    },
    {
        "id": "D110-04-14",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台D110 04排 14座"
    },
    {
        "id": "D110-04-15",
        "areaType": "看台",
        "block": "D110",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台D110 04排 15座"
    },
    {
        "id": "D110-05-01",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台D110 05排 01座"
    },
    {
        "id": "D110-05-02",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台D110 05排 02座"
    },
    {
        "id": "D110-05-03",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台D110 05排 03座"
    },
    {
        "id": "D110-05-04",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台D110 05排 04座"
    },
    {
        "id": "D110-05-05",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台D110 05排 05座"
    },
    {
        "id": "D110-05-06",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台D110 05排 06座"
    },
    {
        "id": "D110-05-07",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台D110 05排 07座"
    },
    {
        "id": "D110-05-08",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台D110 05排 08座"
    },
    {
        "id": "D110-05-09",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台D110 05排 09座"
    },
    {
        "id": "D110-05-10",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台D110 05排 10座"
    },
    {
        "id": "D110-05-11",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台D110 05排 11座"
    },
    {
        "id": "D110-05-12",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台D110 05排 12座"
    },
    {
        "id": "D110-05-13",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台D110 05排 13座"
    },
    {
        "id": "D110-05-14",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台D110 05排 14座"
    },
    {
        "id": "D110-05-15",
        "areaType": "看台",
        "block": "D110",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台D110 05排 15座"
    },
    {
        "id": "D110-06-01",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台D110 06排 01座"
    },
    {
        "id": "D110-06-02",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台D110 06排 02座"
    },
    {
        "id": "D110-06-03",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台D110 06排 03座"
    },
    {
        "id": "D110-06-04",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台D110 06排 04座"
    },
    {
        "id": "D110-06-05",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台D110 06排 05座"
    },
    {
        "id": "D110-06-06",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台D110 06排 06座"
    },
    {
        "id": "D110-06-07",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台D110 06排 07座"
    },
    {
        "id": "D110-06-08",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台D110 06排 08座"
    },
    {
        "id": "D110-06-09",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台D110 06排 09座"
    },
    {
        "id": "D110-06-10",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台D110 06排 10座"
    },
    {
        "id": "D110-06-11",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台D110 06排 11座"
    },
    {
        "id": "D110-06-12",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台D110 06排 12座"
    },
    {
        "id": "D110-06-13",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台D110 06排 13座"
    },
    {
        "id": "D110-06-14",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台D110 06排 14座"
    },
    {
        "id": "D110-06-15",
        "areaType": "看台",
        "block": "D110",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台D110 06排 15座"
    },
    {
        "id": "D110-07-01",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台D110 07排 01座"
    },
    {
        "id": "D110-07-02",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台D110 07排 02座"
    },
    {
        "id": "D110-07-03",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台D110 07排 03座"
    },
    {
        "id": "D110-07-04",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台D110 07排 04座"
    },
    {
        "id": "D110-07-05",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台D110 07排 05座"
    },
    {
        "id": "D110-07-06",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台D110 07排 06座"
    },
    {
        "id": "D110-07-07",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台D110 07排 07座"
    },
    {
        "id": "D110-07-08",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台D110 07排 08座"
    },
    {
        "id": "D110-07-09",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台D110 07排 09座"
    },
    {
        "id": "D110-07-10",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台D110 07排 10座"
    },
    {
        "id": "D110-07-11",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台D110 07排 11座"
    },
    {
        "id": "D110-07-12",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台D110 07排 12座"
    },
    {
        "id": "D110-07-13",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台D110 07排 13座"
    },
    {
        "id": "D110-07-14",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台D110 07排 14座"
    },
    {
        "id": "D110-07-15",
        "areaType": "看台",
        "block": "D110",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台D110 07排 15座"
    },
    {
        "id": "D110-08-01",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台D110 08排 01座"
    },
    {
        "id": "D110-08-02",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台D110 08排 02座"
    },
    {
        "id": "D110-08-03",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台D110 08排 03座"
    },
    {
        "id": "D110-08-04",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台D110 08排 04座"
    },
    {
        "id": "D110-08-05",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台D110 08排 05座"
    },
    {
        "id": "D110-08-06",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台D110 08排 06座"
    },
    {
        "id": "D110-08-07",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台D110 08排 07座"
    },
    {
        "id": "D110-08-08",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台D110 08排 08座"
    },
    {
        "id": "D110-08-09",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台D110 08排 09座"
    },
    {
        "id": "D110-08-10",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台D110 08排 10座"
    },
    {
        "id": "D110-08-11",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台D110 08排 11座"
    },
    {
        "id": "D110-08-12",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台D110 08排 12座"
    },
    {
        "id": "D110-08-13",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台D110 08排 13座"
    },
    {
        "id": "D110-08-14",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台D110 08排 14座"
    },
    {
        "id": "D110-08-15",
        "areaType": "看台",
        "block": "D110",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台D110 08排 15座"
    },
    {
        "id": "D110-09-01",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台D110 09排 01座"
    },
    {
        "id": "D110-09-02",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台D110 09排 02座"
    },
    {
        "id": "D110-09-03",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台D110 09排 03座"
    },
    {
        "id": "D110-09-04",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台D110 09排 04座"
    },
    {
        "id": "D110-09-05",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台D110 09排 05座"
    },
    {
        "id": "D110-09-06",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台D110 09排 06座"
    },
    {
        "id": "D110-09-07",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台D110 09排 07座"
    },
    {
        "id": "D110-09-08",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台D110 09排 08座"
    },
    {
        "id": "D110-09-09",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台D110 09排 09座"
    },
    {
        "id": "D110-09-10",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台D110 09排 10座"
    },
    {
        "id": "D110-09-11",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台D110 09排 11座"
    },
    {
        "id": "D110-09-12",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台D110 09排 12座"
    },
    {
        "id": "D110-09-13",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台D110 09排 13座"
    },
    {
        "id": "D110-09-14",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台D110 09排 14座"
    },
    {
        "id": "D110-09-15",
        "areaType": "看台",
        "block": "D110",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台D110 09排 15座"
    },
    {
        "id": "D110-10-01",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台D110 10排 01座"
    },
    {
        "id": "D110-10-02",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台D110 10排 02座"
    },
    {
        "id": "D110-10-03",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台D110 10排 03座"
    },
    {
        "id": "D110-10-04",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台D110 10排 04座"
    },
    {
        "id": "D110-10-05",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台D110 10排 05座"
    },
    {
        "id": "D110-10-06",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台D110 10排 06座"
    },
    {
        "id": "D110-10-07",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台D110 10排 07座"
    },
    {
        "id": "D110-10-08",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台D110 10排 08座"
    },
    {
        "id": "D110-10-09",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台D110 10排 09座"
    },
    {
        "id": "D110-10-10",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台D110 10排 10座"
    },
    {
        "id": "D110-10-11",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台D110 10排 11座"
    },
    {
        "id": "D110-10-12",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台D110 10排 12座"
    },
    {
        "id": "D110-10-13",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台D110 10排 13座"
    },
    {
        "id": "D110-10-14",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台D110 10排 14座"
    },
    {
        "id": "D110-10-15",
        "areaType": "看台",
        "block": "D110",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台D110 10排 15座"
    },
    {
        "id": "D109-01-01",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台D109 01排 01座"
    },
    {
        "id": "D109-01-02",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台D109 01排 02座"
    },
    {
        "id": "D109-01-03",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台D109 01排 03座"
    },
    {
        "id": "D109-01-04",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台D109 01排 04座"
    },
    {
        "id": "D109-01-05",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台D109 01排 05座"
    },
    {
        "id": "D109-01-06",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台D109 01排 06座"
    },
    {
        "id": "D109-01-07",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台D109 01排 07座"
    },
    {
        "id": "D109-01-08",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台D109 01排 08座"
    },
    {
        "id": "D109-01-09",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台D109 01排 09座"
    },
    {
        "id": "D109-01-10",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台D109 01排 10座"
    },
    {
        "id": "D109-01-11",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台D109 01排 11座"
    },
    {
        "id": "D109-01-12",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台D109 01排 12座"
    },
    {
        "id": "D109-01-13",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台D109 01排 13座"
    },
    {
        "id": "D109-01-14",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台D109 01排 14座"
    },
    {
        "id": "D109-01-15",
        "areaType": "看台",
        "block": "D109",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台D109 01排 15座"
    },
    {
        "id": "D109-02-01",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台D109 02排 01座"
    },
    {
        "id": "D109-02-02",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台D109 02排 02座"
    },
    {
        "id": "D109-02-03",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台D109 02排 03座"
    },
    {
        "id": "D109-02-04",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台D109 02排 04座"
    },
    {
        "id": "D109-02-05",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台D109 02排 05座"
    },
    {
        "id": "D109-02-06",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台D109 02排 06座"
    },
    {
        "id": "D109-02-07",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台D109 02排 07座"
    },
    {
        "id": "D109-02-08",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台D109 02排 08座"
    },
    {
        "id": "D109-02-09",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台D109 02排 09座"
    },
    {
        "id": "D109-02-10",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台D109 02排 10座"
    },
    {
        "id": "D109-02-11",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台D109 02排 11座"
    },
    {
        "id": "D109-02-12",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台D109 02排 12座"
    },
    {
        "id": "D109-02-13",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台D109 02排 13座"
    },
    {
        "id": "D109-02-14",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台D109 02排 14座"
    },
    {
        "id": "D109-02-15",
        "areaType": "看台",
        "block": "D109",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台D109 02排 15座"
    },
    {
        "id": "D109-03-01",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台D109 03排 01座"
    },
    {
        "id": "D109-03-02",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台D109 03排 02座"
    },
    {
        "id": "D109-03-03",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台D109 03排 03座"
    },
    {
        "id": "D109-03-04",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台D109 03排 04座"
    },
    {
        "id": "D109-03-05",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台D109 03排 05座"
    },
    {
        "id": "D109-03-06",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台D109 03排 06座"
    },
    {
        "id": "D109-03-07",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台D109 03排 07座"
    },
    {
        "id": "D109-03-08",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台D109 03排 08座"
    },
    {
        "id": "D109-03-09",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台D109 03排 09座"
    },
    {
        "id": "D109-03-10",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台D109 03排 10座"
    },
    {
        "id": "D109-03-11",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台D109 03排 11座"
    },
    {
        "id": "D109-03-12",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台D109 03排 12座"
    },
    {
        "id": "D109-03-13",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台D109 03排 13座"
    },
    {
        "id": "D109-03-14",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台D109 03排 14座"
    },
    {
        "id": "D109-03-15",
        "areaType": "看台",
        "block": "D109",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台D109 03排 15座"
    },
    {
        "id": "D109-04-01",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台D109 04排 01座"
    },
    {
        "id": "D109-04-02",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台D109 04排 02座"
    },
    {
        "id": "D109-04-03",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台D109 04排 03座"
    },
    {
        "id": "D109-04-04",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台D109 04排 04座"
    },
    {
        "id": "D109-04-05",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台D109 04排 05座"
    },
    {
        "id": "D109-04-06",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台D109 04排 06座"
    },
    {
        "id": "D109-04-07",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台D109 04排 07座"
    },
    {
        "id": "D109-04-08",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台D109 04排 08座"
    },
    {
        "id": "D109-04-09",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台D109 04排 09座"
    },
    {
        "id": "D109-04-10",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台D109 04排 10座"
    },
    {
        "id": "D109-04-11",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台D109 04排 11座"
    },
    {
        "id": "D109-04-12",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台D109 04排 12座"
    },
    {
        "id": "D109-04-13",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台D109 04排 13座"
    },
    {
        "id": "D109-04-14",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台D109 04排 14座"
    },
    {
        "id": "D109-04-15",
        "areaType": "看台",
        "block": "D109",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台D109 04排 15座"
    },
    {
        "id": "D109-05-01",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台D109 05排 01座"
    },
    {
        "id": "D109-05-02",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台D109 05排 02座"
    },
    {
        "id": "D109-05-03",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台D109 05排 03座"
    },
    {
        "id": "D109-05-04",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台D109 05排 04座"
    },
    {
        "id": "D109-05-05",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台D109 05排 05座"
    },
    {
        "id": "D109-05-06",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台D109 05排 06座"
    },
    {
        "id": "D109-05-07",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台D109 05排 07座"
    },
    {
        "id": "D109-05-08",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台D109 05排 08座"
    },
    {
        "id": "D109-05-09",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台D109 05排 09座"
    },
    {
        "id": "D109-05-10",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台D109 05排 10座"
    },
    {
        "id": "D109-05-11",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台D109 05排 11座"
    },
    {
        "id": "D109-05-12",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台D109 05排 12座"
    },
    {
        "id": "D109-05-13",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台D109 05排 13座"
    },
    {
        "id": "D109-05-14",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台D109 05排 14座"
    },
    {
        "id": "D109-05-15",
        "areaType": "看台",
        "block": "D109",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台D109 05排 15座"
    },
    {
        "id": "D109-06-01",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台D109 06排 01座"
    },
    {
        "id": "D109-06-02",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台D109 06排 02座"
    },
    {
        "id": "D109-06-03",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台D109 06排 03座"
    },
    {
        "id": "D109-06-04",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台D109 06排 04座"
    },
    {
        "id": "D109-06-05",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台D109 06排 05座"
    },
    {
        "id": "D109-06-06",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台D109 06排 06座"
    },
    {
        "id": "D109-06-07",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台D109 06排 07座"
    },
    {
        "id": "D109-06-08",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台D109 06排 08座"
    },
    {
        "id": "D109-06-09",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台D109 06排 09座"
    },
    {
        "id": "D109-06-10",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台D109 06排 10座"
    },
    {
        "id": "D109-06-11",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台D109 06排 11座"
    },
    {
        "id": "D109-06-12",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台D109 06排 12座"
    },
    {
        "id": "D109-06-13",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台D109 06排 13座"
    },
    {
        "id": "D109-06-14",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台D109 06排 14座"
    },
    {
        "id": "D109-06-15",
        "areaType": "看台",
        "block": "D109",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台D109 06排 15座"
    },
    {
        "id": "D109-07-01",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台D109 07排 01座"
    },
    {
        "id": "D109-07-02",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台D109 07排 02座"
    },
    {
        "id": "D109-07-03",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台D109 07排 03座"
    },
    {
        "id": "D109-07-04",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台D109 07排 04座"
    },
    {
        "id": "D109-07-05",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台D109 07排 05座"
    },
    {
        "id": "D109-07-06",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台D109 07排 06座"
    },
    {
        "id": "D109-07-07",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台D109 07排 07座"
    },
    {
        "id": "D109-07-08",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台D109 07排 08座"
    },
    {
        "id": "D109-07-09",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台D109 07排 09座"
    },
    {
        "id": "D109-07-10",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台D109 07排 10座"
    },
    {
        "id": "D109-07-11",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台D109 07排 11座"
    },
    {
        "id": "D109-07-12",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台D109 07排 12座"
    },
    {
        "id": "D109-07-13",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台D109 07排 13座"
    },
    {
        "id": "D109-07-14",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台D109 07排 14座"
    },
    {
        "id": "D109-07-15",
        "areaType": "看台",
        "block": "D109",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台D109 07排 15座"
    },
    {
        "id": "D109-08-01",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台D109 08排 01座"
    },
    {
        "id": "D109-08-02",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台D109 08排 02座"
    },
    {
        "id": "D109-08-03",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台D109 08排 03座"
    },
    {
        "id": "D109-08-04",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台D109 08排 04座"
    },
    {
        "id": "D109-08-05",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台D109 08排 05座"
    },
    {
        "id": "D109-08-06",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台D109 08排 06座"
    },
    {
        "id": "D109-08-07",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台D109 08排 07座"
    },
    {
        "id": "D109-08-08",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台D109 08排 08座"
    },
    {
        "id": "D109-08-09",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台D109 08排 09座"
    },
    {
        "id": "D109-08-10",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台D109 08排 10座"
    },
    {
        "id": "D109-08-11",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台D109 08排 11座"
    },
    {
        "id": "D109-08-12",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台D109 08排 12座"
    },
    {
        "id": "D109-08-13",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台D109 08排 13座"
    },
    {
        "id": "D109-08-14",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台D109 08排 14座"
    },
    {
        "id": "D109-08-15",
        "areaType": "看台",
        "block": "D109",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台D109 08排 15座"
    },
    {
        "id": "D109-09-01",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台D109 09排 01座"
    },
    {
        "id": "D109-09-02",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台D109 09排 02座"
    },
    {
        "id": "D109-09-03",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台D109 09排 03座"
    },
    {
        "id": "D109-09-04",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台D109 09排 04座"
    },
    {
        "id": "D109-09-05",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台D109 09排 05座"
    },
    {
        "id": "D109-09-06",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台D109 09排 06座"
    },
    {
        "id": "D109-09-07",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台D109 09排 07座"
    },
    {
        "id": "D109-09-08",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台D109 09排 08座"
    },
    {
        "id": "D109-09-09",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台D109 09排 09座"
    },
    {
        "id": "D109-09-10",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台D109 09排 10座"
    },
    {
        "id": "D109-09-11",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台D109 09排 11座"
    },
    {
        "id": "D109-09-12",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台D109 09排 12座"
    },
    {
        "id": "D109-09-13",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台D109 09排 13座"
    },
    {
        "id": "D109-09-14",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台D109 09排 14座"
    },
    {
        "id": "D109-09-15",
        "areaType": "看台",
        "block": "D109",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台D109 09排 15座"
    },
    {
        "id": "D109-10-01",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台D109 10排 01座"
    },
    {
        "id": "D109-10-02",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台D109 10排 02座"
    },
    {
        "id": "D109-10-03",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台D109 10排 03座"
    },
    {
        "id": "D109-10-04",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台D109 10排 04座"
    },
    {
        "id": "D109-10-05",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台D109 10排 05座"
    },
    {
        "id": "D109-10-06",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台D109 10排 06座"
    },
    {
        "id": "D109-10-07",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台D109 10排 07座"
    },
    {
        "id": "D109-10-08",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台D109 10排 08座"
    },
    {
        "id": "D109-10-09",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台D109 10排 09座"
    },
    {
        "id": "D109-10-10",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台D109 10排 10座"
    },
    {
        "id": "D109-10-11",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台D109 10排 11座"
    },
    {
        "id": "D109-10-12",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台D109 10排 12座"
    },
    {
        "id": "D109-10-13",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台D109 10排 13座"
    },
    {
        "id": "D109-10-14",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台D109 10排 14座"
    },
    {
        "id": "D109-10-15",
        "areaType": "看台",
        "block": "D109",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台D109 10排 15座"
    },
    {
        "id": "D108-01-01",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 1,
        "rowLabel": "01",
        "seatLabel": "01",
        "display": "看台D108 01排 01座"
    },
    {
        "id": "D108-01-02",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 2,
        "rowLabel": "01",
        "seatLabel": "02",
        "display": "看台D108 01排 02座"
    },
    {
        "id": "D108-01-03",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 3,
        "rowLabel": "01",
        "seatLabel": "03",
        "display": "看台D108 01排 03座"
    },
    {
        "id": "D108-01-04",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 4,
        "rowLabel": "01",
        "seatLabel": "04",
        "display": "看台D108 01排 04座"
    },
    {
        "id": "D108-01-05",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 5,
        "rowLabel": "01",
        "seatLabel": "05",
        "display": "看台D108 01排 05座"
    },
    {
        "id": "D108-01-06",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 6,
        "rowLabel": "01",
        "seatLabel": "06",
        "display": "看台D108 01排 06座"
    },
    {
        "id": "D108-01-07",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 7,
        "rowLabel": "01",
        "seatLabel": "07",
        "display": "看台D108 01排 07座"
    },
    {
        "id": "D108-01-08",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 8,
        "rowLabel": "01",
        "seatLabel": "08",
        "display": "看台D108 01排 08座"
    },
    {
        "id": "D108-01-09",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 9,
        "rowLabel": "01",
        "seatLabel": "09",
        "display": "看台D108 01排 09座"
    },
    {
        "id": "D108-01-10",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 10,
        "rowLabel": "01",
        "seatLabel": "10",
        "display": "看台D108 01排 10座"
    },
    {
        "id": "D108-01-11",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 11,
        "rowLabel": "01",
        "seatLabel": "11",
        "display": "看台D108 01排 11座"
    },
    {
        "id": "D108-01-12",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 12,
        "rowLabel": "01",
        "seatLabel": "12",
        "display": "看台D108 01排 12座"
    },
    {
        "id": "D108-01-13",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 13,
        "rowLabel": "01",
        "seatLabel": "13",
        "display": "看台D108 01排 13座"
    },
    {
        "id": "D108-01-14",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 14,
        "rowLabel": "01",
        "seatLabel": "14",
        "display": "看台D108 01排 14座"
    },
    {
        "id": "D108-01-15",
        "areaType": "看台",
        "block": "D108",
        "row": 1,
        "seat": 15,
        "rowLabel": "01",
        "seatLabel": "15",
        "display": "看台D108 01排 15座"
    },
    {
        "id": "D108-02-01",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 1,
        "rowLabel": "02",
        "seatLabel": "01",
        "display": "看台D108 02排 01座"
    },
    {
        "id": "D108-02-02",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 2,
        "rowLabel": "02",
        "seatLabel": "02",
        "display": "看台D108 02排 02座"
    },
    {
        "id": "D108-02-03",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 3,
        "rowLabel": "02",
        "seatLabel": "03",
        "display": "看台D108 02排 03座"
    },
    {
        "id": "D108-02-04",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 4,
        "rowLabel": "02",
        "seatLabel": "04",
        "display": "看台D108 02排 04座"
    },
    {
        "id": "D108-02-05",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 5,
        "rowLabel": "02",
        "seatLabel": "05",
        "display": "看台D108 02排 05座"
    },
    {
        "id": "D108-02-06",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 6,
        "rowLabel": "02",
        "seatLabel": "06",
        "display": "看台D108 02排 06座"
    },
    {
        "id": "D108-02-07",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 7,
        "rowLabel": "02",
        "seatLabel": "07",
        "display": "看台D108 02排 07座"
    },
    {
        "id": "D108-02-08",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 8,
        "rowLabel": "02",
        "seatLabel": "08",
        "display": "看台D108 02排 08座"
    },
    {
        "id": "D108-02-09",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 9,
        "rowLabel": "02",
        "seatLabel": "09",
        "display": "看台D108 02排 09座"
    },
    {
        "id": "D108-02-10",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 10,
        "rowLabel": "02",
        "seatLabel": "10",
        "display": "看台D108 02排 10座"
    },
    {
        "id": "D108-02-11",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 11,
        "rowLabel": "02",
        "seatLabel": "11",
        "display": "看台D108 02排 11座"
    },
    {
        "id": "D108-02-12",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 12,
        "rowLabel": "02",
        "seatLabel": "12",
        "display": "看台D108 02排 12座"
    },
    {
        "id": "D108-02-13",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 13,
        "rowLabel": "02",
        "seatLabel": "13",
        "display": "看台D108 02排 13座"
    },
    {
        "id": "D108-02-14",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 14,
        "rowLabel": "02",
        "seatLabel": "14",
        "display": "看台D108 02排 14座"
    },
    {
        "id": "D108-02-15",
        "areaType": "看台",
        "block": "D108",
        "row": 2,
        "seat": 15,
        "rowLabel": "02",
        "seatLabel": "15",
        "display": "看台D108 02排 15座"
    },
    {
        "id": "D108-03-01",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 1,
        "rowLabel": "03",
        "seatLabel": "01",
        "display": "看台D108 03排 01座"
    },
    {
        "id": "D108-03-02",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 2,
        "rowLabel": "03",
        "seatLabel": "02",
        "display": "看台D108 03排 02座"
    },
    {
        "id": "D108-03-03",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 3,
        "rowLabel": "03",
        "seatLabel": "03",
        "display": "看台D108 03排 03座"
    },
    {
        "id": "D108-03-04",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 4,
        "rowLabel": "03",
        "seatLabel": "04",
        "display": "看台D108 03排 04座"
    },
    {
        "id": "D108-03-05",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 5,
        "rowLabel": "03",
        "seatLabel": "05",
        "display": "看台D108 03排 05座"
    },
    {
        "id": "D108-03-06",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 6,
        "rowLabel": "03",
        "seatLabel": "06",
        "display": "看台D108 03排 06座"
    },
    {
        "id": "D108-03-07",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 7,
        "rowLabel": "03",
        "seatLabel": "07",
        "display": "看台D108 03排 07座"
    },
    {
        "id": "D108-03-08",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 8,
        "rowLabel": "03",
        "seatLabel": "08",
        "display": "看台D108 03排 08座"
    },
    {
        "id": "D108-03-09",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 9,
        "rowLabel": "03",
        "seatLabel": "09",
        "display": "看台D108 03排 09座"
    },
    {
        "id": "D108-03-10",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 10,
        "rowLabel": "03",
        "seatLabel": "10",
        "display": "看台D108 03排 10座"
    },
    {
        "id": "D108-03-11",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 11,
        "rowLabel": "03",
        "seatLabel": "11",
        "display": "看台D108 03排 11座"
    },
    {
        "id": "D108-03-12",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 12,
        "rowLabel": "03",
        "seatLabel": "12",
        "display": "看台D108 03排 12座"
    },
    {
        "id": "D108-03-13",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 13,
        "rowLabel": "03",
        "seatLabel": "13",
        "display": "看台D108 03排 13座"
    },
    {
        "id": "D108-03-14",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 14,
        "rowLabel": "03",
        "seatLabel": "14",
        "display": "看台D108 03排 14座"
    },
    {
        "id": "D108-03-15",
        "areaType": "看台",
        "block": "D108",
        "row": 3,
        "seat": 15,
        "rowLabel": "03",
        "seatLabel": "15",
        "display": "看台D108 03排 15座"
    },
    {
        "id": "D108-04-01",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 1,
        "rowLabel": "04",
        "seatLabel": "01",
        "display": "看台D108 04排 01座"
    },
    {
        "id": "D108-04-02",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 2,
        "rowLabel": "04",
        "seatLabel": "02",
        "display": "看台D108 04排 02座"
    },
    {
        "id": "D108-04-03",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 3,
        "rowLabel": "04",
        "seatLabel": "03",
        "display": "看台D108 04排 03座"
    },
    {
        "id": "D108-04-04",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 4,
        "rowLabel": "04",
        "seatLabel": "04",
        "display": "看台D108 04排 04座"
    },
    {
        "id": "D108-04-05",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 5,
        "rowLabel": "04",
        "seatLabel": "05",
        "display": "看台D108 04排 05座"
    },
    {
        "id": "D108-04-06",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 6,
        "rowLabel": "04",
        "seatLabel": "06",
        "display": "看台D108 04排 06座"
    },
    {
        "id": "D108-04-07",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 7,
        "rowLabel": "04",
        "seatLabel": "07",
        "display": "看台D108 04排 07座"
    },
    {
        "id": "D108-04-08",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 8,
        "rowLabel": "04",
        "seatLabel": "08",
        "display": "看台D108 04排 08座"
    },
    {
        "id": "D108-04-09",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 9,
        "rowLabel": "04",
        "seatLabel": "09",
        "display": "看台D108 04排 09座"
    },
    {
        "id": "D108-04-10",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 10,
        "rowLabel": "04",
        "seatLabel": "10",
        "display": "看台D108 04排 10座"
    },
    {
        "id": "D108-04-11",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 11,
        "rowLabel": "04",
        "seatLabel": "11",
        "display": "看台D108 04排 11座"
    },
    {
        "id": "D108-04-12",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 12,
        "rowLabel": "04",
        "seatLabel": "12",
        "display": "看台D108 04排 12座"
    },
    {
        "id": "D108-04-13",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 13,
        "rowLabel": "04",
        "seatLabel": "13",
        "display": "看台D108 04排 13座"
    },
    {
        "id": "D108-04-14",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 14,
        "rowLabel": "04",
        "seatLabel": "14",
        "display": "看台D108 04排 14座"
    },
    {
        "id": "D108-04-15",
        "areaType": "看台",
        "block": "D108",
        "row": 4,
        "seat": 15,
        "rowLabel": "04",
        "seatLabel": "15",
        "display": "看台D108 04排 15座"
    },
    {
        "id": "D108-05-01",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 1,
        "rowLabel": "05",
        "seatLabel": "01",
        "display": "看台D108 05排 01座"
    },
    {
        "id": "D108-05-02",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 2,
        "rowLabel": "05",
        "seatLabel": "02",
        "display": "看台D108 05排 02座"
    },
    {
        "id": "D108-05-03",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 3,
        "rowLabel": "05",
        "seatLabel": "03",
        "display": "看台D108 05排 03座"
    },
    {
        "id": "D108-05-04",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 4,
        "rowLabel": "05",
        "seatLabel": "04",
        "display": "看台D108 05排 04座"
    },
    {
        "id": "D108-05-05",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 5,
        "rowLabel": "05",
        "seatLabel": "05",
        "display": "看台D108 05排 05座"
    },
    {
        "id": "D108-05-06",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 6,
        "rowLabel": "05",
        "seatLabel": "06",
        "display": "看台D108 05排 06座"
    },
    {
        "id": "D108-05-07",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 7,
        "rowLabel": "05",
        "seatLabel": "07",
        "display": "看台D108 05排 07座"
    },
    {
        "id": "D108-05-08",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 8,
        "rowLabel": "05",
        "seatLabel": "08",
        "display": "看台D108 05排 08座"
    },
    {
        "id": "D108-05-09",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 9,
        "rowLabel": "05",
        "seatLabel": "09",
        "display": "看台D108 05排 09座"
    },
    {
        "id": "D108-05-10",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 10,
        "rowLabel": "05",
        "seatLabel": "10",
        "display": "看台D108 05排 10座"
    },
    {
        "id": "D108-05-11",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 11,
        "rowLabel": "05",
        "seatLabel": "11",
        "display": "看台D108 05排 11座"
    },
    {
        "id": "D108-05-12",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 12,
        "rowLabel": "05",
        "seatLabel": "12",
        "display": "看台D108 05排 12座"
    },
    {
        "id": "D108-05-13",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 13,
        "rowLabel": "05",
        "seatLabel": "13",
        "display": "看台D108 05排 13座"
    },
    {
        "id": "D108-05-14",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 14,
        "rowLabel": "05",
        "seatLabel": "14",
        "display": "看台D108 05排 14座"
    },
    {
        "id": "D108-05-15",
        "areaType": "看台",
        "block": "D108",
        "row": 5,
        "seat": 15,
        "rowLabel": "05",
        "seatLabel": "15",
        "display": "看台D108 05排 15座"
    },
    {
        "id": "D108-06-01",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 1,
        "rowLabel": "06",
        "seatLabel": "01",
        "display": "看台D108 06排 01座"
    },
    {
        "id": "D108-06-02",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 2,
        "rowLabel": "06",
        "seatLabel": "02",
        "display": "看台D108 06排 02座"
    },
    {
        "id": "D108-06-03",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 3,
        "rowLabel": "06",
        "seatLabel": "03",
        "display": "看台D108 06排 03座"
    },
    {
        "id": "D108-06-04",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 4,
        "rowLabel": "06",
        "seatLabel": "04",
        "display": "看台D108 06排 04座"
    },
    {
        "id": "D108-06-05",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 5,
        "rowLabel": "06",
        "seatLabel": "05",
        "display": "看台D108 06排 05座"
    },
    {
        "id": "D108-06-06",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 6,
        "rowLabel": "06",
        "seatLabel": "06",
        "display": "看台D108 06排 06座"
    },
    {
        "id": "D108-06-07",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 7,
        "rowLabel": "06",
        "seatLabel": "07",
        "display": "看台D108 06排 07座"
    },
    {
        "id": "D108-06-08",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 8,
        "rowLabel": "06",
        "seatLabel": "08",
        "display": "看台D108 06排 08座"
    },
    {
        "id": "D108-06-09",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 9,
        "rowLabel": "06",
        "seatLabel": "09",
        "display": "看台D108 06排 09座"
    },
    {
        "id": "D108-06-10",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 10,
        "rowLabel": "06",
        "seatLabel": "10",
        "display": "看台D108 06排 10座"
    },
    {
        "id": "D108-06-11",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 11,
        "rowLabel": "06",
        "seatLabel": "11",
        "display": "看台D108 06排 11座"
    },
    {
        "id": "D108-06-12",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 12,
        "rowLabel": "06",
        "seatLabel": "12",
        "display": "看台D108 06排 12座"
    },
    {
        "id": "D108-06-13",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 13,
        "rowLabel": "06",
        "seatLabel": "13",
        "display": "看台D108 06排 13座"
    },
    {
        "id": "D108-06-14",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 14,
        "rowLabel": "06",
        "seatLabel": "14",
        "display": "看台D108 06排 14座"
    },
    {
        "id": "D108-06-15",
        "areaType": "看台",
        "block": "D108",
        "row": 6,
        "seat": 15,
        "rowLabel": "06",
        "seatLabel": "15",
        "display": "看台D108 06排 15座"
    },
    {
        "id": "D108-07-01",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 1,
        "rowLabel": "07",
        "seatLabel": "01",
        "display": "看台D108 07排 01座"
    },
    {
        "id": "D108-07-02",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 2,
        "rowLabel": "07",
        "seatLabel": "02",
        "display": "看台D108 07排 02座"
    },
    {
        "id": "D108-07-03",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 3,
        "rowLabel": "07",
        "seatLabel": "03",
        "display": "看台D108 07排 03座"
    },
    {
        "id": "D108-07-04",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 4,
        "rowLabel": "07",
        "seatLabel": "04",
        "display": "看台D108 07排 04座"
    },
    {
        "id": "D108-07-05",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 5,
        "rowLabel": "07",
        "seatLabel": "05",
        "display": "看台D108 07排 05座"
    },
    {
        "id": "D108-07-06",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 6,
        "rowLabel": "07",
        "seatLabel": "06",
        "display": "看台D108 07排 06座"
    },
    {
        "id": "D108-07-07",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 7,
        "rowLabel": "07",
        "seatLabel": "07",
        "display": "看台D108 07排 07座"
    },
    {
        "id": "D108-07-08",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 8,
        "rowLabel": "07",
        "seatLabel": "08",
        "display": "看台D108 07排 08座"
    },
    {
        "id": "D108-07-09",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 9,
        "rowLabel": "07",
        "seatLabel": "09",
        "display": "看台D108 07排 09座"
    },
    {
        "id": "D108-07-10",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 10,
        "rowLabel": "07",
        "seatLabel": "10",
        "display": "看台D108 07排 10座"
    },
    {
        "id": "D108-07-11",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 11,
        "rowLabel": "07",
        "seatLabel": "11",
        "display": "看台D108 07排 11座"
    },
    {
        "id": "D108-07-12",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 12,
        "rowLabel": "07",
        "seatLabel": "12",
        "display": "看台D108 07排 12座"
    },
    {
        "id": "D108-07-13",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 13,
        "rowLabel": "07",
        "seatLabel": "13",
        "display": "看台D108 07排 13座"
    },
    {
        "id": "D108-07-14",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 14,
        "rowLabel": "07",
        "seatLabel": "14",
        "display": "看台D108 07排 14座"
    },
    {
        "id": "D108-07-15",
        "areaType": "看台",
        "block": "D108",
        "row": 7,
        "seat": 15,
        "rowLabel": "07",
        "seatLabel": "15",
        "display": "看台D108 07排 15座"
    },
    {
        "id": "D108-08-01",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 1,
        "rowLabel": "08",
        "seatLabel": "01",
        "display": "看台D108 08排 01座"
    },
    {
        "id": "D108-08-02",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 2,
        "rowLabel": "08",
        "seatLabel": "02",
        "display": "看台D108 08排 02座"
    },
    {
        "id": "D108-08-03",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 3,
        "rowLabel": "08",
        "seatLabel": "03",
        "display": "看台D108 08排 03座"
    },
    {
        "id": "D108-08-04",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 4,
        "rowLabel": "08",
        "seatLabel": "04",
        "display": "看台D108 08排 04座"
    },
    {
        "id": "D108-08-05",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 5,
        "rowLabel": "08",
        "seatLabel": "05",
        "display": "看台D108 08排 05座"
    },
    {
        "id": "D108-08-06",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 6,
        "rowLabel": "08",
        "seatLabel": "06",
        "display": "看台D108 08排 06座"
    },
    {
        "id": "D108-08-07",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 7,
        "rowLabel": "08",
        "seatLabel": "07",
        "display": "看台D108 08排 07座"
    },
    {
        "id": "D108-08-08",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 8,
        "rowLabel": "08",
        "seatLabel": "08",
        "display": "看台D108 08排 08座"
    },
    {
        "id": "D108-08-09",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 9,
        "rowLabel": "08",
        "seatLabel": "09",
        "display": "看台D108 08排 09座"
    },
    {
        "id": "D108-08-10",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 10,
        "rowLabel": "08",
        "seatLabel": "10",
        "display": "看台D108 08排 10座"
    },
    {
        "id": "D108-08-11",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 11,
        "rowLabel": "08",
        "seatLabel": "11",
        "display": "看台D108 08排 11座"
    },
    {
        "id": "D108-08-12",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 12,
        "rowLabel": "08",
        "seatLabel": "12",
        "display": "看台D108 08排 12座"
    },
    {
        "id": "D108-08-13",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 13,
        "rowLabel": "08",
        "seatLabel": "13",
        "display": "看台D108 08排 13座"
    },
    {
        "id": "D108-08-14",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 14,
        "rowLabel": "08",
        "seatLabel": "14",
        "display": "看台D108 08排 14座"
    },
    {
        "id": "D108-08-15",
        "areaType": "看台",
        "block": "D108",
        "row": 8,
        "seat": 15,
        "rowLabel": "08",
        "seatLabel": "15",
        "display": "看台D108 08排 15座"
    },
    {
        "id": "D108-09-01",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 1,
        "rowLabel": "09",
        "seatLabel": "01",
        "display": "看台D108 09排 01座"
    },
    {
        "id": "D108-09-02",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 2,
        "rowLabel": "09",
        "seatLabel": "02",
        "display": "看台D108 09排 02座"
    },
    {
        "id": "D108-09-03",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 3,
        "rowLabel": "09",
        "seatLabel": "03",
        "display": "看台D108 09排 03座"
    },
    {
        "id": "D108-09-04",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 4,
        "rowLabel": "09",
        "seatLabel": "04",
        "display": "看台D108 09排 04座"
    },
    {
        "id": "D108-09-05",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 5,
        "rowLabel": "09",
        "seatLabel": "05",
        "display": "看台D108 09排 05座"
    },
    {
        "id": "D108-09-06",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 6,
        "rowLabel": "09",
        "seatLabel": "06",
        "display": "看台D108 09排 06座"
    },
    {
        "id": "D108-09-07",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 7,
        "rowLabel": "09",
        "seatLabel": "07",
        "display": "看台D108 09排 07座"
    },
    {
        "id": "D108-09-08",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 8,
        "rowLabel": "09",
        "seatLabel": "08",
        "display": "看台D108 09排 08座"
    },
    {
        "id": "D108-09-09",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 9,
        "rowLabel": "09",
        "seatLabel": "09",
        "display": "看台D108 09排 09座"
    },
    {
        "id": "D108-09-10",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 10,
        "rowLabel": "09",
        "seatLabel": "10",
        "display": "看台D108 09排 10座"
    },
    {
        "id": "D108-09-11",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 11,
        "rowLabel": "09",
        "seatLabel": "11",
        "display": "看台D108 09排 11座"
    },
    {
        "id": "D108-09-12",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 12,
        "rowLabel": "09",
        "seatLabel": "12",
        "display": "看台D108 09排 12座"
    },
    {
        "id": "D108-09-13",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 13,
        "rowLabel": "09",
        "seatLabel": "13",
        "display": "看台D108 09排 13座"
    },
    {
        "id": "D108-09-14",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 14,
        "rowLabel": "09",
        "seatLabel": "14",
        "display": "看台D108 09排 14座"
    },
    {
        "id": "D108-09-15",
        "areaType": "看台",
        "block": "D108",
        "row": 9,
        "seat": 15,
        "rowLabel": "09",
        "seatLabel": "15",
        "display": "看台D108 09排 15座"
    },
    {
        "id": "D108-10-01",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 1,
        "rowLabel": "10",
        "seatLabel": "01",
        "display": "看台D108 10排 01座"
    },
    {
        "id": "D108-10-02",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 2,
        "rowLabel": "10",
        "seatLabel": "02",
        "display": "看台D108 10排 02座"
    },
    {
        "id": "D108-10-03",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 3,
        "rowLabel": "10",
        "seatLabel": "03",
        "display": "看台D108 10排 03座"
    },
    {
        "id": "D108-10-04",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 4,
        "rowLabel": "10",
        "seatLabel": "04",
        "display": "看台D108 10排 04座"
    },
    {
        "id": "D108-10-05",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 5,
        "rowLabel": "10",
        "seatLabel": "05",
        "display": "看台D108 10排 05座"
    },
    {
        "id": "D108-10-06",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 6,
        "rowLabel": "10",
        "seatLabel": "06",
        "display": "看台D108 10排 06座"
    },
    {
        "id": "D108-10-07",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 7,
        "rowLabel": "10",
        "seatLabel": "07",
        "display": "看台D108 10排 07座"
    },
    {
        "id": "D108-10-08",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 8,
        "rowLabel": "10",
        "seatLabel": "08",
        "display": "看台D108 10排 08座"
    },
    {
        "id": "D108-10-09",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 9,
        "rowLabel": "10",
        "seatLabel": "09",
        "display": "看台D108 10排 09座"
    },
    {
        "id": "D108-10-10",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 10,
        "rowLabel": "10",
        "seatLabel": "10",
        "display": "看台D108 10排 10座"
    },
    {
        "id": "D108-10-11",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 11,
        "rowLabel": "10",
        "seatLabel": "11",
        "display": "看台D108 10排 11座"
    },
    {
        "id": "D108-10-12",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 12,
        "rowLabel": "10",
        "seatLabel": "12",
        "display": "看台D108 10排 12座"
    },
    {
        "id": "D108-10-13",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 13,
        "rowLabel": "10",
        "seatLabel": "13",
        "display": "看台D108 10排 13座"
    },
    {
        "id": "D108-10-14",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 14,
        "rowLabel": "10",
        "seatLabel": "14",
        "display": "看台D108 10排 14座"
    },
    {
        "id": "D108-10-15",
        "areaType": "看台",
        "block": "D108",
        "row": 10,
        "seat": 15,
        "rowLabel": "10",
        "seatLabel": "15",
        "display": "看台D108 10排 15座"
    }
]
export {
    seatsData
}